(function () {
    'use strict';

    var serviceId = 'datacontext';
    angular.module('app').factory(serviceId, ['common', '_', '$location', datacontext]);

    function datacontext(common, _, $location) {
        var $q = common.$q;
        var $http = common.$http;
        var urlAPI = '/api';

        //var basePath = 'http://localhost:60000';
        //var basePath = 'http://192.168.0.65:92/edup'; 
        //var basePath = 'http://51.89.8.72'; //online debug
        //LASTUPDATE: verificare questo link
        var basePath = 'https://www.siverapp.com'; //online        
        var _pageSize = 30;

        //Array condivisi su app - caricati su avvio app
        // Utilizzati esclusivamente su tag SELECT
        var _arrClassi = [];
        var _arrProvincie = [];
        var _arrRisorse = [];       //solo dati non variabili (Id, Cognome, Nome, CodiceFiscale, ProfiloId, Profilo)

        var service = {
            //Metodi pe caricamento dati condivisi su app
            //Array compilati solo a prima chiamata
            account_get: account_get,
            account_changePassword: account_changePassword,

            arrClassi: arrClassi,
            arrProvincie: arrProvincie,
            arrRisorse: arrRisorse,

            //-- AVVISI
            avviso_getAll: avviso_getAll,
            avviso_getAllDocente: avviso_getAllDocente,
            avviso_getAllStakeholder: avviso_getAllStakeholder,
            avviso_getAllStudente: avviso_getAllStudente,
            avviso_get: avviso_get,
            avviso_add: avviso_add,
            avviso_update: avviso_update,
            avviso_delete: avviso_delete,

            //-- AGGIORNAMENTI
            aggiornamento_getAll: aggiornamento_getAll,
            aggiornamento_countAll: aggiornamento_countAll,
            aggiornamento_getByDocente: aggiornamento_getByDocente,
            aggiornamento_getByStudente: aggiornamento_getByStudente,
            aggiornamento_get: aggiornamento_get,
            aggiornamento_add: aggiornamento_add,
            aggiornamento_update: aggiornamento_update,
            aggiornamento_delete: aggiornamento_delete,

            //-- ARGOMENTI
            argomenti_getAll: argomenti_getAll,

            //-- CLASSE - Nuovi Metodi
            classe_getAllList: classe_getAllList,
            classe_getAll: classe_getAll,
            classe_getAllByStudenteId: classe_getAllByStudenteId,
            classe_countAll: classe_countAll,
            classe_get: classe_get,
            classe_add: classe_add,
            classe_update: classe_update,
            classe_delete: classe_delete,
            classe_studentiImportList: classe_studentiImportList,
            classe_verificaCodice: classe_verificaCodice,
            classe_studenteRegistra: classe_studenteRegistra,
            classe_getAllByDocenteId: classe_getAllByDocenteId,
            classe_getAllPerCreate: classe_getAllPerCreate,
            classe_seleziona: classe_seleziona,

            //-- SOCIETA
            societa_getAll: societa_getAll,
            societa_countAll: societa_countAll,
            societa_getAllList: societa_getAllList,
            societa_get: societa_get,
            societa_add: societa_add,
            societa_update: societa_update,
            societa_gest_get: societa_gest_get,
            societa_gest_put: societa_gest_put,
            societa_uploadLogo: societa_uploadLogo,
            societa_inviaInvito: societa_inviaInvito,
            societa_getAllByFilter: societa_getAllByFilter,

            //-- COMMERCIALE
            commerciale_getAllList: commerciale_getAllList,
            commerciale_getAll: commerciale_getAll,
            commerciale_countAll: commerciale_countAll,
            commerciale_getByUsername: commerciale_getByUsername,
            commerciale_getByUsername2: commerciale_getByUsername2,
            commerciale_get: commerciale_get,
            commerciale_add: commerciale_add,
            commerciale_update: commerciale_update,
            commerciale_delete: commerciale_delete,

            //-- CONTRATTO
            contratto_getAllList: contratto_getAllList,
            contratto_getAll: contratto_getAll,
            contratto_countAll: contratto_countAll,
            contratto_get: contratto_get,
            contratto_add: contratto_add,
            contratto_update: contratto_update,
            contratto_delete: contratto_delete,

            //-- CONTRATTO ATTACH
            contrattoAttach_getAllList: contrattoAttach_getAllList,
            contrattoAttach_getAll: contrattoAttach_getAll,
            contrattoAttach_countAll: contrattoAttach_countAll,
            contrattoAttach_get: contrattoAttach_get,
            contrattoAttach_update: contrattoAttach_update,
            contrattoAttach_delete: contrattoAttach_delete,
            contrattoAttach_fileUpload: contrattoAttach_fileUpload,
            contrattoAttach_fileDownload: contrattoAttach_fileDownload,

            //-- CONTRATTO INCONTRO
            contrattoIncontro_getAllList: contrattoIncontro_getAllList,
            contrattoIncontro_getAll: contrattoIncontro_getAll,
            contrattoIncontro_countAll: contrattoIncontro_countAll,
            contrattoIncontro_add: contrattoIncontro_add,
            contrattoIncontro_get: contrattoIncontro_get,
            contrattoIncontro_update: contrattoIncontro_update,
            contrattoIncontro_delete: contrattoIncontro_delete,

            //-- CONTRATTO PROVVIGIONE
            contrattoProvvigione_getAllList: contrattoProvvigione_getAllList,
            contrattoProvvigione_getAll: contrattoProvvigione_getAll,
            contrattoProvvigione_countAll: contrattoProvvigione_countAll,
            contrattoProvvigione_add: contrattoProvvigione_add,
            contrattoProvvigione_get: contrattoProvvigione_get,
            contrattoProvvigione_update: contrattoProvvigione_update,
            contrattoProvvigione_delete: contrattoProvvigione_delete,

            //-- ORDINE
            //ordine_getAllList: ordine_getAllList,
            ordine_getAll: ordine_getAll,
            ordine_countAll: ordine_countAll,
            //ordine_getAllNonPagati:ordine_getAllNonPagati,
            ordine_getAllByDocente: ordine_getAllByDocente,
            ordine_countAllByDocente: ordine_countAllByDocente,
            ordine_calcola: ordine_calcola,
            ordine_calcolaCommerciale: ordine_calcolaCommerciale,
            ordine_postBonifico: ordine_postBonifico,
            ordine_postContanti: ordine_postContanti,
            ordine_get: ordine_get,
            ordine_setPagamentoId: ordine_setPagamentoId,
            ordine_setIncassato: ordine_setIncassato,
            ordine_delete: ordine_delete,
            ordine_sendMail: ordine_sendMail,

            //-- RIEPILOGO ORDINE
            riepilogoOrdine_getAllList: riepilogoOrdine_getAllList,
            riepilogoOrdine_getAll: riepilogoOrdine_getAll,
            riepilogoOrdine_countAll: riepilogoOrdine_countAll,
            riepilogoOrdine_getAllByPagamentoId: riepilogoOrdine_getAllByPagamentoId,

            //-- PAGAMENTO
            pagamento_getAllList: pagamento_getAllList,
            pagamento_getAll: pagamento_getAll,
            pagamento_countAll: pagamento_countAll,
            pagamento_add: pagamento_add,
            pagamento_get: pagamento_get,
            pagamento_update: pagamento_update,
            pagamento_delete: pagamento_delete,

            //-- LISTINO
            listino_getAllList: listino_getAllList,
            listino_getAll: listino_getAll,
            listino_countAll: listino_countAll,
            listino_get: listino_get,
            listino_add: listino_add,
            listino_update: listino_update,
            listino_delete: listino_delete,

            //-- CONTO CORRENTE
            contoCorrente_getAllList: contoCorrente_getAllList,
            contoCorrente_getAll: contoCorrente_getAll,
            contoCorrente_countAll: contoCorrente_countAll,
            contoCorrente_get: contoCorrente_get,
            contoCorrente_add: contoCorrente_add,
            contoCorrente_update: contoCorrente_update,
            contoCorrente_delete: contoCorrente_delete,

            //-- TAG
            tag_getAllList: tag_getAllList,
            tag_getAll: tag_getAll,
            tag_countAll: tag_countAll,
            tag_get: tag_get,
            tag_add: tag_add,
            tag_update: tag_update,
            tag_delete: tag_delete,

            //-- TAG FAKE
            tagFake_getAllList: tagFake_getAllList,
            tagFake_getAll: tagFake_getAll,
            tagFake_countAll: tagFake_countAll,
            tagFake_get: tagFake_get,
            tagFake_add: tagFake_add,
            tagFake_update: tagFake_update,
            tagFake_delete: tagFake_delete,

            //-- INCARICO
            incarico_getAll: incarico_getAll,
            incarico_countAll: incarico_countAll,
            incarico_getAllByClasse: incarico_getAllByClasse,
            incarico_getAllByRisorsa: incarico_getAllByRisorsa,
            incarico_getAllByDocente: incarico_getAllByDocente,
            incarico_add: incarico_add,
            incarico_update: incarico_update,
            incarico_delete: incarico_delete,

            //-- ISTAT
            istat_comune_getAllList: istat_comune_getAllList,
            istat_comune_get: istat_comune_get,

            //-- TIPO INCONTRO          
            tipoIncontro_getAllList: tipoIncontro_getAllList,
            tipoIncontro_get: tipoIncontro_get,

            //-- TIPO TEST          
            tipoTest_getAllList: tipoTest_getAllList,
            tipoTest_get: tipoTest_get,

            //-- TIPO SOCIETA          
            tipoSocieta_getAllList: tipoSocieta_getAllList,
            tipoSocieta_get: tipoSocieta_get,

            //-- INDIRIZZO
            indirizzo_getAllList: indirizzo_getAllList,

            //--INDIRIZZOAGGIUNTIVO 
            indirizzoAggiuntivo_getAllByFilter: indirizzoAggiuntivo_getAllByFilter,

            //-- ISTITUTO          
            istituto_getAllList: istituto_getAllList,
            istituto_getAll: istituto_getAll,
            istituto_countAll: istituto_countAll,
            istituto_get: istituto_get,
            istituto_add: istituto_add,
            istituto_update: istituto_update,
            istituto_delete: istituto_delete,

            //-- MATERIA
            materia_getAllList: materia_getAllList,
            materia_getAllListComplete: materia_getAllListComplete,
            materia_getAllMaterieDocentiList: materia_getAllMaterieDocentiList,
            materia_getAll: materia_getAll,
            materia_getAllListByDocente: materia_getAllListByDocente,
            materia_getAllByDocente: materia_getAllByDocente,
            materia_countAll: materia_countAll,
            materia_get: materia_get,
            materia_add: materia_add,
            materia_update: materia_update,
            materia_delete: materia_delete,
            materia_docenteImportList: materia_docenteImportList,
            materia_docenteDelete: materia_docenteDelete,
            materia_setPredefinita: materia_setPredefinita,
            materia_getAllByDocenteId: materia_getAllByDocenteId,

            //-- VIDEOGUIDA
            //-- TUTORIAL
            videoGuida_getAll: videoGuida_getAll,
            videoGuida_countAll: videoGuida_countAll,
            videoGuida_get: videoGuida_get,
            videoGuida_add: videoGuida_add,
            videoGuida_update: videoGuida_update,
            videoGuida_delete: videoGuida_delete,

            //SCHEDA COMPETENZE
            schedaCompetenze_getAll: schedaCompetenze_getAll,
            schedaCompetenze_countAll: schedaCompetenze_countAll,
            schedaCompetenze_get: schedaCompetenze_get,
            schedaCompetenze_update: schedaCompetenze_update,
            schedaCompetenze_delete: schedaCompetenze_delete,
            schedaCompetenze_add: schedaCompetenze_add,
            schedaCompetenze_attiva: schedaCompetenze_attiva,
            schedaCompetenze_annulla: schedaCompetenze_annulla,


            //ASSE CULTURALE
            asseCulturale_get: asseCulturale_get,
            asse_getAllByMateriaId: asse_getAllByMateriaId,

            //SCHEDA COMPETENZE TEST
            schedaCompetenzeTest_getAll: schedaCompetenzeTest_getAll,
            schedaCompetenzeTest_add: schedaCompetenzeTest_add,            
            schedaCompetenzeTest_update: schedaCompetenzeTest_update, 
            schedaCompetenzeTest_creaDidattica: schedaCompetenzeTest_creaDidattica,
            schedaCompetenzeTest_creaDidatticaAltriTest: schedaCompetenzeTest_creaDidatticaAltriTest,

            //SCHEDA COMPETENZE SESSION
            schedaCompetenzeSession_getAll: schedaCompetenzeSession_getAll,
            schedaCompetenzeSession_add: schedaCompetenzeSession_add,
            schedaCompetenzeSession_update: schedaCompetenzeSession_update,
            schedaCompetenzeSession_get: schedaCompetenzeSession_get,            

            //SCHEDA COMPETENZE DOC
            schedaCompetenzeDoc_countAll: schedaCompetenzeDoc_countAll,
            schedaCompetenzeDoc_getAll: schedaCompetenzeDoc_getAll,
            schedaCompetenzeDoc_getAllByDocId: schedaCompetenzeDoc_getAllByDocId,
            schedaCompetenzeDoc_add: schedaCompetenzeDoc_add,
            schedaCompetenzeDoc_update: schedaCompetenzeDoc_update,
            schedaCompetenzeDoc_delete: schedaCompetenzeDoc_delete,

            //-- RISORSA
            asl_risorsa_getAll: asl_risorsa_getAll,
            asl_risorsa_countAll: asl_risorsa_countAll,
            risorsa_getAllList: risorsa_getAllList,
            risorsa_getByUsernameList: risorsa_getByUsernameList,
            risorsa_getAll: risorsa_getAll,
            risorsa_countAll: risorsa_countAll,
            risorsa_getAllByClasse: risorsa_getAllByClasse,
            risorsa_getByUsername: risorsa_getByUsername,
            risorsa_getByUsername2: risorsa_getByUsername2,
            risorsa_getByCodiceFiscale: risorsa_getByCodiceFiscale,
            risorsa_getDataFineLicenza: risorsa_getDataFineLicenza,
            risorsa_getCodiceLicenza: risorsa_getCodiceLicenza,
            risorsa_get: risorsa_get,
            risorsa_add: risorsa_add,
            risorsa_update: risorsa_update,            
            risorsa_delete: risorsa_delete,
            risorsa_getForBuy: risorsa_getForBuy,
            risorsa_getAllListByStudente: risorsa_getAllListByStudente,
            risorsa_getAllByStudente: risorsa_getAllByStudente,
            risorsa_setIcona: risorsa_setIcona,

            //-- STAKEHOLDER
            //stakeholder_getByUsernameList: stakeholder_getByUsernameList,
            asl_stakeholder_getAll: asl_stakeholder_getAll,
            asl_stakeholder_countAll: asl_stakeholder_countAll,
            stakeholder_getAll: stakeholder_getAll,
            stakeholder_countAll: stakeholder_countAll,
            //stakeholder_getAllByClasse: stakeholder_getAllByClasse,
            stakeholder_getByUsername: stakeholder_getByUsername,
            stakeholder_getByUsername2: stakeholder_getByUsername2,
            stakeholder_getByCodiceFiscale: stakeholder_getByCodiceFiscale,
            //stakeholder_getDataFineLicenza: stakeholder_getDataFineLicenza,
            //stakeholder_getCodiceLicenza: stakeholder_getCodiceLicenza,
            stakeholder_get: stakeholder_get,
            stakeholder_add: stakeholder_add,
            stakeholder_update: stakeholder_update,
            stakeholder_delete: stakeholder_delete,
            stakeholder_addAccount: stakeholder_addAccount,
            stakeholder_getListAccount: stakeholder_getListAccount,
            asl_stakeholder_getListAccount: asl_stakeholder_getListAccount,
            //stakeholder_getForBuy: stakeholder_getForBuy,
            //stakeholder_getAllListByStudente: stakeholder_getAllListByStudente,
            //stakeholder_getAllByStudente: stakeholder_getAllByStudente,
            //stakeholder_setIcona: stakeholder_setIcona,

            //-- STUDENTE
            asl_studente_getAll: asl_studente_getAll,
            asl_studente_countAll: asl_studente_countAll,
            studente_getAllList: studente_getAllList,
            studente_getAllListByClasse: studente_getAllListByClasse,
            studente_getAll: studente_getAll,
            studente_countAll: studente_countAll,
            studente_getAllByUsername: studente_getAllByUsername,
            studente_countAllByUsername: studente_countAllByUsername,
            studente_getAllByClasse: studente_getAllByClasse,
            studente_getAllByClasse_Data: studente_getAllByClasse_Data,
            studente_getAllNotInByClasse: studente_getAllNotInByClasse,
            studente_get: studente_get,
            studente_getByUsername: studente_getByUsername,
            studente_add: studente_add,
            studente_update: studente_update,            
            studente_delete: studente_delete,
            studente_classiImportList: studente_classiImportList,
            studente_classeDelete: studente_classeDelete,
            //Questo metodo serve nella schermata dettaglio classe
            //Calcola le statistiche degli allievi relativi alla classe passata (minuti svolti, minuti previsti)
            studente_getAllByClasseId: studente_getAllByClasseId,
            studente_getAllBySocieta: studente_getAllBySocieta,
            studente_getAllSenzaClasse: studente_getAllSenzaClasse,
            studente_attivaPdp: studente_attivaPdp,
            studente_annullaPdp: studente_annullaPdp,

            //SUPER
            super_studente_getAllByUsername: super_studente_getAllByUsername,
            super_studente_countAllByUsername: super_studente_countAllByUsername,
            super_studente_getAllByClasseId: super_studente_getAllByClasseId,
            super_studente_getAllBySocieta: super_studente_getAllBySocieta,
            super_classe_getAllList: super_classe_getAllList,
            super_classe_getAll: super_classe_getAll,
            super_classe_countAll: super_classe_countAll,
            super_risorsa_getAll: super_risorsa_getAll,
            super_risorsa_getAllList: super_risorsa_getAllList,
            super_risorsa_countAll: super_risorsa_countAll,
            super_materia_getAllByDocente: super_materia_getAllByDocente,
            super_materia_countByDocente: super_materia_countByDocente,
            super_materia_docenteDelete: super_materia_docenteDelete,
            super_materia_docenteImportList: super_materia_docenteImportList,
            super_addAccountStak: super_addAccountStak,
            super_editAccountStak: super_editAccountStak,
            super_eliminazioneMigrazioneUtenteStak: super_eliminazioneMigrazioneUtenteStak,
            super_accountStak_getAllByFilter: super_accountStak_getAllByFilter,
            
            //-- USER
            user_getAll: user_getAll,
            user_getAllUsernames: user_getAllUsernames,
            user_countAll: user_countAll,
            user_get: user_get,
            user_getByUsername: user_getByUsername,
            user_add: user_add,
            user_update: user_update,
            user_activate: user_activate,
            user_deactivate: user_deactivate,
            user_resetPassword: user_resetPassword,
            user_invioCredenziali: user_invioCredenziali,
            user_delete: user_delete,
            user_suggestUserame: user_suggestUserame,
            user_suggestPassword: user_suggestPassword,       
            user_setPassword: user_setPassword,

            //-- ROLE
            role_getAllList: role_getAllList,
            role_getAll: role_getAll,
            role_get: role_get,

            //-- ROLE USER
            userRole_getAll: userRole_getAll,
            userRole_add: userRole_add,
            userRole_delete: userRole_delete,

            //-- AUTHORIZATION
            /*authorization_get: authorization_get,
            authorization_getById: authorization_getById,
            authorization_getAllByUser: authorization_getAllByUser,
            authorization_getAllByFilter: authorization_getAllByFilter,
            authorization_countAllByFilter: authorization_countAllByFilter,
            authorization_add: authorization_add,
            authorization_update: authorization_update,
            authorization_delete: authorization_delete,
            */
            //Carta Docente
            cartaDocente_check: cartaDocente_check,
            cartaDocente_confirmLicenza: cartaDocente_confirmLicenza,

            //Fattura Pa            
            fatturaPa_countByFilter: fatturaPa_countByFilter,
            fatturaPa_getAllByFilter: fatturaPa_getAllByFilter,
            fatturaPa_get: fatturaPa_get,
            fatturaPa_add: fatturaPa_add,
            fatturaPa_update: fatturaPa_update,
            fatturaPa_delete: fatturaPa_delete,
            fatturaPa_getBuoni: fatturaPa_getBuoni,
            fatturaPa_getBuoniDaFatturare: fatturaPa_getBuoniDaFatturare,

            //COMMUNITY
            community_getAmicizia: community_getAmicizia,
            community_getAllRichieste: community_getAllRichieste,
            community_getAllRichiesteRifiutate: community_getAllRichiesteRifiutate,
            community_ricercaDocenti: community_ricercaDocenti,
            community_getAllAmici: community_getAllAmici,
            community_addAmicizia: community_addAmicizia,
            community_deleteAmicizia: community_deleteAmicizia,
            community_accettaAmicizia: community_accettaAmicizia,
            community_rifiutaAmicizia: community_rifiutaAmicizia,
            community_attiva: community_attiva,
            community_annulla: community_annulla,
            community_getProfilo: community_getProfilo,

            //-- ATTACH - Nuovi Metodi
            attach_getAllList: attach_getAllList,
            attach_getAll: attach_getAll,
            attach_countAll: attach_countAll,
            attach_get: attach_get,
            attach_add: attach_add,
            attach_update: attach_update,
            attach_delete: attach_delete,
            attach_setCompleted: attach_setCompleted,
            attach_unsetCompleted: attach_unsetCompleted,

            //Estrazione documentazione dalla piattaforma
            attach_download: attach_download,
            attach_extract: attach_extract,
            upload_getURL: upload_getURL,

            //-- TATTACH          
            tAttach_getAllList: tAttach_getAllList,
            tAttach_getAllModal: tAttach_getAllModal,
            tAttach_getAll: tAttach_getAll,
            tAttach_countAll: tAttach_countAll,
            tAttach_get: tAttach_get,
            tAttach_add: tAttach_add,
            tAttach_update: tAttach_update,
            tAttach_delete: tAttach_delete,

            //-- TATTACHVISIBILITY
            tAttachVisibility_getAuth: tAttachVisibility_getAuth,
            tAttachVisibility_getAll: tAttachVisibility_getAll,
            tAttachVisibility_add: tAttachVisibility_add,
            tAttachVisibility_update: tAttachVisibility_update,
            tAttachVisibility_delete: tAttachVisibility_delete,

            //-- TATTACHFILETYPE
            tAttachFileType_getAll: tAttachFileType_getAll,
            tAttachFileType_add: tAttachFileType_add,
            tAttachFileType_update: tAttachFileType_update,
            tAttachFileType_delete: tAttachFileType_delete,

            //-- TSOURCE          
            tSource_getAllList: tSource_getAllList,
            tSource_getAll: tSource_getAll,
            tSource_get: tSource_get,
            tSource_getByCode: tSource_getByCode,


            //DASHBOARD
            dashboard_get: dashboard_get,
            dashboard_getDocente: dashboard_getDocente,
            dashboard_getStudente: dashboard_getStudente,
            dashboard_getStakeholder: dashboard_getStakeholder,
            dashboard_getAllStudenteSession: dashboard_getAllStudenteSession,
            dashboard_getStudenteAllSessions: dashboard_getStudenteAllSessions,
            dashboard_getStudenteAllDocenteSessions: dashboard_getStudenteAllDocenteSessions,            
            dashboard_getCommerciale: dashboard_getCommerciale,
            dashboard_getAdmin: dashboard_getAdmin,
            dashboard_getAllStakeholderVendite: dashboard_getAllStakeholderVendite,

            //Licenza
            licenza_getAll: licenza_getAll,

            //--testAnteprime
            testAnteprime_getAllByTest: testAnteprime_getAllByTest,

            //-- PACCHETTO
            pacchetto_getAllList: pacchetto_getAllList,
            pacchetto_countByFilter: pacchetto_countByFilter,
            pacchetto_getAllByFilter: pacchetto_getAllByFilter,
            asl_pacchetto_countByFilter: asl_pacchetto_countByFilter,
            asl_pacchetto_getAllByFilter: asl_pacchetto_getAllByFilter,
            pacchetto_get: pacchetto_get,
            pacchetto_update: pacchetto_update,
            pacchetto_delete: pacchetto_delete,
            pacchetto_add: pacchetto_add,
            pacchetto_pubblica: pacchetto_pubblica,
            pacchetto_modifica: pacchetto_modifica,

            //-- pacchettoTest
            pacchettoTest_getAllList: pacchettoTest_getAllList,
            pacchettoTest_getAllByPacchetto: pacchettoTest_getAllByPacchetto,
            pacchettoTest_countAllByPacchetto: pacchettoTest_countAllByPacchetto,
            pacchettoTest_getAllByTest: pacchettoTest_getAllByTest,
            pacchettoTest_get: pacchettoTest_get,
            pacchettoTest_update: pacchettoTest_update,
            pacchettoTest_delete: pacchettoTest_delete,
            pacchettoTest_add: pacchettoTest_add,
            pacchettoTest_importList: pacchettoTest_importList,
            pacchettoTest_addByParams: pacchettoTest_addByParams,

            //-- testPacchetti
            testPacchetti_getAllList: testPacchetti_getAllList,
            testPacchetti_getAllByTest: testPacchetti_getAllByTest,
            testPacchetti_countAllByTest: testPacchetti_countAllByTest,
            testPacchetti_getAllByPacchetto: testPacchetti_getAllByPacchetto,

            //-- categoria
            categoria_getAllByFilter: categoria_getAllByFilter,

            //Acquisto
            acquisto_countByFilter: acquisto_countByFilter,
            acquisto_getAllByFilter: acquisto_getAllByFilter,            
            acquisto_get: acquisto_get,

            /********************************************************/
            /*     EDUP                                             */
            /********************************************************/
            //-- STAK_TEST
            stak_test_countByFilter: stak_test_countByFilter,
            stak_test_getAllByFilter: stak_test_getAllByFilter,
            stak_test_get: stak_test_get,
            stak_test_update: stak_test_update,
            stak_test_delete: stak_test_delete,
            stak_test_add: stak_test_add,
            stak_test_pubblica: stak_test_pubblica,
            stak_test_modifica: stak_test_modifica,
            stak_test_reject: stak_test_reject,
            stak_test_getAllList: stak_test_getAllList,
            stak_test_ricalcolaAnteprime: stak_test_ricalcolaAnteprime,

            //-- STAK_TESTPACCHETTO
            stak_testPacchetto_getAllByFilter: stak_testPacchetto_getAllByFilter,
            stak_testNotInPacchetto_getAllByFilter: stak_testNotInPacchetto_getAllByFilter,

            //-- STAK_QUESTION
            stak_question_getAllListNotInTest: stak_question_getAllListNotInTest,
            stak_question_deleteNewFile: stak_question_deleteNewFile,
            stak_question_countByFilter: stak_question_countByFilter,
            stak_question_getAllByFilter: stak_question_getAllByFilter,
            stak_question_getAllByTest: stak_question_getAllByTest,
            stak_question_get: stak_question_get,
            stak_question_deleteFiles: stak_question_deleteFiles,
            stak_question_update: stak_question_update,
            stak_question_addToTest: stak_question_addToTest,
            stak_question_add: stak_question_add,
            stak_question_delete: stak_question_delete,
            stak_question_upload: stak_question_upload,
            stak_question_deleteFromTest: stak_question_deleteFromTest,

            //-- STAK_QUESTIONTEST
            stak_questionTest_getAllByTest: stak_questionTest_getAllByTest,     
            stak_questionTest_countAllByTest: stak_questionTest_countAllByTest,
            stak_questionTest_delete: stak_questionTest_delete,
            stak_questionTest_changeSequence: stak_questionTest_changeSequence,
            stak_questionTest_importList: stak_questionTest_importList,
            stak_questionTest_getAllList: stak_questionTest_getAllList,
            stak_questionTest_getAllByQuestion: stak_questionTest_getAllByQuestion,

            //-- STAK_CHOISE
            stak_choice_getAllByQuestion: stak_choice_getAllByQuestion,
            stak_choice_delete: stak_choice_delete,
            stak_choice_upload: stak_choice_upload,

            stak_materia_getAllList: stak_materia_getAllList,

            //-- STAK_ACCOUNT
            stak_account_get: stak_account_get,
            stak_account_getAllByFilter: stak_account_getAllByFilter,
            stak_account_countAllByFilter: stak_account_countAllByFilter,
            //stak_account_getAllForMigration: stak_account_getAllForMigration,
            stak_account_add: stak_account_add,
            stak_account_update: stak_account_update,
            stak_account_delete: stak_account_delete,
            stak_account_activate: stak_account_activate,
            stak_account_deactivate: stak_account_deactivate,
            stak_account_resetPassword: stak_account_resetPassword,
            stak_account_invioCredenziali: stak_account_invioCredenziali,
            stak_account_eliminazioneMigrazioneUtente: stak_account_eliminazioneMigrazioneUtente,

            //-- TEST
            test_getAllList: test_getAllList,
            test_getAllListExclude: test_getAllListExclude,
            test_count: test_count,
            test_countByFilter: test_countByFilter,
            test_getAllByFilter: test_getAllByFilter,
            testDocentiAllievi_countByFilter: testDocentiAllievi_countByFilter,
            testDocentiAllievi_getAllByFilter: testDocentiAllievi_getAllByFilter,
            asl_test_countAll: asl_test_countAll,
            asl_test_getAll: asl_test_getAll,
            testColleghi_getAllByFilter: testColleghi_getAllByFilter,
            testColleghi_countByFilter: testColleghi_countByFilter,
            testIstituto_getAllByFilter: testIstituto_getAllByFilter,
            testIstituto_countByFilter: testIstituto_countByFilter,
            testCommunity_getAllByFilter: testCommunity_getAllByFilter,
            testCommunity_countByFilter: testCommunity_countByFilter,
            testAllieviCondivisi_getAllByFilter: testAllieviCondivisi_getAllByFilter,
            testAllieviCondivisi_countByFilter: testAllieviCondivisi_countByFilter,
            testCondivisi_getAllByFilter: testCondivisi_getAllByFilter,
            testCondivisi_countByFilter: testCondivisi_countByFilter,
            testAcquistati_getAllByFilter: testAcquistati_getAllByFilter,
            testAcquistati_countByFilter: testAcquistati_countByFilter,
            testAcquistati_get: testAcquistati_get,
            test_get: test_get,
            test_update: test_update,
            test_delete: test_delete,
            test_add: test_add,
            //gestione workflow
            test_sendForVerify: test_sendForVerify,
            test_accept: test_accept,
            test_reject: test_reject,
            test_modify: test_modify,
            test_setCommunity: test_setCommunity,
            test_setIstitutoShare: test_setIstitutoShare,
            //-- question
            //question_getAllList: question_getAllList,
            question_getAllListInTest: question_getAllListInTest,
            question_getAllListNotInTest: question_getAllListNotInTest,
            //question_count: question_count,
            //question_countByFilter: question_countByFilter,
            //question_getAll: question_getAll,
            question_getAllByFilter: question_getAllByFilter,
            question_getAllByTest: question_getAllByTest,
            question_get: question_get,
            question_getWithRandomChoices: question_getWithRandomChoices,
            question_update: question_update,
            question_delete: question_delete,
            question_add: question_add,
            question_addToTest: question_addToTest,
            question_upload: question_upload,
            question_deleteFiles: question_deleteFiles,
            question_load: question_load,
            question_deleteFromTest: question_deleteFromTest,

            //-- choice
            choice_getAllList: choice_getAllList,
            choice_count: choice_count,
            choice_countByFilter: choice_countByFilter,
            choice_getAll: choice_getAll,
            choice_getAllByQuestion: choice_getAllByQuestion,
            choice_get: choice_get,
            choice_update: choice_update,
            choice_delete: choice_delete,
            choice_add: choice_add,
            choice_upload: choice_upload,

            //-- questionTest
            questionTest_getAllList: questionTest_getAllList,
            questionTest_countByTest: questionTest_countByTest,
            questionTest_getAllByTest: questionTest_getAllByTest,
            questionTest_getAllByQuestion: questionTest_getAllByQuestion,
            questionTest_get: questionTest_get,
            questionTest_update: questionTest_update,
            questionTest_changeSequence: questionTest_changeSequence,
            questionTest_delete: questionTest_delete,
            questionTest_add: questionTest_add,
            questionTest_importList: questionTest_importList,
            questionTest_addByParams: questionTest_addByParams,

            questionTestCompBase_update: questionTestCompBase_update,
            questionTestCompBase_updateAll: questionTestCompBase_updateAll,

            //-- PERFORMANCE MATERIA
            performanceMateria_getAll: performanceMateria_getAll,

            //-- SESSION
            asl_session_getAll: asl_session_getAll,
            asl_session_countAll: asl_session_countAll,
            session_getAllList: session_getAllList,
            session_count: session_count,
            session_countByFilter: session_countByFilter,
            session_getAll: session_getAll,
            session_getAllByFilter: session_getAllByFilter,
            session_countByProc: session_countByProc,
            session_getAllByProc: session_getAllByProc,
            session_get: session_get,
            session_add: session_add,
            session_update: session_update,
            session_delete: session_delete,
            session_activate: session_activate,
            session_inactivate: session_inactivate,
            session_aggiornaVotiDidattica: session_aggiornaVotiDidattica,
            session_calcolaStatistiche: session_calcolaStatistiche,

            //attivazione come app
            session_enable: session_enable,
            session_createCode: session_createCode,
            studenteSession_unlock: studenteSession_unlock,            
            studenteSession_disableStudent: studenteSession_disableStudent,
            studenteSession_getBySessionId: studenteSession_getBySessionId,
            session_disable: session_disable,
            session_complete: session_complete,
            session_getSecondsRemaining: session_getSecondsRemaining,
            session_monitor: session_monitor,

            //esecuzione come da app
            studenteSession_disable: studenteSession_disable,
            studenteSession_start: studenteSession_start,
            questionStudenteSession_update: questionStudenteSession_update,

            //Lato studente
            session_getAllActive: session_getAllActive,
            session_getAllHistory: session_getAllHistory,
            session_getAllActiveByProc: session_getAllActiveByProc,
            session_countAllActiveByProc: session_countAllActiveByProc,
            session_getAllHistoryByProc: session_getAllHistoryByProc,
            session_countAllHistoryByProc: session_countAllHistoryByProc,

            //REPORTSTUDENTESESSION
            reportStudenteSession_getAllByStudenteId: reportStudenteSession_getAllByStudenteId,
            reportStudenteSession_countAllByStudenteId: reportStudenteSession_countAllByStudenteId,

            //REPORTSTUDENTESCHEDACOMPETENZE
            reportStudenteSchedaCompetenze_getAllByStudenteId: reportStudenteSchedaCompetenze_getAllByStudenteId,
            reportStudenteSchedaCompetenze_countAllByStudenteId: reportStudenteSchedaCompetenze_countAllByStudenteId,

            //REPORTCLASSESESSION
            reportClasseSession_getAllByClasseId: reportClasseSession_getAllByClasseId,
            reportClasseSession_countAllByClasseId: reportClasseSession_countAllByClasseId,

            //-- SESSION STUDENTE
            studenteSession_getAllList: studenteSession_getAllList,
            studenteSession_addList: studenteSession_addList,
            studenteSession_count: studenteSession_count,
            studenteSession_countByFilter: studenteSession_countByFilter,
            studenteSession_getAll: studenteSession_getAll,
            studenteSession_getAllByFilter: studenteSession_getAllByFilter,
            studenteSession_getAllByProc: studenteSession_getAllByProc,
            studenteSession_get: studenteSession_get,
            studenteSession_update: studenteSession_update,
            studenteSession_delete: studenteSession_delete,
            studenteSession_updatePdp: studenteSession_updatePdp,

            //PDP
            pdp_getAll: pdp_getAll,
            pdp_update: pdp_update,
            pdp_add: pdp_add,

            //VALUTAZIONE DOC
            valutazioneDoc_getAll: valutazioneDoc_getAll,
            valutazioneDoc_update: valutazioneDoc_update,
            valutazioneDoc_getByVoto: valutazioneDoc_getByVoto,
            valutazioneDoc_getByLettera: valutazioneDoc_getByLettera,

            //System Method
            getWhoAmI: getWhoAmI,
            getYearsList: getYearsList,
            logGetAll: logGetAll,
            logDelete: logDelete,
            pushGetAll: pushGetAll,
            pushDelete: pushDelete,
            updateSettings: updateSettings,

            getUrl: getUrl,
            getImage: getImage
        };
        return service;

        function getUrl() {
            return basePath;
        }

        function getImage(imagePath) {
            return $http.get(imagePath)
                .then(function (response) {
                    return response;
                })
                .catch(function (response) {
                    console.log('XHR Failed getImage for %s: %s', imagePath, response);
                    return response;
            });
        }

        // ******************************
        //  Funzioni Generiche
        function getAll(objName) {
            return $http.get(urlAPI + '/' + objName + '/GetAll')
                        .then(function (response) {
                            return response.data;
                        })
                        .catch(function (message) {
                            console.log('XHR Failed getAll for %s: %s', objName, message);
                            if (message.status == 401) {
                                $location.path('/logout');
                            }
                            return message.status;
                        });
        }

        function getAllList(objName) {
            return $http.get(urlAPI + '/' + objName + '/GetAllList')
                        .then(function (response) {
                            return response.data;
                        })
                        .catch(function (message) {
                            console.log('XHR Failed getAllList for %s: %s', objName, message);
                            if (message.status == 401) {
                                $location.path('/logout');
                            }
                            return message.status;
                        });
        }

        function getAllNoParam(objName, actionName) {
            var url = urlAPI + '/' + objName + '/' + actionName;
            return $http.get(url)
                        .then(function (response) {
                            return response.data;
                        })
                        .catch(function (message) {
                            console.log('XHR Failed getAll NO Param for %s: %s', objName, message);
                            if (message.status == 401) {
                                $location.path('/logout');
                            }
                            return message.status;
                        });
        }

        function getAllByParam(objName, actionName, paramName, paramValue) {
            var url = urlAPI + '/' + objName + '/' + actionName + '?' + paramName + '=' + paramValue;
            return $http.get(url)
                        .then(function (response) {
                            return response.data;
                        })
                        .catch(function (message) {
                            console.log('XHR Failed getAll for %s: %s', objName, message);
                            if (message.status == 401) {
                                $location.path('/logout');
                            }
                            return message.status;
                        });
        }

        function getAllByParams(objName, actionName, paramArray) {            
            var url = urlAPI + '/' + objName + '/' + actionName;

            var numParams = paramArray.length;
            if (numParams > 0) {
                url += '?';
            }

            for (var i = 0; i < numParams; i++) {
                if (i > 0) url += '&';
                url += paramArray[i].name + '=' + paramArray[i].value;
            }
            return $http.get(url)
                        .then(function (response) {
                            return response.data;
                        })
                        .catch(function (message) {
                            console.log('XHR Failed getAllByParams for %s: %s', objName, message);
                            if (message.status == 401) {
                                $location.path('/logout');
                            }
                            return message.status;
                        });
        }

        function getById(objName, id) {
            return $http.get(urlAPI + '/' + objName + '/Get/' + id)
                        .then(function (response) {
                            return response.data;
                        })
                        .catch(function (message) {
                            console.log('XHR Failed getById for %s: %s', objName, message);
                            if (message.status == 401) {
                                $location.path('/logout');
                            }
                            return message.status;
                        });
        }

        function getBaseById(objName, id) {
            return $http.get(urlAPI + '/' + objName + '/GetBase/' + id)
                        .then(function (response) {
                            return response.data;
                        })
                        .catch(function (message) {
                            console.log('XHR Failed getBaseById for %s: %s', objName, message);
                            if (message.status == 401) {
                                $location.path('/logout');
                            }
                            return message.status;
                        });
        }

        function addObj(objName, objValue) {
            //console.info("objName- value", objName, objValue);
            return $http.post(urlAPI + '/' + objName + '/Post', objValue)
                        .then(function (response) {
                            return response.data;
                        })
                        .catch(function (message) {
                            console.log('XHR Failed addObj for %s: %s', objName, message);
                            if (message.status == 401) {
                                $location.path('/logout');
                            }
                            return message.status;
                        });
        }

        function updateObj(objName, objValue) {
            return $http.put(urlAPI + '/' + objName + '/Put', objValue)
                        .then(function (response) {
                            return response.data;
                        })
                        .catch(function (message) {
                            console.log('XHR Failed updateObj for %s: %s', objName, message);
                            if (message.status == 401) {
                                $location.path('/logout');
                            }
                            return message.status;
                        });
        }

        function deleteObj(objName, id) {
            return $http.delete(urlAPI + '/' + objName + '/Delete/' + id)
                        .then(function (response) {
                            return response.status;
                        })
                        .catch(function (message) {
                            console.log('XHR Failed deleteObj for %s: %s', objName, message);
                            if (message.status == 401) {
                                $location.path('/logout');
                            }
                            return message.status;
                        });
        }
        //  END - Funzioni Generiche
        // ******************************


        // ***************************************************
        // ***************************************************
        //  Funzioni Pubbliche - esposte su interfaccia Service
        // ***************************************************
        // ***************************************************

        // ********************************
        // Account

        function account_get() {
            return $http.get(urlAPI + '/account/get').then(function (response) {
                return response.data;
            })
                .catch(function (response) {
                    console.log('XHR Failed account_get: %s', response); return null;
                });
        }

        function account_changePassword(item) {
            return $http.post(urlAPI + '/account/ChangePassword', item)
                .then(function (response) {
                    return response;
                })
                .catch(function (response) {
                    console.log('XHR Failed account_changePassword: %s', response);
                    return response;
                });
        }

        // ******************************
        //  Metodi init per array condivisi
        function arrClassi() {
            if (_arrClassi.length == 0) {
                return getAllList('classe').then(function (data) {
                    _arrClassi = data;
                    return _arrClassi;
                });
            }
            return $q.when(_arrClassi);
        }

        function arrProvincie() {
            if (_arrProvincie.length == 0) {
                return getAll('provincia').then(function (data) {
                    _arrProvincie = data;
                    return _arrProvincie;
                });
            }
            return $q.when(_arrProvincie);
        }

        function arrRisorse() {
            if (_arrRisorse.length == 0) {
                return getAllNoParam('risorsa', 'GetAllBase').then(function (data) {
                    _arrRisorse = data;
                    return _arrRisorse;
                });
            }
            return $q.when(_arrRisorse);
        }

        // ******************************
        //  AVVISI
        function avviso_getAll() {
            var data = getAllNoParam('avviso', 'GetAll');
            return $q.when(data);
        }       

        function avviso_getAllDocente() {
            var data = getAllNoParam('avviso', 'GetAllDocente');
            return $q.when(data);
        }

        function avviso_getAllStakeholder() {
            var data = getAllNoParam('avviso', 'GetAllStakeholder');
            return $q.when(data);
        }

        function avviso_getAllStudente() {
            var data = getAllNoParam('avviso', 'GetAllStudente');
            return $q.when(data);
        }

        function avviso_get(id) {
            var data = getById('avviso', id);
            return $q.when(data);
        }

        function avviso_add(item) {
            var data = addObj('avviso', item);
            return $q.when(data);
        }

        function avviso_update(item) {
            var data = updateObj('avviso', item);
            return $q.when(data);
        }

        function avviso_delete(id) {
            var data = deleteObj('avviso', id);
            return $q.when(data);
        }

        // ******************************
        //  AGGIORNAMENTI
        function aggiornamento_getAll() {
            var data = getAllNoParam('aggiornamento', 'GetAll');
            return $q.when(data);
        }

        function aggiornamento_countAll() {
            var data = getAllNoParam('aggiornamento', 'CountAll');
            return $q.when(data);
        }

        function aggiornamento_getByDocente() {
            var data = getAllNoParam('aggiornamento', 'GetByDocente');
            return $q.when(data);
        }

        function aggiornamento_getByStudente() {
            var data = getAllNoParam('aggiornamento', 'GetByStudente');
            return $q.when(data);
        }

        function aggiornamento_get(id) {
            var data = getById('aggiornamento', id);
            return $q.when(data);
        }

        function aggiornamento_add(item) {
            var data = addObj('aggiornamento', item);
            return $q.when(data);
        }

        function aggiornamento_update(item) {
            var data = updateObj('aggiornamento', item);
            return $q.when(data);
        }

        function aggiornamento_delete(id) {
            var data = deleteObj('aggiornamento', id);
            return $q.when(data);
        }

        // ******************************
        //  CLASSE - NUOVI METODI
        function classe_getAllList(anno) {
            if (typeof (anno) == 'undefined') { anno = -1; }

            var params = [];
            params.push({ name: 'anno', value: anno });

            var data = getAllByParams('classe', 'GetAllList', params);
            return $q.when(data);
        }

        function classe_getAll(pageSize, page, anno, classe, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (anno) == 'undefined' || anno == '' || anno == '') { anno = -1; }
            if (typeof (classe) == 'undefined') { classe = ""; }
            if (typeof (order) == 'undefined') { order = 'id'; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'anno', value: anno });
            params.push({ name: 'classe', value: classe });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('classe', 'GetAllByFilter', params);
            return $q.when(data);
        }

        //appartiene = true : torna tutte le classi dello studente
        //appartiene = false : torna tutte le classi a cui lo studente non appartiene 
        function classe_getAllByStudenteId(studenteId, appartiene) {
            if (typeof (studenteId) == 'undefined') { studenteId = 0; }
            if (typeof (appartiene) == 'undefined') { include = true; }

            var params = [];
            params.push({ name: 'studenteId', value: studenteId });
            params.push({ name: 'appartiene', value: appartiene });

            var data = getAllByParams('classe', 'GetAllByStudenteId', params);
            return $q.when(data);
        }

        function classe_countAll(anno, classe) {
            if (typeof (anno) == 'undefined' || anno == '') { anno = -1; }
            if (typeof (classe) == 'undefined') { classe = ""; }

            var params = [];
            params.push({ name: 'anno', value: anno });
            params.push({ name: 'classe', value: classe });

            var data = getAllByParams('classe', 'CountByFilter', params);
            return $q.when(data);
        }

        function classe_get(id) {
            var data = getById('classe', id);
            return $q.when(data);
        }

        function classe_add(item) {
            var data = addObj('classe', item);
            return $q.when(data);
        }

        function classe_update(item) {
            var data = updateObj('classe', item);
            return $q.when(data);
        }

        function classe_delete(id) {
            var data = deleteObj('classe', id);
            return $q.when(data);
        }

        function classe_studentiImportList(classeId, studenti) {
            var objName = 'classe';
            var method = 'StudentiImportList';

            if (typeof (classeId) == 'undefined') { classeId = 0; }
            if (typeof (studenti) == 'undefined') { studenti = []; }

            var url = urlAPI + '/' + objName + '/' + method;

            var obj = {
                classeId: classeId,
                studenti: studenti
            };

            return $http.put(url, obj)
              .then(function (response) {
                  return response.data;
              })
              .catch(function (message) {
                  console.log('XHR Failed classe_studentiImportList for %s: %s', objName, message);
                  return message.status;
              });
        }

        function classe_verificaCodice(codice) {
            var objName = 'classe';
            var method = 'VerificaCodice';

            if (typeof (codice) == 'undefined') { codice = ''; }
            var url = urlAPI + '/' + objName + '/' + method + '?codice=' + codice;
            return $http.get(url)
              .then(function (response) {
                  return response.data;
              })
              .catch(function (message) {
                  console.log('XHR Failed classe_verificaCodice for %s: %s', objName, message);
                  return message.status;
              });
        }

        function classe_studenteRegistra(id) {
            var objName = 'classe';
            var method = 'RegistraClasse';

            if (typeof (id) == 'undefined') { id = 0; }
            var url = urlAPI + '/' + objName + '/' + method + '?classeId=' + id;
            return $http.get(url)
              .then(function (response) {
                  return response.status;
              })
              .catch(function (message) {
                  console.log('XHR Failed classe_verificaCodice for %s: %s', objName, message);
                  return message.status;
              });
        }

        function classe_getAllByDocenteId(docenteId) {
            if (typeof (docenteId) == 'undefined') { docenteId = 0; }

            var params = [];
            params.push({ name: 'docenteId', value: docenteId });

            var data = getAllByParams('classe', 'GetAllByDocenteId', params);
            return $q.when(data);
        }

        function classe_getAllPerCreate(anno, grado, sezione, idTipoIndirizzo) {
            if (typeof (anno) == 'undefined') { anno = 0; }
            if (typeof (grado) == 'undefined') { grado = 0; }
            if (typeof (sezione) == 'undefined') { sezione = ''; }
            if (typeof (idTipoIndirizzo) == 'undefined') { idTipoIndirizzo = 0; }

            var params = [];
            params.push({ name: 'anno', value: anno });
            params.push({ name: 'grado', value: grado });
            params.push({ name: 'sezione', value: sezione });
            params.push({ name: 'idTipoIndirizzo', value: idTipoIndirizzo });

            var data = getAllByParams('classe', 'GetAllPerCreate', params);
            return $q.when(data);
        }

        function classe_seleziona(classeId) {
            var objName = 'classe';
            var method = 'Seleziona';

            if (typeof (classeId) == 'undefined') { classeId = 0; }
            var url = urlAPI + '/' + objName + '/' + method + '?classeId=' + classeId;

            return $http.post(url)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed classe_seleziona for %s: %s', objName, message);
                    return message.status;
                });
        }


        // ******************************
        //  VIDEOGUIDA
        function videoGuida_getAll(tutorialDocenti, pageSize, page, order, ricerca) {
            if (typeof (tutorialDocenti) == 'undefined') { tutorialDocenti = -1; }
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (order) == 'undefined') { order = ''; }
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }

            var params = [];
            params.push({ name: 'tutorialDocenti', value: tutorialDocenti });
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'order', value: order });
            params.push({ name: 'ricerca', value: ricerca });

            var data = getAllByParams('videoGuida', 'GetAllByFilter', params);
            return $q.when(data);
        }

        //function videoGuida_getAll(pageSize, page, order) {
        //    var data = getAllNoParam('videoGuida', 'GetAll');
        //    return $q.when(data);
        //} 
        /*
        function societa_countAll(testo, provinciaId, comuneId, invitoInviato) {
            if (typeof (testo) == 'undefined') { testo = ""; }
            if (typeof (provinciaId) == 'undefined') { provinciaId = 0; }
            if (typeof (comuneId) == 'undefined') { comuneId = 0; }
            if (typeof (invitoInviato) == 'undefined') { invitoInviato = -1; }

            var params = [];
            params.push({ name: 'testo', value: testo });
            params.push({ name: 'provinciaId', value: provinciaId });
            params.push({ name: 'comuneId', value: comuneId });
            params.push({ name: 'invitoInviato', value: invitoInviato });

            var data = getAllByParams('societa', 'CountByFilter', params);
            return $q.when(data);
        }
        */
        function videoGuida_countAll(tutorialDocenti, ricerca) {
            if (typeof (tutorialDocenti) == 'undefined') { tutorialDocenti = -1; }
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }

            var params = [];
            params.push({ name: 'tutorialDocenti', value: tutorialDocenti });
            params.push({ name: 'ricerca', value: ricerca });

            var data = getAllByParams('videoGuida', 'CountByFilter',params);
            return $q.when(data);
        }

        function videoGuida_get(id) {
            var data = getById('videoGuida', id);
            return $q.when(data);
        }

        function videoGuida_add(item) {
            var data = addObj('videoGuida', item);
            return $q.when(data);
        }

        function videoGuida_update(item) {
            var data = updateObj('videoGuida', item);
            return $q.when(data);
        }

        function videoGuida_delete(id) {
            var data = deleteObj('videoGuida', id);
            return $q.when(data);
        }

        // ******************************
        //  SOCIETA

        function societa_getAll(pageSize, page, testo, provinciaId, comuneId, invitoInviato, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (testo) == 'undefined') { testo = ""; }
            if (typeof (provinciaId) == 'undefined') { provinciaId = 0; }
            if (typeof (comuneId) == 'undefined') { comuneId = 0; }
            if (typeof (invitoInviato) == 'undefined') { invitoInviato = -1; }
            if (typeof (order) == 'undefined') { order = 'id'; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'testo', value: testo });
            params.push({ name: 'provinciaId', value: provinciaId });
            params.push({ name: 'comuneId', value: comuneId });            
            params.push({ name: 'invitoInviato', value: invitoInviato });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('societa', 'GetAllByFilter', params);
            return $q.when(data);
        }

        function societa_countAll(testo, provinciaId, comuneId, invitoInviato) {
            if (typeof (testo) == 'undefined') { testo = ""; }
            if (typeof (provinciaId) == 'undefined') { provinciaId = 0; }
            if (typeof (comuneId) == 'undefined') { comuneId = 0; }
            if (typeof (invitoInviato) == 'undefined') { invitoInviato = -1; }

            var params = [];
            params.push({ name: 'testo', value: testo });
            params.push({ name: 'provinciaId', value: provinciaId });
            params.push({ name: 'comuneId', value: comuneId });
            params.push({ name: 'invitoInviato', value: invitoInviato });

            var data = getAllByParams('societa', 'CountByFilter', params);
            return $q.when(data);
        }

        function societa_getAllList() {
            var data = getAllList('societa');
            return $q.when(data);
        }

        function societa_get(id) {
            var data = getById('societa', id);
            return $q.when(data);
        }

        function societa_add(item) {
            var data = addObj('societa', item);
            return $q.when(data);
        }

        function societa_update(item) {
            var data = updateObj('societa', item);
            return $q.when(data);
        }

        //Metodi per il gestore didattico
        function societa_gest_get() {
            return $http.get(urlAPI + '/Societa/Gest_Get').then(function (response) {
                return response.data;
            })
              .catch(function (message) {
                  console.log('XHR Failed societa_gest_get: %s', message);
                  return message.status;
              });
        }

        function societa_gest_put(item) {
            return $http.put(urlAPI + '/Societa/Gest_Put', item).then(function (response) {
                return response.data;
            })
              .catch(function (message) {
                  console.log('XHR Failed societa_gest_get: %s', message);
                  return message.status;
              });
        }

        function societa_uploadLogo(filename, file) {
            var objName = 'societa';
            var method = 'UploadLogo';

            if (typeof (filename) == 'undefined') { filename = ''; }
            if (typeof (file) == 'undefined') { file = {}; }

            var url = urlAPI + '/' + objName + '/' + method;

            var item = {};
            item.filename = filename;
            item.file = file;

            return $http.post(url, item)
              .then(function (response) {
                  return response.data;
              })
              .catch(function (message) {
                  console.log('XHR Failed question_upload for %s: %s', objName, message);
                  return message.status;
              });
        }

        function societa_inviaInvito(id) {
            var url = urlAPI + '/societa/inviaInvito?id=' + id;
            return $http.post(url)
                .then(function (response) {
                    return response;
                })
                .catch(function (message) {
                    console.log('XHR Failed societa_inviaInvito: %s', message);
                    return message;
            });
        }

        function societa_getAllByFilter(ricerca) {
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }

            var params = [];
            params.push({ name: 'ricerca', value: ricerca });

            var data = getAllByParams('societa', 'Super_GetSocieta', params);
            return $q.when(data);
        }

        // ******************************
        //  COMMERCIALE
        function commerciale_getAllList() {
            var data = getAllNoParam('commerciale', 'GetAllList');
            return $q.when(data);
        }

        function commerciale_getAll(pageSize, page, nominativo, bStato, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (nominativo) == 'undefined') { nominativo = ''; }
            if (typeof (bStato) == 'undefined') { bStato = 0; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'nominativo', value: nominativo });
            params.push({ name: 'bStato', value: bStato });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('commerciale', 'GetAllByFilter', params);
            return $q.when(data);
        }

        function commerciale_countAll(nominativo, bStato) {
            if (typeof (nominativo) == 'undefined') { nominativo = ''; }
            if (typeof (bStato) == 'undefined') { bStato = 0; }
            var params = [];
            params.push({ name: 'nominativo', value: nominativo });
            params.push({ name: 'bStato', value: bStato });

            var data = getAllByParams('commerciale', 'CountByFilter', params);
            return $q.when(data);
        }

        function commerciale_getByUsername() {
            var data = getAllNoParam('commerciale', 'GetByUsername');
            return $q.when(data);
        }

        function commerciale_getByUsername2(username) {
            var data = getAllByParam('commerciale', 'GetByUsername2', 'username', username);
            return $q.when(data);
        }

        function commerciale_get(id) {
            var data = getById('commerciale', id);
            return $q.when(data);
        }

        function commerciale_add(item) {
            var data = addObj('commerciale', item);
            return $q.when(data);
        }

        function commerciale_update(item) {
            var data = updateObj('commerciale', item);
            return $q.when(data);
        }

        function commerciale_delete(id) {
            var data = deleteObj('commerciale', id);
            return $q.when(data);
        }

        // ******************************
        //  CONTRATTO
        function contratto_getAllList() {
            var data = getAllNoParam('contratto', 'GetAllList');
            return $q.when(data);
        }

        function contratto_getAll(pageSize, page, commercialeId, istitutoId, anno, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (commercialeId) == 'undefined') { commercialeId = 0; }
            if (typeof (istitutoId) == 'undefined') { istitutoId = 0; }
            if (typeof (anno) == 'undefined' || anno == '') { anno = -1; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'commercialeId', value: commercialeId });
            params.push({ name: 'istitutoId', value: istitutoId });
            params.push({ name: 'anno', value: anno });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('contratto', 'GetAllByFilter', params);
            return $q.when(data);
        }

        function contratto_countAll(commercialeId, istitutoId, anno) {
            if (typeof (commercialeId) == 'undefined') { commercialeId = 0; }
            if (typeof (istitutoId) == 'undefined') { istitutoId = 0; }
            if (typeof (anno) == 'undefined' || anno == '') { anno = -1; }
            var params = [];
            params.push({ name: 'commercialeId', value: commercialeId });
            params.push({ name: 'istitutoId', value: istitutoId });
            params.push({ name: 'anno', value: anno });

            var data = getAllByParams('contratto', 'CountByFilter', params);
            return $q.when(data);
        }

        function contratto_get(id) {
            var data = getById('contratto', id);
            return $q.when(data);
        }

        function contratto_add(item) {
            var data = addObj('contratto', item);
            return $q.when(data);
        }

        function contratto_update(item) {
            var data = updateObj('contratto', item);
            return $q.when(data);
        }

        function contratto_delete(id) {
            var data = deleteObj('contratto', id);
            return $q.when(data);
        }

        // ******************************
        //  LISTINO
        function listino_getAllList() {
            var data = getAllNoParam('listino', 'GetAllList');
            return $q.when(data);
        }

        function listino_getAll(pageSize, page, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('listino', 'GetAllByFilter', params);
            return $q.when(data);
        }

        function listino_countAll() {
            var data = getAllNoParam('listino', 'CountByFilter');
            return $q.when(data);
        }

        function listino_get(id) {
            var data = getById('listino', id);
            return $q.when(data);
        }

        function listino_add(item) {
            var data = addObj('listino', item);
            return $q.when(data);
        }

        function listino_update(item) {
            var data = updateObj('listino', item);
            return $q.when(data);
        }

        function listino_delete(id) {
            var data = deleteObj('listino', id);
            return $q.when(data);
        }

        // ******************************
        //  CONTO CORRENTE
        function contoCorrente_getAllList() {
            var data = getAllNoParam('contoCorrente', 'GetAllList');
            return $q.when(data);
        }

        function contoCorrente_getAll(pageSize, page, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('contoCorrente', 'GetAllByFilter', params);
            return $q.when(data);
        }

        function contoCorrente_countAll() {
            var data = getAllNoParam('contoCorrente', 'CountByFilter');
            return $q.when(data);
        }

        function contoCorrente_get(id) {
            var data = getById('contoCorrente', id);
            return $q.when(data);
        }

        function contoCorrente_add(item) {
            var data = addObj('contoCorrente', item);
            return $q.when(data);
        }

        function contoCorrente_update(item) {
            var data = updateObj('contoCorrente', item);
            return $q.when(data);
        }

        function contoCorrente_delete(id) {
            var data = deleteObj('contoCorrente', id);
            return $q.when(data);
        }

        // ******************************
        //  TAG
        function tag_getAllList(idParent, text, weight) {
            if (typeof (idParent) == 'undefined') { idParent = 0; }
            if (typeof (text) == 'undefined') { text = ''; }
            if (typeof (weight) == 'undefined') { weight = 0; }

            var params = [];
            params.push({ name: 'idParent', value: idParent });
            params.push({ name: 'text', value: text });
            params.push({ name: 'weight', value: weight });

            var data = getAllByParams('tag', 'GetAllList', params);
            return $q.when(data);
        }

        function tag_getAll(pageSize, page, idParent, text, weight, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (idParent) == 'undefined') { idParent = 0; }
            if (typeof (text) == 'undefined') { text = ''; }
            if (typeof (weight) == 'undefined') { weight = 0; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'idParent', value: idParent });
            params.push({ name: 'text', value: text });
            params.push({ name: 'weight', value: weight });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('tag', 'GetAllByFilter', params);
            return $q.when(data);
        }

        function tag_countAll(idParent, text, weight) {
            if (typeof (idParent) == 'undefined') { idParent = 0; }
            if (typeof (text) == 'undefined') { text = ''; }
            if (typeof (weight) == 'undefined') { weight = 0; }

            var params = [];
            params.push({ name: 'idParent', value: idParent });
            params.push({ name: 'text', value: text });
            params.push({ name: 'weight', value: weight });

            var data = getAllByParams('tag', 'CountByFilter', params);
            return $q.when(data);
        }

        function tag_get(id) {
            var data = getById('tag', id);
            return $q.when(data);
        }

        function tag_add(item) {
            var data = addObj('tag', item);
            return $q.when(data);
        }

        function tag_update(item) {
            var data = updateObj('tag', item);
            return $q.when(data);
        }

        function tag_delete(id) {
            var data = deleteObj('tag', id);
            return $q.when(data);
        }

        // ******************************
        //  TAG FAKE
        function tagFake_getAllList(text) {
            if (typeof (text) == 'undefined') { text = ''; }

            var params = [];
            params.push({ name: 'text', value: text });

            var data = getAllByParams('tagFake', 'GetAllList', params);
            return $q.when(data);
        }

        function tagFake_getAll(pageSize, page, text, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (text) == 'undefined') { text = ''; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'text', value: text });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('tagFake', 'GetAllByFilter', params);
            return $q.when(data);
        }

        function tagFake_countAll(text) {
            if (typeof (text) == 'undefined') { text = ''; }

            var params = [];
            params.push({ name: 'text', value: text });

            var data = getAllByParams('tagFake', 'CountByFilter', params);
            return $q.when(data);
        }

        function tagFake_get(id) {
            var data = getById('tagFake', id);
            return $q.when(data);
        }

        function tagFake_add(item) {
            var data = addObj('tagFake', item);
            return $q.when(data);
        }

        function tagFake_update(item) {
            var data = updateObj('tagFake', item);
            return $q.when(data);
        }

        function tagFake_delete(id) {
            var data = deleteObj('tagFake', id);
            return $q.when(data);
        }

        // ******************************
        //  CONTRATTO ATTACH
        function contrattoAttach_getAllList() {
            var data = getAllNoParam('contrattoAttach', 'GetAllList');
            return $q.when(data);
        }

        function contrattoAttach_getAll(pageSize, page, contrattoId, tipo, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (contrattoId) == 'undefined') { contrattoId = 0; }
            if (typeof (tipo) == 'undefined') { tipo = ''; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'contrattoId', value: contrattoId });
            params.push({ name: 'tipo', value: tipo });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('contrattoAttach', 'GetAllByFilter', params);
            return $q.when(data);
        }

        function contrattoAttach_countAll(contrattoId, tipo) {
            if (typeof (contrattoId) == 'undefined') { commercialeId = 0; }
            if (typeof (tipo) == 'undefined') { tipo = ''; }

            var params = [];
            params.push({ name: 'contrattoId', value: commercialeId });
            params.push({ name: 'tipo', value: tipo });

            var data = getAllByParams('contrattoAttach', 'CountByFilter', params);
            return $q.when(data);
        }

        function contrattoAttach_get(id) {
            var data = getById('contrattoAttach', id);
            return $q.when(data);
        }

        function contrattoAttach_update(item) {
            var data = updateObj('contrattoAttach', item);
            return $q.when(data);
        }

        function contrattoAttach_delete(id) {
            var data = deleteObj('contrattoAttach', id);
            return $q.when(data);
        }

        function contrattoAttach_fileUpload(contrattoId, filename, file, type) {
            var objName = 'contrattoAttach';
            var method = 'FileUpload';

            if (typeof (filename) == 'undefined') { filename = ''; }
            if (typeof (file) == 'undefined') { file = {}; }
            if (typeof (type) == 'undefined') { type = '' }

            var url = urlAPI + '/' + objName + '/' + method;

            var item = {};
            item.ContrattoId = contrattoId;
            item.FileName = filename;
            item.File = file;
            item.Tipo = type;               //P: protocollo di intesa, E: excel dati istituto

            return $http.post(url, item)
              .then(function (response) {
                  return response.data;
              })
              .catch(function (message) {
                  console.log('XHR Failed contrattoAttach_fileUpload for %s: %s', objName, message);
                  return message.status;
              });
        }

        function contrattoAttach_fileDownload(id) {
            var objName = 'contrattoAttach';
            var method = 'FileDownload';

            return $http.get(urlAPI + '/' + objName + '/' + method + '/' + id)
                       .then(function (response) {
                           return response.data;
                       })
                       .catch(function (message) {
                           console.log('XHR Failed contrattoAttach_fileDownload for %s: %s', objName, message);
                           return message.status;
                       });
        }

        // ******************************
        //  CONTRATTO INCONTRO
        function contrattoIncontro_getAllList() {
            var data = getAllNoParam('contrattoIncontro', 'GetAllList');
            return $q.when(data);
        }

        function contrattoIncontro_getAll(pageSize, page, contrattoId, commercialeId) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (contrattoId) == 'undefined') { contrattoId = 0; }
            if (typeof (commercialeId) == 'undefined') { commercialeId = 0; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'contrattoId', value: contrattoId });
            params.push({ name: 'commercialeId', value: commercialeId });

            var data = getAllByParams('contrattoIncontro', 'GetAllByFilter', params);
            return $q.when(data);
        }

        function contrattoIncontro_countAll(contrattoId, commercialeId) {
            if (typeof (contrattoId) == 'undefined') { contrattoId = 0; }
            if (typeof (commercialeId) == 'undefined') { commercialeId = 0; }

            var params = [];
            params.push({ name: 'contrattoId', value: contrattoId });
            params.push({ name: 'commercialeId', value: commercialeId });

            var data = getAllByParams('contrattoIncontro', 'CountByFilter', params);
            return $q.when(data);
        }

        function contrattoIncontro_get(id) {
            var data = getById('contrattoIncontro', id);
            return $q.when(data);
        }

        function contrattoIncontro_add(item) {
            var data = addObj('contrattoIncontro', item);
            return $q.when(data);
        }

        function contrattoIncontro_update(item) {
            var data = updateObj('contrattoIncontro', item);
            return $q.when(data);
        }

        function contrattoIncontro_delete(id) {
            var data = deleteObj('contrattoIncontro', id);
            return $q.when(data);
        }


        // ******************************
        //  CONTRATTO PROVVIGIONE
        function contrattoProvvigione_getAllList() {
            var data = getAllNoParam('contrattoProvvigione', 'GetAllList');
            return $q.when(data);
        }

        function contrattoProvvigione_getAll(pageSize, page, contrattoId, anno, percentuale, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (contrattoId) == 'undefined') { contrattoId = 0; }
            if (typeof (anno) == 'undefined' || anno == '') { anno = 0; }
            if (typeof (percentuale) == 'undefined') { percentuale = 0; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'contrattoId', value: contrattoId });
            params.push({ name: 'anno', value: anno });
            params.push({ name: 'percentuale', value: percentuale });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('contrattoProvvigione', 'GetAllByFilter', params);
            return $q.when(data);
        }

        function contrattoProvvigione_countAll(contrattoId, anno, percentuale) {
            if (typeof (contrattoId) == 'undefined') { contrattoId = 0; }
            if (typeof (anno) == 'undefined' || anno == '') { anno = 0; }
            if (typeof (percentuale) == 'undefined') { percentuale = 0; }

            var params = [];
            params.push({ name: 'contrattoId', value: contrattoId });
            params.push({ name: 'anno', value: anno });
            params.push({ name: 'percentuale', value: percentuale });

            var data = getAllByParams('contrattoProvvigione', 'CountByFilter', params);
            return $q.when(data);
        }

        function contrattoProvvigione_get(id) {
            var data = getById('contrattoProvvigione', id);
            return $q.when(data);
        }

        function contrattoProvvigione_add(item) {
            var data = addObj('contrattoProvvigione', item);
            return $q.when(data);
        }

        function contrattoProvvigione_update(item) {
            var data = updateObj('contrattoProvvigione', item);
            return $q.when(data);
        }

        function contrattoProvvigione_delete(id) {
            var data = deleteObj('contrattoProvvigione', id);
            return $q.when(data);
        }

        // ******************************
        //  ORDINE
        /*function ordine_getAllList() {
            var data = getAllNoParam('ordine', 'GetAllList');
            return $q.when(data);
        }*/

        function ordine_getAll(pageSize, page, docenteId, commercialeId, dataOrdine, strumF, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (docenteId) == 'undefined') { docenteId = 0; }
            if (typeof (commercialeId) == 'undefined') { commercialeId = 0; }
            if (typeof (dataOrdine) == 'undefined') { dataOrdine = ''; }
            if (typeof (strumF) == 'undefined') { strumF = ''; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'docenteId', value: docenteId });
            params.push({ name: 'commercialeId', value: commercialeId });
            params.push({ name: 'dataOrdine', value: dataOrdine });
            params.push({ name: 'strumF', value: strumF });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('ordine', 'GetAllByFilter', params);
            return $q.when(data);
        }

        function ordine_countAll(docenteId, commercialeId, dataOrdine, strumF) {
            if (typeof (docenteId) == 'undefined') { docenteId = 0; }
            if (typeof (commercialeId) == 'undefined') { commercialeId = 0; }
            if (typeof (dataOrdine) == 'undefined') { dataOrdine = ''; }
            if (typeof (strumF) == 'undefined') { strumF = ''; }

            var params = [];
            params.push({ name: 'docenteId', value: docenteId });
            params.push({ name: 'commercialeId', value: commercialeId });
            params.push({ name: 'dataOrdine', value: dataOrdine });
            params.push({ name: 'strumF', value: strumF });

            var data = getAllByParams('ordine', 'CountByFilter', params);
            return $q.when(data);
        }

        function ordine_getAllByDocente() {
            var data = getAllNoParam('ordine', 'GetAllByDocente');
            return $q.when(data);
        }

        function ordine_countAllByDocente() {
            var data = getAllNoParam('ordine', 'CountByDocente');
            return $q.when(data);
        }

        function ordine_setPagamentoId(ordineId, pagamentoId) {
            if (typeof (ordineId) == 'undefined') { ordineId = 0; }
            if (typeof (pagamentoId) == 'undefined') { pagamentoId = 0; }

            var item = {};
            item.Id = ordineId;
            item.PagamentoId = pagamentoId;

            return $http.put(urlAPI + '/ordine/SetPagamentoId', item)
                        .then(function (response) {
                            return response.data;
                        })
                        .catch(function (message) {
                            console.log('XHR Failed setPagamentoId for %s: %s', objName, message);
                            return message.status;
                        });
        }

        function ordine_setIncassato(ordineId, dataIncassato) {
            if (typeof (ordineId) == 'undefined') { ordineId = 0; }
            if (typeof (dataIncassato) == 'undefined') { dataIncassato = ''; }

            var item = {};

            item.Id = ordineId;
            item.DataIncassato = dataIncassato;

            return $http.put(urlAPI + '/ordine/SetIncassato', item)
                        .then(function (response) {
                            return response.data;
                        })
                        .catch(function (message) {
                            console.log('XHR Failed setIncassato for %s', message);
                            return message.status;
                        });
        }

        function ordine_get(id) {
            var data = getById('ordine', id);
            return $q.when(data);
        }

        function ordine_sendMail(id) {
            if (typeof (id) == 'undefined') { id = 0; }
            return $http.get(urlAPI + '/ordine/SendMail/' + id)
                        .then(function (response) {
                            return response.data;
                        })
                        .catch(function (message) {
                            console.log('XHR Failed ordine_sendMail for %s', message);
                            return message.status;
                        });
        }

        function ordine_calcola() {
            return $http.get(urlAPI + '/Ordine/Calcola')
                            .then(function (response) {
                                return response.data;
                            })
                            .catch(function (message) {
                                console.log('XHR Failed for ordine_calcola: %s', message);
                                return message.status;
                            });
        }

        function ordine_calcolaCommerciale(docenteId) {
            if (typeof (docenteId) == 'undefined') { docenteId = 0; }

            return $http.get(urlAPI + '/Ordine/Calcola?docenteId=' + docenteId)
                            .then(function (response) {
                                return response.data;
                            })
                            .catch(function (message) {
                                console.log('XHR Failed for ordine_calcolaCommerciale: %s', message);
                                return message.status;
                            });
        }

        function ordine_postBonifico(item) {
            return $http.post(urlAPI + '/Ordine/PostBonifico', item)
                        .then(function (response) {
                            return response.data;
                        })
                        .catch(function (message) {
                            console.log('XHR Failed for ordine_postBonifico: %s', message);
                            return message.status;
                        });
        }

        function ordine_postContanti(item) {
            return $http.post(urlAPI + '/Ordine/PostContanti', item)
                        .then(function (response) {
                            return response.data;
                        })
                        .catch(function (message) {
                            console.log('XHR Failed for ordine_postContanti: %s', message);
                            return message.status;
                        });
        }

        function ordine_delete(id) {
            var data = deleteObj('ordine', id);
            return $q.when(data);
        }

        // ******************************
        //  ORDINE RIEPILOGO
        function riepilogoOrdine_getAllList() {
            var data = getAllNoParam('ordine', 'RiepilogoOrdine_GetAllList');
            return $q.when(data);
        }

        function riepilogoOrdine_getAll(pageSize, page, commercialeId, docenteId, pagato, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (commercialeId) == 'undefined') { commercialeId = 0; }
            if (typeof (docenteId) == 'undefined') { docenteId = 0; }
            if (typeof (pagato) == 'undefined') { pagato = 0; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'commercialeId', value: commercialeId });
            params.push({ name: 'docenteId', value: docenteId });
            params.push({ name: 'pagato', value: pagato });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('ordine', 'RiepilogoOrdine_GetAllByFilter', params);
            return $q.when(data);
        }

        function riepilogoOrdine_countAll(commercialeId, docenteId, pagato) {
            if (typeof (commercialeId) == 'undefined') { commercialeId = 0; }
            if (typeof (docenteId) == 'undefined') { docenteId = 0; }
            if (typeof (pagato) == 'undefined') { pagato = 0; }

            var params = [];
            params.push({ name: 'commercialeId', value: commercialeId });
            params.push({ name: 'docenteId', value: docenteId });
            params.push({ name: 'pagato', value: pagato });

            var data = getAllByParams('ordine', 'RiepilogoOrdine_CountByFilter', params);
            return $q.when(data);
        }

        function riepilogoOrdine_getAllByPagamentoId(id) {
            if (typeof (id) == 'undefined') { id = 0; }

            var params = [];
            params.push({ name: 'id', value: id });

            var data = getAllByParams('ordine', 'RiepilogoOrdine_GetAllByPagamentoId', params);
            return $q.when(data);
        }

        // ******************************
        //  PAGAMENTO
        function pagamento_getAllList() {
            var data = getAllNoParam('pagamento', 'GetAllList');
            return $q.when(data);
        }

        function pagamento_getAll(pageSize, page, testuale, commercialeId, data, strumF, order) {
            if (typeof pageSize == 'undefined') { pageSize = _pageSize; }
            if (typeof page == 'undefined') { page = 1; }
            if (typeof testuale == 'undefined') { testuale = ''; }
            if (typeof commercialeId == 'undefined') { commercialeId = 0; }
            if (typeof data == 'undefined') { data = ''; }
            if (typeof strumF == 'undefined') { strumF = ''; }
            if (typeof order == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'testuale', value: testuale });
            params.push({ name: 'commercialeId', value: commercialeId });
            params.push({ name: 'data', value: data });
            params.push({ name: 'strumF', value: strumF });
            params.push({ name: 'order', value: order });

            var data1 = getAllByParams('pagamento', 'GetAllByFilter', params);
            return $q.when(data1);
        }

        function pagamento_countAll(testuale, commercialeId, data, strumF) {
            if (typeof commercialeId == 'undefined') { commercialeId = 0; }
            if (typeof testuale == 'undefined') { testuale = ''; }
            if (typeof data == 'undefined') { data = ''; }
            if (typeof strumF == 'undefined') { strumF = ''; }

            var params = [];
            params.push({ name: 'data', value: data });
            params.push({ name: 'commercialeId', value: commercialeId });
            params.push({ name: 'testuale', value: testuale });
            params.push({ name: 'strumF', value: strumF });

            var data1 = getAllByParams('pagamento', 'CountByFilter', params);
            return $q.when(data1);
        }

        function pagamento_get(id) {
            var data = getById('pagamento', id);
            return $q.when(data);
        }

        function pagamento_add(item) {
            var data = addObj('pagamento', item);
            return $q.when(data);
        }

        function pagamento_update(item) {
            var data = updateObj('pagamento', item);
            return $q.when(data);
        }

        function pagamento_delete(id) {
            var data = deleteObj('pagamento', id);
            return $q.when(data);
        }

        // ******************************
        //  ISTAT
        function istat_comune_getAllList(idprov) {
            var data = getAllByParam('comune', 'GetAllByIdProv', 'id', idprov);
            return $q.when(data);
        }

        function istat_comune_get(id) {
            var data = getById('comune', id);
            return $q.when(data);
        }

        // ******************************
        //--  TIPO INCONTRO
        function tipoIncontro_getAllList() {
            var data = getAllList('tipoIncontro');
            return $q.when(data);
        }

        function tipoIncontro_get(id) {
            var data = getById('tipoIncontro', id);
            return $q.when(data);
        }

        // ******************************
        //--  TIPO TEST
        function tipoTest_getAllList() {
            var data = getAllList('tipoTest');
            return $q.when(data);
        }

        function tipoTest_get(id) {
            var data = getById('tipoTest', id);
            return $q.when(data);
        }        

        // ******************************
        //--  TIPO SOCIETA
        function tipoSocieta_getAllList() {
            var data = getAllList('tipoSocieta');
            return $q.when(data);
        }

        function tipoSocieta_get(id) {
            var data = getById('tipoSocieta', id);
            return $q.when(data);
        }

        function indirizzo_getAllList() {
            var data = getAllList('indirizzo');
            return $q.when(data);
        }

        // ******************************
        //   INDIRIZZO AGGIUNTIVO
        function indirizzoAggiuntivo_getAllByFilter(societaId, sede) {
            if (typeof (societaId) == 'undefined') { societaId = 0; }
            if (typeof (sede) == 'undefined') { sede = ''; }

            var params = [];
            params.push({ name: 'societaId', value: societaId });
            params.push({ name: 'sede', value: sede });

            var data = getAllByParams('indirizzoAggiuntivo', 'GetAllByFilter', params);
            return $q.when(data);
        }

        // ******************************
        //  INCARICO
        function incarico_getAll(pageSize, page, nominativo, classeId) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (nominativo) == 'undefined') { nominativo = ''; }
            if (typeof (classeId) == 'undefined') { classeId = 0; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'nominativo', value: nominativo });
            params.push({ name: 'classeId', value: classeId });

            var data = getAllByParams('incarico', 'GetAllByFilter', params);
            return $q.when(data);
        }

        function incarico_countAll(nominativo, classeId) {
            var params = [];
            params.push({ name: 'nominativo', value: nominativo });
            params.push({ name: 'classeId', value: classeId });

            var data = getAllByParams('incarico', 'CountByFilter', params);
            return $q.when(data);
        }

        function incarico_getAllByClasse(id) {
            var data = getAllByParam('incarico', 'GetAllByClasse', 'id', id);
            return $q.when(data);
        }

        function incarico_getAllByRisorsa(id) {
            var data = getAllByParam('incarico', 'GetAllByRisorsa', 'id', id);
            return $q.when(data);
        }

        function incarico_getAllByDocente(classeId) {
            var data = getAllByParam('incarico', 'GetAllByDocente', 'classeId', classeId);
            return $q.when(data);
        }

        function incarico_get(id) {
            var data = getById('incarico', id);
            return $q.when(data);
        }

        function incarico_getBase(id) {
            var data = getBaseById('incarico', id);
            return $q.when(data);
        }

        function incarico_add(item) {
            var data = addObj('incarico', item);
            return $q.when(data);
        }

        function incarico_update(item) {
            var data = updateObj('incarico', item);
            return $q.when(data);
        }

        function incarico_delete(id) {
            var data = deleteObj('incarico', id);
            return $q.when(data);
        }

        // ******************************
        function licenza_getAll() {
            //var data = getAllNoParam('tipoLicenza', 'GetAll');
            var data = getAll('tipoLicenza');

            return $q.when(data);
        }

        //--testAnteprime        
        function testAnteprime_getAllByTest(testId, questionId) {
            if (typeof (testId) == 'undefined') { testId = 0; }
            if (typeof (questionId) == 'undefined') { questionId = 0; }

            var params = [];
            params.push({ name: 'testId', value: testId });
            params.push({ name: 'questionId', value: questionId });

            var data = getAllByParams('testAnteprime', 'getAllByTest', params);
            return $q.when(data);
        }

        //-- PACCHETTO
        function pacchetto_getAllList() {
            var data = getAllList('pacchetto');
            return $q.when(data);
        }

        function pacchetto_countByFilter(testo, stato, numeroTest, data) {
            if (typeof (testo) == 'undefined') { testo = ''; }
            if (typeof (stato) == 'undefined') { stato = 0; }
            if (typeof (numeroTest) == 'undefined') { numeroTest = 0; }
            if (typeof (data) == 'undefined') { data = ''; }

            var params = [];
            params.push({ name: 'testo', value: testo });
            params.push({ name: 'stato', value: stato });
            params.push({ name: 'numeroTest', value: numeroTest });
            params.push({ name: 'data', value: data });

            var data1 = getAllByParams('pacchetto', 'CountByFilter', params);
            return $q.when(data1);
        }

        function pacchetto_getAllByFilter(pageSize, page, testo, stato, numeroTest, data, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (testo) == 'undefined') { testo = ''; }
            if (typeof (stato) == 'undefined') { stato = 0; }
            if (typeof (numeroTest) == 'undefined') { numeroTest = 0; }
            if (typeof (data) == 'undefined') { data = ''; }
            if (typeof (order) == 'undefined') { order = ''; }


            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'testo', value: testo });
            params.push({ name: 'stato', value: stato });
            params.push({ name: 'numeroTest', value: numeroTest });
            params.push({ name: 'data', value: data });
            params.push({ name: 'order', value: order });

            var data1 = getAllByParams('pacchetto', 'GetAllByFilter', params);
            return $q.when(data1);
        }

        function asl_pacchetto_countByFilter(testo, stato, numeroTest) {
            if (typeof (testo) == 'undefined') { testo = ''; }
            if (typeof (stato) == 'undefined') { stato = 0; }
            if (typeof (numeroTest) == 'undefined') { numeroTest = 0; }

            var params = [];
            params.push({ name: 'testo', value: testo });
            params.push({ name: 'stato', value: stato });
            params.push({ name: 'numeroTest', value: numeroTest });

            var data1 = getAllByParams('pacchetto', 'Asl_CountByFilter', params);
            return $q.when(data1);
        }

        function asl_pacchetto_getAllByFilter(pageSize, page, testo, stato, numeroTest, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (testo) == 'undefined') { testo = ''; }
            if (typeof (stato) == 'undefined') { stato = 0; }
            if (typeof (numeroTest) == 'undefined') { numeroTest = 0; }
            if (typeof (order) == 'undefined') { order = ''; }


            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'testo', value: testo });
            params.push({ name: 'stato', value: stato });
            params.push({ name: 'numeroTest', value: numeroTest });
            params.push({ name: 'order', value: order });

            var data1 = getAllByParams('pacchetto', 'Asl_GetAllByFilter', params);
            return $q.when(data1);
        }

        function pacchetto_get(id) {
            var data = getById('pacchetto', id);
            return $q.when(data);
        }

        function pacchetto_update(item) {
            var data = updateObj('pacchetto', item);
            return $q.when(data);
        }

        function pacchetto_delete(id) {
            var data = deleteObj('pacchetto', id);
            return $q.when(data);
        }


        function pacchetto_add(item) {
            var data = addObj('pacchetto', item);
            return $q.when(data);
        }

        function pacchetto_pubblica(item) {
            return $http.put(urlAPI + '/pacchetto/pubblica', item)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed pacchetto_pubblica: %s', message);
                    return message.status;
                });
        }
        function pacchetto_modifica(item) {
            return $http.put(urlAPI + '/pacchetto/modifica', item)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed pacchetto_modifica: %s', message);
                    return message.status;
                });
        }

        //-- pacchettoTest
        function pacchettoTest_getAllList(pacchettoId) {
            var objName = 'pacchettoTest';
            var action = 'GetAllList';
            if (typeof (pacchettoId) == 'undefined') { pacchettoId = 0; }

            return $http.get(urlAPI + '/' + objName + '/' + action + '/' + pacchettoId)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed getAllList for %s: %s', objName, message);
                    return message.status;
                });
        }

        function pacchettoTest_getAllByPacchetto(pacchettoId, order) {
            if (typeof (pacchettoId) == 'undefined') { pacchettoId = 0; }
            if (typeof (order) == 'undefined') { order = 'id'; }

            var params = [];
            params.push({ name: 'pacchettoId', value: pacchettoId });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('pacchettoTest', 'getAllByPacchetto', params);
            return $q.when(data);
        }

        function pacchettoTest_countAllByPacchetto(pacchettoId) {
            if (typeof (pacchettoId) == 'undefined') { pacchettoId = 0; }

            var params = [];
            params.push({ name: 'pacchettoId', value: pacchettoId });

            var data = getAllByParams('pacchettoTest', 'CountAllByPacchetto', params);
            return $q.when(data);
        }

        function pacchettoTest_getAllByTest(pacchettoId, testId, order) {
            if (typeof (pacchettoId) == 'undefined') { pacchettoId = 0; }
            if (typeof (testId) == 'undefined') { testId = 0; }
            if (typeof (order) == 'undefined') { order = 'id'; }

            var params = [];
            params.push({ name: 'pacchettoId', value: pacchettoId });
            params.push({ name: 'testId', value: testId });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('pacchettoTest', 'getAllByTest', params);
            return $q.when(data);
        }

        function pacchettoTest_importList(pacchettoId, testsList) {
            var objName = 'pacchettoTest';
            var method = 'ImportList';

            if (typeof (pacchettoId) == 'undefined') { pacchettoId = 0; }
            if (typeof (testsList) == 'undefined') { testsList = []; }

            var url = urlAPI + '/' + objName + '/' + method;

            var obj = {
                pacchettoId: pacchettoId,
                testsList: testsList
            }

            return $http.put(url, obj)
              .then(function (response) {
                  return response.data;
              })
              .catch(function (message) {
                  console.log('XHR Failed ImportList for %s: %s', objName, message);
                  return message.status;
              });
        }

        function pacchettoTest_get(id) {
            var data = getById('pacchettoTest', id);
            return $q.when(data);
        }

        function pacchettoTest_update(item) {
            var data = updateObj('pacchettoTest', item);
            return $q.when(data);
        }

        function pacchettoTest_delete(id) {
            var data = deleteObj('pacchettoTest', id);
            return $q.when(data);
        }

        function pacchettoTest_add(item) {
            var data = addObj('pacchettoTest', item);
            return $q.when(data);
        }

        function pacchettoTest_addByParams(pacchettoId, testId) {
            var item = {};
            item.pacchettoId = pacchettoId;
            item.testId = testId;
            var data = addObj('pacchettoTest', item);
            return $q.when(data);
        }

        //-- testPacchetti
        function testPacchetti_getAllList(testId) {
            var objName = 'testPacchetti';
            var action = 'GetAllList';
            if (typeof (testId) == 'undefined') { testId = 0; }

            return $http.get(urlAPI + '/' + objName + '/' + action + '/' + testId)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed getAllList for %s: %s', objName, message);
                    return message.status;
                });
        }

        function testPacchetti_getAllByTest(testId, order) {
            if (typeof (testId) == 'undefined') { testId = 0; }
            if (typeof (order) == 'undefined') { order = 'id'; }

            var params = [];
            params.push({ name: 'testId', value: testId });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('testPacchetti', 'getAllByTest', params);
            return $q.when(data);
        }

        function testPacchetti_countAllByTest(testId) {
            if (typeof (testId) == 'undefined') { testId = 0; }

            var params = [];
            params.push({ name: 'testId', value: testId });

            var data = getAllByParams('testPacchetti', 'CountAllByTest', params);
            return $q.when(data);
        }

        function testPacchetti_getAllByPacchetto(pacchettoId, testId, order) {
            if (typeof (pacchettoId) == 'undefined') { pacchettoId = 0; }
            if (typeof (testId) == 'undefined') { testId = 0; }
            if (typeof (order) == 'undefined') { order = 'id'; }

            var params = [];
            params.push({ name: 'pacchettoId', value: pacchettoId });
            params.push({ name: 'testId', value: testId });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('testPacchetti', 'getAllByPacchetto', params);
            return $q.when(data);
        }

        //--categoria
        function categoria_getAllByFilter(pageSize, page, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (order) == 'undefined') { order = 'id'; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('categoria', 'GetAllByFilter', params);
            return $q.when(data);
        }

        //-- argomenti
        function argomenti_getAll(pageSize, page, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (order) == 'undefined') { order = 'id'; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('argomento', 'GetAllByFilter', params);
            return $q.when(data);
        }


        //********************************
        // ACQUISTO

        function acquisto_getAllByFilter(pageSize, page, titolo, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (titolo) == 'undefined') { titolo = ''; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'titolo', value: titolo });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('acquisto', 'GetAllByFilter', params);
            return $q.when(data);
        }

        function acquisto_countByFilter(titolo) {
            if (typeof (titolo) == 'undefined') { titolo = ''; }
            var params = [];
            params.push({ name: 'titolo', value: titolo });

            var data = getAllByParams('acquisto', 'CountByFilter', params);
            return $q.when(data);
        }        

        function acquisto_get(id) {
            var data = getById('acquisto', id);
            return $q.when(data);
        }

        //***************************
        //STAK
        //***************************
        //stak_test
        function stak_test_getAllByFilter(pageSize, page, testo, stato, numeroPacchetti, data, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (testo) == 'undefined') { testo = ''; }
            if (typeof (stato) == 'undefined') { stato = 0; }
            if (typeof (numeroPacchetti) == 'undefined') { numeroPacchetti = 0; }
            if (typeof (data) == 'undefined') { data = ''; }
            if (typeof (order) == 'undefined') { order = ''; }


            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'testo', value: testo });
            params.push({ name: 'stato', value: stato });
            params.push({ name: 'numeroPacchetti', value: numeroPacchetti });
            params.push({ name: 'data', value: data });
            params.push({ name: 'order', value: order });

            var data1 = getAllByParams('stakTest', 'GetAllByFilter', params);
            return $q.when(data1);
        }

        function stak_test_countByFilter(testo, stato, numeroPacchetti, data) {
            if (typeof (testo) == 'undefined') { testo = ''; }
            if (typeof (stato) == 'undefined') { stato = 0; }
            if (typeof (numeroPacchetti) == 'undefined') { numeroPacchetti = 0; }
            if (typeof (data) == 'undefined') { data = ''; }

            var params = [];
            params.push({ name: 'testo', value: testo });
            params.push({ name: 'stato', value: stato });
            params.push({ name: 'numeroPacchetti', value: numeroPacchetti });
            params.push({ name: 'data', value: data });

            var data1 = getAllByParams('stakTest', 'CountByFilter', params);
            return $q.when(data1);
        }

        function stak_test_getAllList() {
            var data = getAllList('stakTest');
            return $q.when(data);
        }

        function stak_test_get(id) {
            var data = getById('stakTest', id);
            return $q.when(data);
        }

        function stak_test_update(item) {
            var data = updateObj('stakTest', item);
            return $q.when(data);
        }

        function stak_test_delete(id) {
            var data = deleteObj('stakTest', id);
            return $q.when(data);
        }

        function stak_test_add(item) {
            var data = addObj('stakTest', item);
            return $q.when(data);
        }

        function stak_test_pubblica(item) {
            return $http.put(urlAPI + '/stakTest/pubblica', item)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed stakTest_pubblica: %s', message);
                    return message.status;
                });
        }
        function stak_test_modifica(item) {
            return $http.put(urlAPI + '/stakTest/modifica', item)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed stakTest_modifica: %s', message);
                    return message.status;
                });
        }

        function stak_test_reject(item) {
            return $http.put(urlAPI + '/staktest/reject', item)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed staktest_reject: %s', message);
                    return message.status;
                });
        }

        function stak_test_ricalcolaAnteprime(testId) {
            return $http.put(urlAPI + '/stakTest/RicalcolaAnteprime?id='+ testId)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed stak_test_ricalcolaAnteprime: %s', message);
                    return message.status;
                });
        }

        function stak_testPacchetto_getAllByFilter(materie, argomenti, anni) {
            if (typeof (materie) == 'undefined') { materie = ''; }
            if (typeof (argomenti) == 'undefined') { argomenti = ''; }
            if (typeof (anni) == 'undefined') { anni = ''; }

            var params = [];
            params.push({ name: 'materie', value: materie });
            params.push({ name: 'argomenti', value: argomenti });
            params.push({ name: 'anni', value: anni });

            var data = getAllByParams('stakTest', 'TestPacchetto_GetAllByFilter', params);
            return $q.when(data);
        }

        function stak_testNotInPacchetto_getAllByFilter(materie, argomenti, anni, pacchettoId) {
            if (typeof (materie) == 'undefined') { materie = ''; }
            if (typeof (argomenti) == 'undefined') { argomenti = ''; }
            if (typeof (anni) == 'undefined') { anni = ''; }
            if (typeof (pacchettoId) == 'undefined') { pacchettoId = 0; }

            var params = [];
            params.push({ name: 'materie', value: materie });
            params.push({ name: 'argomenti', value: argomenti });
            params.push({ name: 'anni', value: anni });
            params.push({ name: 'pacchettoId', value: pacchettoId });

            var data = getAllByParams('stakTest', 'TestNotInPacchetto_GetAllByFilter', params);
            return $q.when(data);
        }

        

        //stak_question

        function stak_question_getAllListNotInTest(testId) {
            var objName = 'stakQuestion';
            if (typeof (testId) == 'undefined') { testId = 0; }

            return $http.get(urlAPI + '/' + objName + '/GetAllListNotInTest?testId=' + testId)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed getAllList for %s: %s', objName, message);
                    return message.status;
                });
        }

        function stak_question_deleteNewFile(pathFile) {
            if (typeof (pathFile) == 'undefined') { pathFile = ''; }

            var params = [];
            params.push({ name: 'pathFile', value: pathFile });

            var data = getAllByParams('stakQuestion', 'DeleteNewFile', params);
            return $q.when(data);
        }

        function stak_question_countByFilter(testo) {
            if (typeof (testo) == 'undefined') { testo = ''; }
            var params = [];
            params.push({ name: 'testo', value: testo });

            var data = getAllByParams('stakQuestion', 'CountByFilter', params);
            return $q.when(data);
        }

        function stak_question_getAllByFilter(pageSize, page, testo, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (testo) == 'undefined') { testo = ''; }
            if (typeof (order) == 'undefined') { order = 'id'; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'testo', value: testo });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('stakQuestion', 'GetAllByFilter', params);
            return $q.when(data);
        }

        
        function stak_question_getAllByTest(testId, order) {
            if (typeof (testId) == 'undefined') { testId = 0; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'testId', value: testId });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('stakQuestion', 'GetAllByTest', params);
            return $q.when(data);
        }

        function stak_question_get(id) {
            var data = getById('stakQuestion', id);
            return $q.when(data);
        }

        function stak_question_deleteFiles(filesList) {
            var objName = 'stakQuestion';
            if (typeof (filesList) == 'undefined') { filesList = []; }

            var obj = {
                filesList: filesList
            }

            var url = urlAPI + '/' + objName + '/DeleteFiles';
            return $http.put(url, obj)
              .then(function (response) {
                  return response.data;
              })
              .catch(function (message) {
                  console.log('XHR Failed DeleteFiles for %s: %s', objName, message);
                  return message.status;
              });

        }

        function stak_question_update(item) {
            var data = updateObj('stakQuestion', item);
            return $q.when(data);
        }

        function stak_question_addToTest(item, testId) {
            var objName = 'stakQuestionTest';
            var method = 'AddQuestionToTest';

            if (typeof (testId) == 'undefined') { testId = 0; }
            if (typeof (item) == 'undefined') { item = {}; }

            var url = urlAPI + '/' + objName + '/' + method;

            item.testId = testId;


            return $http.post(url, item)
              .then(function (response) {
                  return response.data;
              })
              .catch(function (message) {
                  console.log('XHR Failed question_addToTest for %s: %s', objName, message);
                  return message.status;
              });

            /*
            return addObj('question', item).then(function (data) {
                return questionTest_addByParams(testId, data.Id).then(function (data2) {
                });
                /*
                var data2 = questionTest_addByParams(testId, data.Id);
                var dataUnion = {};
                dataUnion.question = data;
                dataUnion.questionTest = data2;
                return $q.when(dataUnion);
                //
            });
            */
        }

        function stak_question_add(item) {
            var data = addObj('stakQuestion', item);
            return $q.when(data);
        }

        function stak_question_delete(id) {
            var data = deleteObj('stakQuestion', id);
            return $q.when(data);
        }

        function stak_question_upload(filename, file, nome) {
            var objName = 'stakQuestion';
            var method = 'Upload';

            if (typeof (filename) == 'undefined') { filename = ''; }
            if (typeof (file) == 'undefined') { file = {}; }
            if (typeof (nome) == 'undefined') { nome = ''; }

            var url = urlAPI + '/' + objName + '/' + method;

            var item = {};
            item.filename = filename;
            item.file = file;
            item.nome = nome;


            return $http.post(url, item)
              .then(function (response) {
                  return response.data;
              })
              .catch(function (message) {
                  console.log('XHR Failed stak_question_upload for %s: %s', objName, message);
                  return message.status;
              });

        }

        function stak_question_deleteFromTest(questionId, testId) {
            var objName = 'stakQuestion';
            var method = 'DeleteFromTest';

            if (typeof (questionId) == 'undefined') { questionId = 0; }
            if (typeof (testId) == 'undefined') { testId = 0; }

            var url = urlAPI + '/' + objName + '/' + method + '?questionId=' + questionId + '&testId=' + testId;

            return $http.delete(url)
                .then(function (response) {
                    return response.status;
                })
                .catch(function (message) {
                    console.log('XHR Failed stak_question_deleteFromTest for %s: %s', objName, message);
                    return message.status;
                });
        }        

        //stak_questionTest

        function stak_questionTest_getAllByTest(testId, order) {
            if (typeof (testId) == 'undefined') { testId = 0; }
            if (typeof (order) == 'undefined') { order = 'id'; }

            var params = [];
            params.push({ name: 'testId', value: testId });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('stakQuestionTest', 'getAllByTest', params);
            return $q.when(data);
        }

        function stak_questionTest_countAllByTest(testId) {
            if (typeof (testId) == 'undefined') { testId = 0; }

            var params = [];
            params.push({ name: 'testId', value: testId });

            var data = getAllByParams('stakQuestionTest', 'CountAllByTest', params);
            return $q.when(data);
        }

        function stak_questionTest_delete(id) {
            var data = deleteObj('stakQuestionTest', id);
            return $q.when(data);
        }

        function stak_questionTest_changeSequence(orderList) {
            var objName = 'stakQuestionTest';
            if (typeof (orderList) == 'undefined') { orderList = []; }

            var obj = {
                orderList: orderList
            }

            var url = urlAPI + '/' + objName + '/ChangeSequence';
            return $http.put(url, obj)
              .then(function (response) {
                  return response.data;
              })
              .catch(function (message) {
                  console.log('XHR Failed ChangeSequence for %s: %s', objName, message);
                  return message.status;
              });

        }

        function stak_questionTest_importList(testId, questionsList) {
            var objName = 'stakQuestionTest';
            var method = 'ImportList';

            if (typeof (testId) == 'undefined') { testId = 0; }
            if (typeof (questionsList) == 'undefined') { questionsList = []; }

            var url = urlAPI + '/' + objName + '/' + method;

            var obj = {
                testId: testId,
                questionsList: questionsList
            }

            return $http.put(url, obj)
              .then(function (response) {
                  return response.data;
              })
              .catch(function (message) {
                  console.log('XHR Failed ImportList for %s: %s', objName, message);
                  return message.status;
              });
        }

        function stak_questionTest_getAllList(testId) {
            var objName = 'stakQuestionTest';
            var action = 'GetAllList';
            if (typeof (testId) == 'undefined') { testId = 0; }

            return $http.get(urlAPI + '/' + objName + '/' + action + '/' + testId)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed getAllList for %s: %s', objName, message);
                    return message.status;
                });
        }

        function stak_questionTest_getAllByQuestion(testId, questionId, order) {
            if (typeof (testId) == 'undefined') { testId = 0; }
            if (typeof (questionId) == 'undefined') { questionId = 0; }
            if (typeof (order) == 'undefined') { order = 'id'; }

            var params = [];
            params.push({ name: 'testId', value: testId });
            params.push({ name: 'questionId', value: questionId });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('stakQuestionTest', 'getAllByQuestion', params);
            return $q.when(data);
        }

        //stak_choice

        function stak_choice_getAllByQuestion(questionId, order) {
            if (typeof (questionId) == 'undefined') { questionId = 0; }
            if (typeof (order) == 'undefined') { order = 'id'; }

            var params = [];
            params.push({ name: 'questionId', value: questionId });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('stakChoice', 'getAllByQuestion', params);
            return $q.when(data);
        }       

        function stak_choice_delete(id) {
            var data = deleteObj('stakChoice', id);
            return $q.when(data);
        }

        function stak_choice_upload(filename, file) {
            var objName = 'stakChoice';
            var method = 'Upload';

            if (typeof (filename) == 'undefined') { filename = ''; }
            if (typeof (file) == 'undefined') { file = {}; }

            var url = urlAPI + '/' + objName + '/' + method;

            var item = {};
            item.filename = filename;
            item.file = file;


            return $http.post(url, item)
                                    .then(function (response) {
                                        return response.data;
                                    })
                                    .catch(function (message) {
                                        console.log('XHR Failed stak_choice_upload for %s: %s', objName, message);
                                        return message.status;
                                    });

        }
       
        function stak_materia_getAllList() {
            return $http.get(urlAPI + '/Argomento/Materie_GetAllList')
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed getAllList: %s', message);
                    if (message.status == 401) {
                        $location.path('/logout');
                    }
                    return message.status;
                });
        }

        //Stak_account

        function stak_account_getAllByFilter(pageSize, page, bAttivo, usernameFilter, emailFilter, ruolo, vecchioUserId, order) {
            if (typeof (bAttivo) == 'undefined') { bAttivo = 1; }
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (usernameFilter) == 'undefined') { usernameFilter = ''; }
            if (typeof (emailFilter) == 'undefined') { emailFilter = ''; }
            if (typeof (ruolo) == 'undefined') { ruolo = -1; }
            if (typeof (order) == 'undefined') { order = 'username'; }
            if (typeof (vecchioUserId) == 'undefined') { vecchioUserId = 0; }
            var params = [];
            params.push({ name: 'bAttivo', value: bAttivo });
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'usernameFilter', value: usernameFilter });
            params.push({ name: 'emailFilter', value: emailFilter });
            params.push({ name: 'ruolo', value: ruolo });
            params.push({ name: 'vecchioUserId', value: vecchioUserId });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('stakAccount', 'GetAllByFilter', params);
            return $q.when(data);
        }

        function stak_account_countAllByFilter(bAttivo, usernameFilter, emailFilter, ruolo, vecchioUserId) {
            if (typeof (bAttivo) == 'undefined') { bAttivo = 1; }
            if (typeof (usernameFilter) == 'undefined') { usernameFilter = ''; }
            if (typeof (emailFilter) == 'undefined') { emailFilter = 0; }
            if (typeof (vecchioUserId) == 'undefined') { vecchioUserId = 0; }
            if (typeof (ruolo) == 'undefined') { ruolo = -1; }
            var params = [];
            params.push({ name: 'bAttivo', value: bAttivo });
            params.push({ name: 'usernameFilter', value: usernameFilter });
            params.push({ name: 'emailFilter', value: emailFilter });
            params.push({ name: 'ruolo', value: ruolo });
            params.push({ name: 'vecchioUserId', value: vecchioUserId });

            var data = getAllByParams('stakAccount', 'CountByFilter', params);
            return $q.when(data);
        }

        //function stak_account_getAllForMigration(pageSize, page, bAttivo, username, email, ruolo, stakeholderId, vecchioUserId, order) {
        //    if (typeof (bAttivo) == 'undefined') { bAttivo = 1; }
        //    if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
        //    if (typeof (page) == 'undefined') { page = 1; }
        //    if (typeof (username) == 'undefined') { username = ''; }
        //    if (typeof (email) == 'undefined') { email = ''; }
        //    if (typeof (ruolo) == 'undefined') { ruolo = ''; }
        //    if (typeof (order) == 'undefined') { order = 'alfabetico'; }
        //    if (typeof (stakeholderId) == 'undefined') { stakeholderId = 0; }
        //    if (typeof (vecchioUserId) == 'undefined') { vecchioUserId = 0; }
        //    var params = [];
        //    params.push({ name: 'bAttivo', value: bAttivo });
        //    params.push({ name: 'pageSize', value: pageSize });
        //    params.push({ name: 'page', value: page });
        //    params.push({ name: 'username', value: username });
        //    params.push({ name: 'email', value: email });
        //    params.push({ name: 'ruolo', value: ruolo });
        //    params.push({ name: 'stakeholderId', value: stakeholderId });
        //    params.push({ name: 'vecchioUserId', value: vecchioUserId });
        //    params.push({ name: 'order', value: order });

        //    var data = getAllByParams('stakAccount', 'GetAllForMigration', params);
        //    return $q.when(data);
        //}

        function stak_account_eliminazioneMigrazioneUtente(vecchioUserId, nuovoUserId) {
            var objName = 'stakAccount';
            var method = 'EliminazioneMigrazioneUtente';

            if (typeof (vecchioUserId) == 'undefined') { vecchioUserId = 0; }
            if (typeof (nuovoUserId) == 'undefined') { nuovoUserId = 0; }            

            var url = urlAPI + '/' + objName + '/' + method + '?vecchioUserId=' + vecchioUserId + '&nuovoUserId=' + nuovoUserId;

            return $http.delete(url)
                .then(function (response) {
                    return response.status;
                })
                .catch(function (message) {
                    console.log('XHR Failed stak_account_eliminazioneMigrazioneUtente for %s: %s', objName, message);
                    return message.status;
                });
        }

        function stak_account_get(id) {
            var data = getById('stakAccount', id);
            return $q.when(data);
        }

        function stak_account_add(item) {
            var data = addObj('stakAccount', item);
            return $q.when(data);
        }

        function stak_account_update(item) {
            var data = updateObj('stakAccount', item);
            return $q.when(data);
        }

        function stak_account_activate(id) {
            var url = urlAPI + '/stakAccount/activate?id=' + id;
            return $http.post(url)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed activate for stakAccount: %s', message);
                    return message.status;
                });
        }

        function stak_account_deactivate(id) {
            var url = urlAPI + '/stakAccount/deactivate?id=' + id;
            return $http.post(url)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed deactivate for stakAccount: %s', message);
                    return message.status;
                });
        }

        function stak_account_resetPassword(email) {
            var url = urlAPI + '/stakAccount/resetpassword?email=' + email;
            return $http.post(url)
                .then(function (response) {
                    return response.status;
                })
                .catch(function (message) {
                    console.log('XHR Failed Reset Password for stakAccount: %s', message);
                    return message.status;
                });
        }

        function stak_account_invioCredenziali(email) {
            var url = urlAPI + '/stakAccount/invioCredenziali?email=' + email;
            return $http.post(url)
                .then(function (response) {
                    return response.status;
                })
                .catch(function (message) {
                    console.log('XHR Failed Reset Password for stakAccount: %s', message);
                    return message.status;
                });
        }

        function stak_account_delete(id) {
            var data = deleteObj('stakAccount', id);
            return $q.when(data);
        }


        // ******************************
        //  ISTITUTO
        function istituto_getAllList() {
            var data = getAllList('istituto');
            return $q.when(data);
        }

        function istituto_getAll(pageSize, page, nome) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (nome) == 'undefined') { nome = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'nome', value: nome });

            var data = getAllByParams('istituto', 'GetAllByFilter', params);
            return $q.when(data);

        }

        function istituto_countAll(nome) {
            if (typeof (nome) == 'undefined') { nome = ''; }

            var params = [];
            params.push({ name: 'nome', value: nome });

            var data = getAllByParams('istituto', 'CountByFilter', params);
            return $q.when(data);
        }

        function istituto_get(id) {
            var data = getById('istituto', id);
            return $q.when(data);
        }

        function istituto_getBase(id) {
            var data = getBaseById('istituto', id);
            return $q.when(data);
        }

        function istituto_add(item) {
            var data = addObj('istituto', item);
            return $q.when(data);
        }

        function istituto_update(item) {
            var data = updateObj('istituto', item);
            return $q.when(data);
        }

        function istituto_delete(id) {
            var data = deleteObj('istituto', id);
            return $q.when(data);
        }

        // ******************************
        //  MATERIA
        function materia_getAllList() {
            var data = getAllByParam('materia', 'GetAllList');
            return $q.when(data);
        }

        function materia_getAllListComplete() {
            var data = getAllNoParam('materia', 'GetAllListComplete');
            return $q.when(data);
        }

        function materia_getAllListByDocente(docenteId) {
            if (typeof (docenteId) == 'undefined') { docenteId = 0; }
            var data = getAllByParam('materia', 'GetAllListByDocente', 'docenteId', docenteId);
            return $q.when(data);
        }

        function materia_getAllMaterieDocentiList(docenteId) {
            if (typeof (docenteId) == 'undefined') { docenteId = 0; }
            var data = getAllByParam('materia', 'GetAllMaterieDocentiList', 'docenteId', docenteId);
            return $q.when(data);
        }

        function materia_getAll(pageSize, page, titolo, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (titolo) == 'undefined') { titolo = ''; }
            if (typeof (order) == 'undefined') { order = 'materia'; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'titolo', value: titolo });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('materia', 'GetAllByFilter', params);
            return $q.when(data);
        }

        function materia_getAllByDocente(pageSize, page, titolo) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (titolo) == 'undefined') { titolo = ''; }            

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'titolo', value: titolo });            

            var data = getAllByParams('materia', 'GetAllByDocente', params);
            return $q.when(data);
        }

        function materia_countAll(titolo) {
            if (typeof (titolo) == 'undefined') { titolo = ''; }

            var params = [];
            params.push({ name: 'titolo', value: titolo });

            var data = getAllByParams('materia', 'CountByFilter', params);
            return $q.when(data);
        }

        function materia_get(id) {
            var data = getById('materia', id);
            return $q.when(data);
        }

        function materia_add(item) {
            var data = addObj('materia', item);
            return $q.when(data);
        }

        function materia_update(item) {
            var data = updateObj('materia', item);
            return $q.when(data);
        }

        function materia_delete(id) {
            var data = deleteObj('materia', id);
            return $q.when(data);
        }

        function materia_docenteImportList(materie) {
            var objName = 'materia';
            var method = 'DocenteImportList';

            if (typeof (materie) == 'undefined') { materie = []; }

            var url = urlAPI + '/' + objName + '/' + method;

            var obj = {
                docenteId: 0,
                materie: materie
            };

            return $http.put(url, obj)
              .then(function (response) {
                  return response.data;
              })
              .catch(function (message) {
                  console.log('XHR Failed materia_docenteImportList for %s: %s', objName, message);
                  return message.status;
              });
        }

        function materia_docenteDelete(id) {
            var objName = 'materia';
            var method = 'DocenteDelete';

            if (typeof (id) == 'undefined') { id = 0; }
            var url = urlAPI + '/' + objName + '/' + method + '?materiaId=' + id;

            return $http.delete(url)
              .then(function (response) {
                  return response.status;
              })
              .catch(function (message) {
                  console.log('XHR Failed materia_docenteDelete for %s: %s', objName, message);
                  return message.status;
              });
        }

        function materia_setPredefinita(id) {
            return $http.put(urlAPI + '/materia/SetPredefinita?materiaId=' + id)
                .then(function (response) {
                    return response.status;
                })
                .catch(function (message) {
                    console.log('XHR Failed materia_setPredefinita: %s', message);
                    return message.status;
                });
        }

        function materia_getAllByDocenteId(docenteId) {
            if (typeof (docenteId) == 'undefined') { docenteId = 0; }
            
            var params = [];
            params.push({ name: 'docenteId', value: docenteId });
            
            var data = getAllByParams('materia', 'GetAllByDocenteId', params);
            return $q.when(data);
        }

        // ******************************
        //SCHEDA COMPETENZE
        function schedaCompetenze_getAll(pageSize, page, ricerca, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }
            if (typeof (order) == 'undefined') { order = 'Id'; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'ricerca', value: ricerca });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('schedaCompetenza', 'GetAll', params);
            return $q.when(data);
        }

        function schedaCompetenze_countAll(ricerca) {
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }

            var params = [];
            params.push({ name: 'ricerca', value: ricerca });

            var data = getAllByParams('schedaCompetenza', 'CountAll', params);
            return $q.when(data);
        }

        function schedaCompetenze_get(id) {
            var data = getById('schedaCompetenza', id);
            return $q.when(data);
        }

        function schedaCompetenze_update(item) {
            var data = updateObj('schedaCompetenza', item);
            return $q.when(data);
        }

        function schedaCompetenze_delete(id) {
            var data = deleteObj('schedaCompetenza', id);
            return $q.when(data);
        }

        function schedaCompetenze_add(item) {
            var data = addObj('schedaCompetenza', item);
            return $q.when(data);
        }

        function schedaCompetenze_attiva() {
            return $http.put(urlAPI + '/SchedaCompetenza/AttivaDidattica')
                       .then(function (response) {
                           return response.data;
                       })
                       .catch(function (message) {
                           console.log('XHR Failed addObj for schedaCompetenze_attiva: %s', message);
                           return message.status;
                       });
        }

        function schedaCompetenze_annulla() {
            return $http.put(urlAPI + '/SchedaCompetenza/AnnullaDidattica')
                       .then(function (response) {
                           return response.data;
                       })
                       .catch(function (message) {
                           console.log('XHR Failed addObj for schedaCompetenze_annulla: %s', message);
                           return message.status;
                       });
        }

        // ******************************
        //  ASSE CULTURALE
        function asseCulturale_get(id) {
            var data = getById('asseCulturale', id);
            return $q.when(data);
        }

        
        function asse_getAllByMateriaId(materiaId) {
            if (typeof (materiaId) == 'undefined') { materiaId = 0; }

            var params = [];
            params.push({ name: 'materiaId', value: materiaId });

            var data = getAllByParams('materieAssi', 'GetAllByMateriaId', params);
            return $q.when(data);
        }

        // ******************************
        //SCHEDA COMPETENZE TEST
        function schedaCompetenzeTest_getAll(testId, docenteId, anno) {
            var params = [];
            params.push({ name: 'testId', value: testId });
            params.push({ name: 'docenteId', value: docenteId });
            params.push({ name: 'anno', value: anno });

            var data = getAllByParams('schedaCompetenzaTest', 'GetAll', params);
            return $q.when(data);
        }

        function schedaCompetenzeTest_add (item) {
            var data = addObj('schedaCompetenzaTest', item);
            return $q.when(data);
        }

        function schedaCompetenzeTest_update(item) {
            var data = updateObj('schedaCompetenzaTest', item);
            return $q.when(data);
        }

        function schedaCompetenzeTest_creaDidattica(testId) {
            return $http.get(urlAPI + '/SchedaCompetenzaTest/CreaDidattica?testId=' + testId)
                .then(function (response) {
                    return response.status;
                })
                .catch(function (message) {
                    console.log('XHR Failed schedaCompetenzeTest_creaDidattica: %s', message);
                    return message.status;
                });
        }

        function schedaCompetenzeTest_creaDidatticaAltriTest(testId) {
            return $http.get(urlAPI + '/SchedaCompetenzaTest/CreaDidatticaAltriTest?testId=' + testId)
                .then(function (response) {
                    return response.status;
                })
                .catch(function (message) {
                    console.log('XHR Failed schedaCompetenzeTest_creaDidattica: %s', message);
                    return message.status;
                });
        }

        // ******************************
        //SCHEDA COMPETENZE SESSION
        function schedaCompetenzeSession_getAll(sessionId, docenteId/*, asseId*/) {
            var params = [];
            params.push({ name: 'sessionId', value: sessionId });
            params.push({ name: 'docenteId', value: docenteId });
            //params.push({ name: 'asseId', value: asseId });

            var data = getAllByParams('schedaCompetenzaSession', 'GetAll', params);
            return $q.when(data);
        }

        function schedaCompetenzeSession_add(item) {
            var data = addObj('schedaCompetenzaSession', item);
            return $q.when(data);
        }

        function schedaCompetenzeSession_update(item) {
            var data = updateObj('schedaCompetenzaSession', item);
            return $q.when(data);
        }

        function schedaCompetenzeSession_get(id) {
            var data = getById('schedaCompetenzaSession', id);
            return $q.when(data);
        }        

        // ******************************
        //SCHEDA COMPETENZE DOC
        function schedaCompetenzeDoc_getAll(anno, materiaId, docenteId, asseId) {
            var params = [];
            params.push({ name: 'anno', value: anno });
            params.push({ name: 'materiaId', value: materiaId });
            params.push({ name: 'docenteId', value: docenteId });
            params.push({ name: 'asseId', value: asseId });

            var data = getAllByParams('schedaCompetenzaDoc', 'GetAll', params);
            return $q.when(data);
        }
        function schedaCompetenzeDoc_countAll(anno, materiaId) {
            //if (typeof (anno) == 'undefined' || anno == '' || anno == '') { anno = -1; }
            //if (typeof (materia) == 'undefined') { materia = ""; }

            var params = [];
            params.push({ name: 'anno', value: anno });
            params.push({ name: 'materiaId', value: materiaId });

            var data = getAllByParams('schedaCompetenzaDoc', 'CountAll', params);
            return $q.when(data);
        }

        function schedaCompetenzeDoc_getAllByDocId(anno, materiaId, order) {
            
            if (typeof (anno) == 'undefined' || anno == '' || anno == '') { anno = -1; }
            if (typeof (materiaId) == 'undefined') { materiaId = 0; }
            if (typeof (order) == 'undefined') { order = 'id'; }

            var params = [];
            
            params.push({ name: 'anno', value: anno });
            params.push({ name: 'materiaId', value: materiaId });
            params.push({ name: 'order', value: order });
            var data = getAllByParams('schedaCompetenzaDoc', 'GetAllByDocenteId', params);
            return $q.when(data);
        }
        
        function schedaCompetenzeDoc_add(item) {
            var data = addObj('schedaCompetenzaDoc', item);
            return $q.when(data);
        }

        function schedaCompetenzeDoc_update(item) {
            var data = updateObj('schedaCompetenzaDoc', item);
            return $q.when(data);
        }

        function schedaCompetenzeDoc_delete(materiaId, docenteId, asseId, anno) {
            var params = [];
            params.push({ name: 'materiaId', value: materiaId });
            params.push({ name: 'docenteId', value: docenteId });
            params.push({ name: 'asseId', value: asseId });
            params.push({ name: 'anno', value: anno });

            var data = getAllByParams('schedaCompetenzaDoc', 'Delete', params);
            return $q.when(data);
        }


        // ******************************************
        //  RISORSA
        function asl_risorsa_getAll(pageSize, page, ricerca, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'ricerca', value: ricerca });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('risorsa', 'ASL_GetAllByFilter', params);
            return $q.when(data);
        }

        function asl_risorsa_countAll(ricerca) {
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }
            var params = [];
            params.push({ name: 'ricerca', value: ricerca });

            var data = getAllByParams('risorsa', 'ASL_CountByFilter', params);
            return $q.when(data);
        }

        function risorsa_getAllList() {
            var data = getAllNoParam('risorsa', 'GetAllList');
            return $q.when(data);
        }

        function risorsa_getByUsernameList() {
            var data = getAllNoParam('risorsa', 'GetByUsernameList');
            return $q.when(data);
        }

        function risorsa_getAll(pageSize, page, anno, nominativo, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (anno) == 'undefined' || anno == '') { anno = -1; }
            if (typeof (nominativo) == 'undefined') { nominativo = ''; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'anno', value: anno });
            params.push({ name: 'nominativo', value: nominativo });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('risorsa', 'GetAllByFilter', params);
            return $q.when(data);
        }

        function risorsa_countAll(anno, nominativo) {
            if (typeof (anno) == 'undefined' || anno == '') { anno = -1; }
            if (typeof (nominativo) == 'undefined') { nominativo = ''; }
            var params = [];
            params.push({ name: 'anno', value: anno });
            params.push({ name: 'nominativo', value: nominativo });

            var data = getAllByParams('risorsa', 'CountByFilter', params);
            return $q.when(data);
        }

        function risorsa_getAllByCognome(cognome) {
            var data = getAllByParam('risorsa', 'GetAllByCognome', 'cognome', cognome);
            return $q.when(data);
        }

        function risorsa_getAllByClasse(id) {
            var data = getAllByParam('risorsa', 'GetAllByClasse', 'id', id);
            return $q.when(data);
        }

        function risorsa_getByUsername() {
            var data = getAllNoParam('risorsa', 'GetByUsername');
            return $q.when(data);
        }

        function risorsa_getByUsername2(username) {
            var data = getAllByParam('risorsa', 'GetByUsername2', 'username', username);
            return $q.when(data);
        }

        function risorsa_getForBuy(codiceFiscale) {
            var data = getAllByParam('risorsa', 'GetForBuy', 'codiceFiscale', codiceFiscale);
            return $q.when(data);
        }

        function risorsa_getByCodiceFiscale(codiceFiscale) {
            if (typeof (codiceFiscale) == 'undefined') { codiceFiscale = ""; }

            return $http.get(urlAPI + '/Risorsa/GetByCodiceFiscale?codiceFiscale=' + codiceFiscale)
                       .then(function (response) {
                           return response.data;
                       })
                       .catch(function (message) {
                           console.log('XHR Failed risorsa_getByCodiceFiscale for: %s', message);
                           return message.status;
                       });
        }

        function risorsa_getDataFineLicenza(docenteId) {
            if (typeof (docenteId) == 'undefined') { docenteId = 0; }

            return $http.get(urlAPI + '/Risorsa/GetDataFineLicenza?id=' + docenteId)
                       .then(function (response) {
                           return response.data;
                       })
                       .catch(function (message) {
                           console.log('XHR Failed risorsa_getByCodiceFiscale for: %s', message);
                           return message.status;
                       });
        }

        function risorsa_getCodiceLicenza(docenteId) {
            if (typeof (docenteId) == 'undefined') { docenteId = 0; }

            return $http.get(urlAPI + '/Risorsa/GetCodiceLicenza?id=' + docenteId)
                       .then(function (response) {
                           return response.data;
                       })
                       .catch(function (message) {
                           console.log('XHR Failed risorsa_getCodiceLicenza for: %s', message);
                           return message.status;
                       });
        }

        function risorsa_get(id) {
            var data = getById('risorsa', id);
            return $q.when(data);
        }

        function risorsa_getBase(id) {
            var data = getBaseById('risorsa', id);
            return $q.when(data);
        }

        function risorsa_add(item) {
            var data = addObj('risorsa', item);
            return $q.when(data);
        }

        function risorsa_update(item) {
            var data = updateObj('risorsa', item);
            return $q.when(data);
        }       

        function risorsa_delete(id) {
            var data = deleteObj('risorsa', id);
            return $q.when(data);
        }

        function risorsa_getAllListByStudente() {
            var data = getAllNoParam('risorsa', 'GetAllListByStudente');
            return $q.when(data);
        }

        function risorsa_getAllByStudente() {
            var data = getAllNoParam('risorsa', 'GetAllByStudente');
            return $q.when(data);
        }

        function risorsa_setIcona(icona) {
            if (typeof (icona) == 'undefined') { icona = 0; }

            return $http.put(urlAPI + '/Risorsa/SetIcona?icona=' + icona)
                       .then(function (response) {                           
                           return response.status;
                       })
                       .catch(function (message) {
                           console.log('XHR Failed risorsa_setIcona for: %s', message);
                           return message.status;
                       });
        }

        // ******************************
        //  PDP

        function pdp_getAll(studenteId) {
            var params = [];
            params.push({ name: 'studenteId', value: studenteId });
            
            var data = getAllByParams('pianoDidatticoPersonalizzato', 'GetByFilter', params);
            return $q.when(data);
        }

        function pdp_update(item) {
            var data = updateObj('pianoDidatticoPersonalizzato', item);
            return $q.when(data);
        }

        function pdp_add(item) {
            var data = addObj('pianoDidatticoPersonalizzato', item);
            return $q.when(data);
        }
        
        

        // ******************************
        //  STAKEHOLDER

        function asl_stakeholder_getAll(pageSize, page, ricerca, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'ricerca', value: ricerca });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('stakeholder', 'ASL_GetAllByFilter', params);
            return $q.when(data);
        }

        function asl_stakeholder_countAll(ricerca) {
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }
            var params = [];
            params.push({ name: 'ricerca', value: ricerca });

            var data = getAllByParams('stakeholder', 'ASL_CountByFilter', params);
            return $q.when(data);
        }

        function stakeholder_getAll(pageSize, page, ragioneSociale, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (ragioneSociale) == 'undefined') { ragioneSociale = ''; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'ragioneSociale', value: ragioneSociale });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('stakeholder', 'GetAllByFilter', params);
            return $q.when(data);
        }

        function stakeholder_countAll(ragioneSociale) {
            if (typeof (ragioneSociale) == 'undefined') { ragioneSociale = ''; }
            var params = [];
            params.push({ name: 'ragioneSociale', value: ragioneSociale });

            var data = getAllByParams('stakeholder', 'CountByFilter', params);
            return $q.when(data);
        }

        function stakeholder_getAllByRagioneSociale(cognome) {
            var data = getAllByParam('stakeholder', 'GetAllByRagioneSociale', 'ragioneSociale', ragioneSociale);
            return $q.when(data);
        }

        /*function stakeholder_getAllByClasse(id) {
            var data = getAllByParam('stakeholder', 'GetAllByClasse', 'id', id);
            return $q.when(data);
        }*/

        function stakeholder_getByUsername() {
            var data = getAllNoParam('stakeholder', 'GetByUsername');
            return $q.when(data);
        }

        function stakeholder_getByUsername2(username) {
            var data = getAllByParam('stakeholder', 'GetByUsername2', 'username', username);
            return $q.when(data);
        }

        /*function stakeholder_getForBuy(codiceFiscale) {
            var data = getAllByParam('stakeholder', 'GetForBuy', 'codiceFiscale', codiceFiscale);
            return $q.when(data);
        }*/

        function stakeholder_getByCodiceFiscale(codiceFiscale) {
            if (typeof (codiceFiscale) == 'undefined') { codiceFiscale = ""; }

            return $http.get(urlAPI + '/stakeholder/GetByCodiceFiscale?codiceFiscale=' + codiceFiscale)
                       .then(function (response) {
                           return response.data;
                       })
                       .catch(function (message) {
                           console.log('XHR Failed stakeholder_getByCodiceFiscale for: %s', message);
                           return message.status;
                       });
        }

        /*function stakeholder_getDataFineLicenza(docenteId) {
            if (typeof (docenteId) == 'undefined') { docenteId = 0; }

            return $http.get(urlAPI + '/stakeholder/GetDataFineLicenza?id=' + docenteId)
                       .then(function (response) {
                           return response.data;
                       })
                       .catch(function (message) {
                           console.log('XHR Failed stakeholder_getByCodiceFiscale for: %s', message);
                           return message.status;
                       });
        }

        function stakeholder_getCodiceLicenza(docenteId) {
            if (typeof (docenteId) == 'undefined') { docenteId = 0; }

            return $http.get(urlAPI + '/stakeholder/GetCodiceLicenza?id=' + docenteId)
                       .then(function (response) {
                           return response.data;
                       })
                       .catch(function (message) {
                           console.log('XHR Failed stakeholder_getCodiceLicenza for: %s', message);
                           return message.status;
                       });
        }*/

        function stakeholder_get(id) {
            var data = getById('stakeholder', id);
            return $q.when(data);
        }

        function stakeholder_getBase(id) {
            var data = getBaseById('stakeholder', id);
            return $q.when(data);
        }

        function stakeholder_add(item) {
            var data = addObj('stakeholder', item);
            return $q.when(data);
        }

        function stakeholder_update(item) {
            var data = updateObj('stakeholder', item);
            return $q.when(data);
        }

        function stakeholder_delete(id) {
            var data = deleteObj('stakeholder', id);
            return $q.when(data);
        }

        function stakeholder_addAccount(item) {
            return $http.post(urlAPI + '/Stakeholder/PostAccount', item)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.info('XHR Failed stakeholder_addAccount for PostAccount: %s', message);
                    return message.status;
                });
        }

        function stakeholder_getListAccount(pageSize, page, bAttivo, username, stakeholderId, order) {
            if (typeof (bAttivo) == 'undefined') { bAttivo = 1; }
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (username) == 'undefined') { username = ''; }
            if (typeof (order) == 'undefined') { order = 'alfabetico'; }
            if (typeof (stakeholderId) == 'undefined') { stakeholderId = 0; }
            var params = [];
            params.push({ name: 'bAttivo', value: bAttivo });
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'username', value: username });
            params.push({ name: 'stakeholderId', value: stakeholderId });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('user', 'GetAllByStakeholder', params);
            return $q.when(data);
        }

        function asl_stakeholder_getListAccount(pageSize, page, bAttivo, username, stakeholderId, order) {
            if (typeof (bAttivo) == 'undefined') { bAttivo = 1; }
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (username) == 'undefined') { username = ''; }
            if (typeof (order) == 'undefined') { order = 'alfabetico'; }
            if (typeof (stakeholderId) == 'undefined') { stakeholderId = 0; }
            var params = [];
            params.push({ name: 'bAttivo', value: bAttivo });
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'username', value: username });
            params.push({ name: 'stakeholderId', value: stakeholderId });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('stakeholder', 'Asl_GetAllByFilterStak', params);
            return $q.when(data);
        }

        /*function stakeholder_getAllListByStudente() {
            var data = getAllNoParam('stakeholder', 'GetAllListByStudente');
            return $q.when(data);
        }

        function stakeholder_getAllByStudente() {
            var data = getAllNoParam('stakeholder', 'GetAllByStudente');
            return $q.when(data);
        }

        function stakeholder_setIcona(icona) {
            if (typeof (icona) == 'undefined') { icona = 0; }

            return $http.put(urlAPI + '/stakeholder/SetIcona?icona=' + icona)
                       .then(function (response) {
                           return response.status;
                       })
                       .catch(function (message) {
                           console.log('XHR Failed stakeholder_setIcona for: %s', message);
                           return message.status;
                       });
        }*/

        // ******************************
        //  STUDENTE
        function asl_studente_getAll(pageSize, page, ricerca, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'ricerca', value: ricerca });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('studente', 'ASL_GetAllByFilter', params);
            return $q.when(data);
        }

        function asl_studente_countAll(ricerca) {
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }
            var params = [];
            params.push({ name: 'ricerca', value: ricerca });

            var data = getAllByParams('studente', 'ASL_CountByFilter', params);
            return $q.when(data);
        }

        function studente_getAllList() {
            var data = getAllList('studente');
            return $q.when(data);
        }

        function studente_getAllListByClasse(classeId) {
            if (typeof (classeId) == 'undefined') { classeId = 0; }

            var data = getAllByParam('studente', 'GetAllListByClasse', 'classeId', classeId);
            return $q.when(data);
        }

        function studente_getAll(pageSize, page, anno, nominativo, classeId, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (anno) == 'undefined' || anno == '') { anno = -1; }
            if (typeof (nominativo) == 'undefined') { nominativo = ''; }
            if (typeof (classeId) == 'undefined') { classeId = 0; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'anno', value: anno });
            params.push({ name: 'nominativo', value: nominativo });
            params.push({ name: 'classeId', value: classeId });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('studente', 'GetAllByFilter', params);
            return $q.when(data);

        }

        function studente_countAll(anno, nominativo, classeId) {
            if (typeof (anno) == 'undefined' || anno == '') { anno = -1; }
            if (typeof (nominativo) == 'undefined') { nominativo = ''; }
            if (typeof (classeId) == 'undefined') { classeId = 0; }

            var params = [];
            params.push({ name: 'anno', value: anno });
            params.push({ name: 'nominativo', value: nominativo });
            params.push({ name: 'classeId', value: classeId });

            var data = getAllByParams('studente', 'CountByUsername', params);
            return $q.when(data);
        }

        function studente_getAllByUsername(pageSize, page, anno, nominativo, classeId, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (anno) == 'undefined' || anno == '') { anno = -1; }
            if (typeof (nominativo) == 'undefined') { nominativo = ''; }
            if (typeof (classeId) == 'undefined') { classeId = 0; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'anno', value: anno });
            params.push({ name: 'nominativo', value: nominativo });
            params.push({ name: 'classeId', value: classeId });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('studente', 'GetAllByUsername', params);
            return $q.when(data);

        }

        function studente_countAllByUsername(anno, nominativo, classeId) {
            if (typeof (anno) == 'undefined' || anno == '') { anno = -1; }
            if (typeof (nominativo) == 'undefined') { nominativo = ''; }
            if (typeof (classeId) == 'undefined') { classeId = 0; }

            var params = [];
            params.push({ name: 'anno', value: anno });
            params.push({ name: 'nominativo', value: nominativo });
            params.push({ name: 'classeId', value: classeId });

            var data = getAllByParams('studente', 'CountByUsername', params);
            return $q.when(data);
        }

        function studente_getAllByClasse(id) {
            var data = getAllByParam('studente', 'GetAllByClasse', 'id', id);
            return $q.when(data);
        }

        //Questo metodo serve nella schermata dettaglio classe
        //Calcola le statistiche degli allievi relativi alla classe passata (minuti svolti, minuti previsti)
        function studente_getAllByClasseId(id) {
            var data = getAllByParam('studente', 'GetAllByClasseId', 'id', id);
            return $q.when(data);
        }

        //id = classeId
        //escludi = bool
        //serve ad escludere gli studenti assegnati ad altre classi dello stesso corso
        function studente_getAllNotInByClasse(id) {
            if (typeof (id) == 'undefined') { id = 0; }
            var params = [];
            params.push({ name: 'id', value: id });
            var data = getAllByParams('studente', 'GetAllNotInByClasse', params);
            return $q.when(data);
        }

        function studente_getAllByClasse_Data(id, dt) {
            if (typeof (id) == 'undefined') { id = 0; }
            if (typeof (dt) == 'undefined') { dt = ''; }
            var params = [];
            params.push({ name: 'id', value: id });
            params.push({ name: 'dt', value: dt });

            var data = getAllByParams('studente', 'GetAllByClasse_Data', params);
            //var data = getAllByParams('studente', 'GetAllByClasse', 'id', id);
            return $q.when(data);
        }

        function studente_get(id) {
            var data = getById('studente', id);
            return $q.when(data);
        }

        function studente_getByUsername() {
            var data = getAllNoParam('studente', 'GetByUsername');
            return $q.when(data);
        }

        function studente_add(item) {
            var data = addObj('studente', item);
            return $q.when(data);
        }

        function studente_update(item) {
            var data = updateObj('studente', item);
            return $q.when(data);
        }       

        function studente_delete(id) {
            var data = deleteObj('studente', id);
            return $q.when(data);
        }

        function studente_classiImportList(studenteId, classi) {
            var objName = 'studente';
            var method = 'ClassiImportList';

            if (typeof (studenteId) == 'undefined') { studenteId = 0; }
            if (typeof (classi) == 'undefined') { classi = []; }

            var url = urlAPI + '/' + objName + '/' + method;

            var obj = {
                studenteId: studenteId,
                classi: classi
            };

            return $http.put(url, obj)
              .then(function (response) {
                  return response.data;
              })
              .catch(function (message) {
                  console.log('XHR Failed studente_classiImportList for %s: %s', objName, message);
                  return message.status;
              });
        }

        function studente_classeDelete(studenteId, classeId) {
            var objName = 'studente';
            var method = 'ClasseDelete';

            if (typeof (studenteId) == 'undefined') { studenteId = 0; }
            if (typeof (classeId) == 'undefined') { classeId = 0; }

            var url = urlAPI + '/' + objName + '/' + method + '?studenteId=' + studenteId + '&classeId=' + classeId;

            return $http.delete(url)
              .then(function (response) {
                  return response.status;
              })
              .catch(function (message) {
                  console.log('XHR Failed studente_classiImportList for %s: %s', objName, message);
                  return message.status;
              });
        }

        
        function studente_attivaPdp(username) {
            if (typeof (username) == 'undefined') { username = ''; }
            return $http.put(urlAPI + '/studente/AttivaPdp' + '?username=' + username)
                       .then(function (response) {
                           return response.data;
                       })
                       .catch(function (message) {
                           console.log('XHR Failed addObj for pdp_attiva: %s', message);
                           return message.status;
                       });
        }

        function studente_annullaPdp(username) {
            if (typeof (username) == 'undefined') { username = ''; }
            return $http.put(urlAPI + '/studente/AnnullaPdp' + '?username=' + username)
                       .then(function (response) {
                           return response.data;
                       })
                       .catch(function (message) {
                           console.log('XHR Failed addObj for pdp_annallata: %s', message);
                           return message.status;
                       });
        }

        function studente_getAllBySocieta(societaId) {
            if (typeof (societaId) == 'undefined' || societaId == '') { societaId = -1; }

            var params = [];
            params.push({ name: 'societaId', value: societaId });

            var data = getAllByParams('studente', 'Studente_GetAllBySocieta', params);
            return $q.when(data);
        }

        function studente_getAllSenzaClasse(societaId, anno) {
            if (typeof (societaId) == 'undefined' || societaId == '') { societaId = -1; }
            if (typeof (anno) == 'undefined' || anno == '') { anno = 0; }

            var params = [];
            params.push({ name: 'societaId', value: societaId });
            params.push({ name: 'anno', value: anno });

            var data = getAllByParams('studente', 'Studente_GetAllSenzaClasse', params);
            return $q.when(data);
        }

        // ******************************
        //SUPER
        function super_studente_getAllByUsername(pageSize, page, anno, nominativo, classeId, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (anno) == 'undefined' || anno == '') { anno = -1; }
            if (typeof (nominativo) == 'undefined') { nominativo = ''; }
            if (typeof (classeId) == 'undefined') { classeId = 0; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'anno', value: anno });
            params.push({ name: 'nominativo', value: nominativo });
            params.push({ name: 'classeId', value: classeId });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('studente', 'Super_GetAllByUsername', params);
            return $q.when(data);

        }

        function super_studente_countAllByUsername(anno, nominativo, classeId) {
            if (typeof (anno) == 'undefined' || anno == '') { anno = -1; }
            if (typeof (nominativo) == 'undefined') { nominativo = ''; }
            if (typeof (classeId) == 'undefined') { classeId = 0; }

            var params = [];
            params.push({ name: 'anno', value: anno });
            params.push({ name: 'nominativo', value: nominativo });
            params.push({ name: 'classeId', value: classeId });

            var data = getAllByParams('studente', 'Super_CountByUsername', params);
            return $q.when(data);
        }

        function super_studente_getAllByClasseId(id) {
            var data = getAllByParam('studente', 'Super_GetAllByClasseId', 'id', id);
            return $q.when(data);
        }

        function super_studente_getAllBySocieta(societaId, included) {
            if (typeof (societaId) == 'undefined' || societaId == '') { societaId = -1; }
            if (typeof (included) == 'undefined') { included = false; }


            var params = [];
            params.push({ name: 'societaId', value: societaId });
            params.push({ name: 'included', value: included });

            var data = getAllByParams('studente', 'Super_Studente_GetAllBySocieta', params);
            return $q.when(data);
        }
        

        function super_classe_getAllList(anno, societaId) {
            if (typeof (anno) == 'undefined' || anno == '' || anno == '') { anno = -1; }
            if (typeof (societaId) == 'undefined') { societaId = 0; }

            var params = [];
            params.push({ name: 'anno', value: anno });
            params.push({ name: 'societaId', value: societaId });

            var data = getAllByParams('classe', 'Super_GetAllList', params);
            return $q.when(data);
        }

        function super_classe_getAll(pageSize, page, anno, classe, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (anno) == 'undefined' || anno == '' || anno == '') { anno = -1; }
            if (typeof (classe) == 'undefined') { classe = ""; }
            if (typeof (order) == 'undefined') { order = 'id'; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'anno', value: anno });
            params.push({ name: 'classe', value: classe });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('classe', 'Super_GetAllByFilter', params);
            return $q.when(data);
        }        

        function super_classe_countAll(anno, classe) {
            if (typeof (anno) == 'undefined' || anno == '') { anno = -1; }
            if (typeof (classe) == 'undefined') { classe = ""; }

            var params = [];
            params.push({ name: 'anno', value: anno });
            params.push({ name: 'classe', value: classe });

            var data = getAllByParams('classe', 'Super_CountByFilter', params);
            return $q.when(data);
        }

        function super_risorsa_getAll(pageSize, page, anno, nominativo, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (anno) == 'undefined' || anno == '') { anno = -1; }
            if (typeof (nominativo) == 'undefined') { nominativo = ''; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'anno', value: anno });
            params.push({ name: 'nominativo', value: nominativo });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('risorsa', 'Super_GetAllByFilter', params);
            return $q.when(data);
        }

        function super_risorsa_getAllList() {
            var data = getAllNoParam('risorsa', 'Super_GetAllList');
            return $q.when(data);
        }

        function super_risorsa_countAll(anno, nominativo) {
            if (typeof (anno) == 'undefined' || anno == '') { anno = -1; }
            if (typeof (nominativo) == 'undefined') { nominativo = ''; }
            var params = [];
            params.push({ name: 'anno', value: anno });
            params.push({ name: 'nominativo', value: nominativo });

            var data = getAllByParams('risorsa', 'Super_CountByFilter', params);
            return $q.when(data);
        }    

        function super_addAccountStak(item) {
            return $http.post(urlAPI + '/Stakeholder/Super_PostAccount', item)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.info('XHR Failed super_addAccountStak: %s', message);
                    return message.status;
                });
        }

        function super_editAccountStak(item) {
            return $http.put(urlAPI + '/Stakeholder/Super_PutAccount', item)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.info('XHR Failed super_editAccountStak: %s', message);
                    return message.status;
                });
        }

        function super_materia_getAllByDocente(docenteId) {
            var data = getAllByParam('materia', 'Super_GetAllByDocente', 'docenteId', docenteId);
            return $q.when(data);
        }

        function super_materia_countByDocente(docenteId) {
            var data = getAllByParam('materia', 'Super_CountByDocente', 'docenteId', docenteId);
            return $q.when(data);
        }

        function super_materia_docenteDelete(docenteId, materiaId) {
            var objName = 'materia';
            var method = 'Super_DocenteDelete';

            if (typeof (docenteId) == 'undefined') { docenteId = 0; }
            if (typeof (materiaId) == 'undefined') { materiaId = 0; }
            var url = urlAPI + '/' + objName + '/' + method + '?docenteId=' + docenteId + '&materiaId=' + materiaId;

            return $http.delete(url)
                .then(function (response) {
                    return response.status;
                })
                .catch(function (message) {
                    console.log('XHR Failed super_materia_docenteDelete for %s: %s', objName, message);
                    return message.status;
                });
        }

        function super_materia_docenteImportList(docenteId, materie) {
            var objName = 'materia';
            var method = 'Super_DocenteImportList';

            if (typeof (docenteId) == 'undefined') { docenteId = 0; }
            if (typeof (materie) == 'undefined') { materie = []; }

            var url = urlAPI + '/' + objName + '/' + method;

            var obj = {
                docenteId: docenteId,
                materie: materie
            };

            return $http.put(url, obj)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed super_materia_docenteImportList for %s: %s', objName, message);
                    return message.status;
                });
        }

        function super_eliminazioneMigrazioneUtenteStak(vecchioUserId, nuovoUserId) {
            var objName = 'stakeholder';
            var method = 'Super_EliminazioneMigrazioneUtenteStak';

            if (typeof (vecchioUserId) == 'undefined') { vecchioUserId = 0; }
            if (typeof (nuovoUserId) == 'undefined') { nuovoUserId = 0; }

            var url = urlAPI + '/' + objName + '/' + method + '?vecchioUserId=' + vecchioUserId + '&nuovoUserId=' + nuovoUserId;

            return $http.delete(url)
                .then(function (response) {
                    return response.status;
                })
                .catch(function (message) {
                    console.log('XHR Failed Super_EliminazioneMigrazioneUtenteStak for %s: %s', objName, message);
                    return message.status;
                });
        }

        function super_accountStak_getAllByFilter(pageSize, page, bAttivo, usernameFilter, emailFilter, ruolo, stakeholderId, vecchioUserId, order) {
            if (typeof (bAttivo) == 'undefined') { bAttivo = 1; }
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (usernameFilter) == 'undefined') { usernameFilter = ''; }
            if (typeof (emailFilter) == 'undefined') { emailFilter = ''; }
            if (typeof (ruolo) == 'undefined') { ruolo = -1; }
            if (typeof (order) == 'undefined') { order = 'username'; }
            if (typeof (stakeholderId) == 'undefined') { stakeholderId = 0; }
            if (typeof (vecchioUserId) == 'undefined') { vecchioUserId = 0; }
            var params = [];
            params.push({ name: 'bAttivo', value: bAttivo });
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'usernameFilter', value: usernameFilter });
            params.push({ name: 'emailFilter', value: emailFilter });
            params.push({ name: 'ruolo', value: ruolo });
            params.push({ name: 'stakeholderId', value: stakeholderId });
            params.push({ name: 'vecchioUserId', value: vecchioUserId });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('stakeholder', 'super_accountStak_getAllByFilter', params);
            return $q.when(data);
        }
        
        
        

        // ******************************
        //  ATTACH - NUOVI METODI
        function attach_getAllList(tSourceCode, tSourceId, sourceId, tAttachId) {
            if (typeof (tSourceCode) == 'undefined') { tSourceCode = ''; }
            if (typeof (tSourceId) == 'undefined') { tSourceId = 0; }
            if (typeof (sourceId) == 'undefined') { sourceId = 0; }
            if (typeof (tAttachId) == 'undefined') { tAttachId = 0; }

            var params = [];
            params.push({ name: 'tSourceId', value: tSourceId });
            params.push({ name: 'tSourceCode', value: tSourceCode });
            params.push({ name: 'sourceId', value: sourceId });
            params.push({ name: 'tAttachId', value: tAttachId });

            var data = getAllByParams('attach', 'GetAllList', params);
            return $q.when(data);
        }

        function attach_getAll(pageSize, page, tSourceCode, tSourceId, sourceId, tAttachId, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (tSourceCode) == 'undefined') { tSourceCode = ''; }
            if (typeof (tSourceId) == 'undefined') { tSourceId = 0; }
            if (typeof (sourceId) == 'undefined') { sourceId = 0; }
            if (typeof (tAttachId) == 'undefined') { tAttachId = 0; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'tSourceId', value: tSourceId });
            params.push({ name: 'tSourceCode', value: tSourceCode });
            params.push({ name: 'sourceId', value: sourceId });
            params.push({ name: 'tAttachId', value: tAttachId });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('attach', 'GetAllByFilter', params);
            return $q.when(data);
        }


        function attach_countAll(tSourceCode, tSourceId, sourceId, tAttachId) {
            if (typeof (tSourceCode) == 'undefined') { tSourceCode = ''; }
            if (typeof (tSourceId) == 'undefined') { tSourceId = 0; }
            if (typeof (sourceId) == 'undefined') { sourceId = 0; }
            if (typeof (tAttachId) == 'undefined') { tAttachId = 0; }

            var params = [];
            params.push({ name: 'tSourceId', value: tSourceId });
            params.push({ name: 'tSourceCode', value: tSourceCode });
            params.push({ name: 'sourceId', value: sourceId });
            params.push({ name: 'tAttachId', value: tAttachId });

            var data = getAllByParams('attach', 'CountByFilter', params);
            return $q.when(data);
        }

        function attach_get(id) {
            var data = getById('attach', id);
            return $q.when(data);
        }

        function attach_add(item) {
            var data = addObj('attach', item);
            return $q.when(data);
        }

        function attach_update(item) {
            var data = updateObj('attach', item);
            return $q.when(data);
        }

        function attach_delete(id) {
            var data = deleteObj('attach', id);
            return $q.when(data);
        }

        function attach_setCompleted(id) {
            var objName = 'attach';

            return $http.put(urlAPI + '/' + objName + '/SetCompleted/' + id)
                .then(function (response) {
                    return response.status;
                })
                .catch(function (message) {
                    console.info('XHR Failed att_SetCompleted for %s: %s', objName, message);
                    return message.status;
                });
        }

        function attach_unsetCompleted(id) {
            var objName = 'attach';

            return $http.put(urlAPI + '/' + objName + '/UnsetCompleted/' + id)
                .then(function (response) {
                    return response.status;
                })
                .catch(function (message) {
                    console.info('XHR Failed att_UnsetCompleted for %s: %s', objName, message);
                    return message.status;
                });
        }

        function attach_download(tirocinioId, tirocinanteId, classeId, misura) {
            if (typeof (tirocinioId) == 'undefined') { tirocinioId = 0; }
            if (typeof (tirocinanteId) == 'undefined') { tirocinanteId = 0; }
            if (typeof (classeId) == 'undefined') { classeId = 0; }
            if (typeof (misura) == 'undefined') { misura = 0; }

            var params = [];
            params.push({ name: 'tirocinioId', value: tirocinioId });
            params.push({ name: 'tirocinanteId', value: tirocinanteId });
            params.push({ name: 'classeId', value: classeId });
            params.push({ name: 'misura', value: misura });

            var objName = 'attach';
            var actionName = 'Download';
            var url = urlAPI + '/' + objName + '/' + actionName;
            var numParams = params.length;
            if (numParams > 0) {
                url += '?'
            }

            for (var i = 0; i < numParams; i++) {
                if (i > 0) url += '&';
                url += params[i].name + '=' + params[i].value;
            }

            return $http.get(url)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.info('XHR Failed Download for %s: %s', objName, message);
                    return message.status;
                });
        }

        function attach_extract(id) {
            return $http.get(urlAPI + '/Attach/Extract/' + id)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.info('XHR Failed getById for Extract: %s', message);
                    return message.status;
                });
        }

        function upload_getURL() {
            var controller = 'Attach';
            var action = 'Upload';

            return urlAPI + '/' + controller + '/' + action + '/';
        }


        // ******************************
        //  TATTACH - NUOVI METODI
        function tAttach_getAllList(tSourceCode, tSourceId, sourceId, onlyMissing, tAttachId) {
            /*
				onlyMissing:
					1: solo mancanti
					0: tutte
					-1: sono presenti
			*/
            if (typeof (tSourceCode) == 'undefined') { tSourceCode = ''; }
            if (typeof (tSourceId) == 'undefined') { tSourceId = 0; }
            if (typeof (sourceId) == 'undefined') { sourceId = 0; }
            if (typeof (onlyMissing) == 'undefined') { onlyMissing = 0; }
            if (typeof (tAttachId) == 'undefined') { tAttachId = 0; }

            var params = [];
            params.push({ name: 'tSourceCode', value: tSourceCode });
            params.push({ name: 'tSourceId', value: tSourceId });
            params.push({ name: 'sourceId', value: sourceId });
            params.push({ name: 'onlyMissing', value: onlyMissing });
            params.push({ name: 'tAttachId', value: tAttachId });

            var data = getAllByParams('tAttach', 'GetAllList', params);
            return $q.when(data);
        }

        function tAttach_getAllModal(tSourceCode, tSourceId, sourceId, onlyMissing, order) {
            if (typeof (tSourceCode) == 'undefined') { tSourceCode = ''; }
            if (typeof (tSourceId) == 'undefined') { tSourceId = 0; }
            if (typeof (sourceId) == 'undefined') { sourceId = 0; }
            if (typeof (onlyMissing) == 'undefined') { onlyMissing = 0; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'tSourceCode', value: tSourceCode });
            params.push({ name: 'tSourceId', value: tSourceId });
            params.push({ name: 'sourceId', value: sourceId });
            params.push({ name: 'onlyMissing', value: onlyMissing });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('tAttach', 'GetAllByFilter', params);
            return $q.when(data);
        }


        function tAttach_getAll(pageSize, page, tSourceCode, tSourceId, testuale, roleId, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = 0; }
            if (typeof (page) == 'undefined') { page = 0; }
            if (typeof (tSourceCode) == 'undefined') { tSourceCode = ''; }
            if (typeof (tSourceId) == 'undefined') { tSourceId = 0; }
            if (typeof (testuale) == 'undefined') { testuale = ''; }
            if (typeof (roleId) == 'undefined') { roleId = 0; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'tSourceCode', value: tSourceCode });
            params.push({ name: 'tSourceId', value: tSourceId });
            params.push({ name: 'testuale', value: testuale });
            params.push({ name: 'roleId', value: roleId });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('tAttach', 'GetAllWithoutVisibility', params);
            return $q.when(data);
        }

        function tAttach_countAll(tSourceCode, tSourceId, testuale, roleId) {
            if (typeof (tSourceCode) == 'undefined') { tSourceCode = ''; }
            if (typeof (tSourceId) == 'undefined') { tSourceId = 0; }
            if (typeof (testuale) == 'undefined') { testuale = 0; }
            if (typeof (roleId) == 'undefined') { roleId = 0; }

            var params = [];
            params.push({ name: 'tSourceCode', value: tSourceCode });
            params.push({ name: 'tSourceId', value: tSourceId });
            params.push({ name: 'testuale', value: testuale });
            params.push({ name: 'roleId', value: roleId });

            var data = getAllByParams('tAttach', 'CountWithoutVisibility', params);
            return $q.when(data);
        }


        function tAttach_get(id) {
            var data = getById('tAttach', id);
            return $q.when(data);
        }

        function tAttach_add(item) {
            var data = addObj('tAttach', item);
            return $q.when(data);
        }

        function tAttach_update(item) {
            var data = updateObj('tAttach', item);
            return $q.when(data);
        }

        function tAttach_delete(id) {
            var data = deleteObj('tAttach', id);
            return $q.when(data);
        }

        // ******************************
        //  TATTACHVISIBILITY - NUOVI METODI

        function tAttachVisibility_getAuth(tSourceCode) {
            if (typeof (tSourceCode) == 'undefined') { tSourceCode = ''; }

            var params = [];
            params.push({ name: 'tSourceCode', value: tSourceCode });

            var data = getAllByParams('TAttach', 'TAttachVisibility_GetAuth', params);
            return $q.when(data);
        }

        function tAttachVisibility_getAll(tAttachId, roleId) {
            if (typeof (tAttachId) == 'undefined') { tAttachId = 0; }
            if (typeof (roleId) == 'undefined') { roleId = 0; }

            var params = [];
            params.push({ name: 'tAttachId', value: tAttachId });
            params.push({ name: 'roleId', value: roleId });

            var data = getAllByParams('TAttach', 'TAttachVisibility_GetAllByFilter', params);
            return $q.when(data);
        }

        function tAttachVisibility_add(item) {
            return $http.post(urlAPI + '/TAttach/TAttachVisibility_Add', item)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.info('XHR Failed tAttachVisibility_add for TAttach: %s', message);
                    return message.status;
                });

        }

        function tAttachVisibility_update(item) {
            return $http.put(urlAPI + '/TAttach/TAttachVisibility_Update', item)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.info('XHR Failed tAttachVisibility_update for TAttach: %s', message);
                    return message.status;
                });

        }

        function tAttachVisibility_delete(id) {
            return $http.delete(urlAPI + '/TAttach/TAttachVisibility_Delete/' + id)
                .then(function (response) {
                    return response.status;
                })
                .catch(function (message) {
                    console.info('XHR Failed deleteObj for TAttach: %s', message);
                    return message.status;
                });
        }

        // ******************************
        //  TATTACHFILETYPE - NUOVI METODI

        function tAttachFileType_getAll(tAttachId, title, extension) {
            if (typeof (tAttachId) == 'undefined') { tAttachId = 0; }
            if (typeof (title) == 'undefined') { title = ''; }
            if (typeof (extension) == 'undefined') { extension = ''; }

            var params = [];
            params.push({ name: 'tAttachId', value: tAttachId });
            params.push({ name: 'title', value: title });
            params.push({ name: 'extension', value: extension });

            var data = getAllByParams('TAttach', 'TAttachFileType_GetAllByFilter', params);
            return $q.when(data);
        }

        function tAttachFileType_add(item) {
            return $http.post(urlAPI + '/TAttach/TAttachFileType_Add', item)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.info('XHR Failed TAttachFileType_Add for TAttach: %s', message);
                    return message.status;
                });

        }

        function tAttachFileType_update(item) {
            return $http.put(urlAPI + '/TAttach/TAttachFileType_Update_Update', item)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.info('XHR Failed TAttachFileType_Update for TAttach: %s', message);
                    return message.status;
                });

        }

        function tAttachFileType_delete(id) {
            return $http.delete(urlAPI + '/TAttach/TAttachFileType_Delete/' + id)
                .then(function (response) {
                    return response.status;
                })
                .catch(function (message) {
                    console.info('XHR Failed deleteObj for TAttachFileType: %s', message);
                    return message.status;
                });
        }


        // ******************************
        //  TSOURCE - NUOVI METODI
        function tSource_getAllList() {

            var data = getAllList('tSource');
            return $q.when(data);
        }

        function tSource_getAll(order) {
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: 0 });
            params.push({ name: 'page', value: 0 });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('tSource', 'GetAllByFilter', params);
            return $q.when(data);
        }

        function tSource_get(id) {
            var data = getById('tSource', id);
            return $q.when(data);
        }

        function tSource_getByCode(code) {
            var data = getAllByParam('tSource', 'GetByCode', 'code', code);
            return $q.when(data);
        }


        /*     
		function tSource_countAll() {
				var params = [];
				var data = getAllByParams('tSource', 'CountByFilter', params);
				return $q.when(data);
			}




			function tSource_add(item) {
				var data = addObj('tSource', item);
				return $q.when(data);
			}

			function tSource_update(item) {
				var data = updateObj('tSource', item);
				return $q.when(data);
			}

			function tSource_delete(id) {
				var data = deleteObj('tSource', id);
				return $q.when(data);
			}
			*/



        // ******************************
        //  USER
        function user_getAll(pageSize, page, bAttivo, username, email, societaId, ruolo, order) {
            if (typeof (bAttivo) == 'undefined') { bAttivo = 1; }
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (username) == 'undefined') { username = ''; }
            if (typeof (email) == 'undefined') { email = ''; }
            if (typeof (ruolo) == 'undefined') { ruolo = ''; }
            if (typeof (order) == 'undefined') { order = 'alfabetico'; }
            if (typeof (societaId) == 'undefined') { societaId = 0; }
            var params = [];
            params.push({ name: 'bAttivo', value: bAttivo });
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'username', value: username });
            params.push({ name: 'email', value: email });
            params.push({ name: 'societaId', value: societaId });
            params.push({ name: 'ruolo', value: ruolo });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('user', 'GetAllByFilter', params);
            return $q.when(data);
        }

        function user_countAll(bAttivo, username, email, societaId, ruolo) {
            if (typeof (bAttivo) == 'undefined') { bAttivo = 1; }
            if (typeof (username) == 'undefined') { username = ''; }
            if (typeof (email) == 'undefined') { email = 0; }
            if (typeof (societaId) == 'undefined') { societaId = 0; }
            if (typeof (ruolo) == 'undefined') { ruolo = ''; }
            var params = [];
            params.push({ name: 'bAttivo', value: bAttivo });
            params.push({ name: 'username', value: username });
            params.push({ name: 'email', value: email });
            params.push({ name: 'societaId', value: societaId });
            params.push({ name: 'ruolo', value: ruolo });

            var data = getAllByParams('user', 'CountByFilter', params);
            return $q.when(data);
        }

        //metodo per il recupero della lista di Username per allievi e docenti
        function user_getAllUsernames(societaId) {
            var data = getAllByParam('user', 'GetAllUsernames', 'societaId', societaId);
            return $q.when(data);
        }

        function user_get(id) {
            var data = getById('user', id);
            return $q.when(data);
        }

        function user_getByUsername(username) {
            var data = getAllByParam('user', 'GetByUsername', 'username', username);
            return $q.when(data);
        }

        function user_add(item) {
            var data = addObj('user', item);
            return $q.when(data);
        }

        function user_update(item) {
            var data = updateObj('user', item);
            return $q.when(data);
        }

        function user_activate(id) {
            var url = urlAPI + '/user/activate?id=' + id;
            return $http.post(url)
                        .then(function (response) {
                            return response.data;
                        })
                        .catch(function (message) {
                            console.log('XHR Failed activate for user: %s', message);
                            return message.status;
                        });
        }

        function user_deactivate(id) {
            var url = urlAPI + '/user/deactivate?id=' + id;
            return $http.post(url)
                        .then(function (response) {
                            return response.data;
                        })
                        .catch(function (message) {
                            console.log('XHR Failed deactivate for user: %s', message);
                            return message.status;
                        });
        }

        function user_resetPassword(email) {
            var url = urlAPI + '/user/resetpassword?email=' + email;
            return $http.post(url)
                        .then(function (response) {
                            return response.status;
                        })
                        .catch(function (message) {
                            console.log('XHR Failed Reset Password for user: %s', message);
                            return message.status;
                        });
        }

        function user_invioCredenziali(email) {
            var url = urlAPI + '/user/invioCredenziali?email=' + email;
            return $http.post(url)
                .then(function (response) {
                    return response.status;
                })
                .catch(function (message) {
                    console.log('XHR Failed Reset Password for user: %s', message);
                    return message.status;
                });
        }

        function user_delete(id) {
            var data = deleteObj('user', id);
            return $q.when(data);
        }

        function user_suggestUserame(nome, cognome) {
            if (typeof (nome) == 'undefined') { nome = ""; }
            if (typeof (cognome) == 'undefined') { cognome = "" }
            var params = [];
            params.push({ name: 'nome', value: nome });
            params.push({ name: 'cognome', value: cognome });

            var data = getAllByParams('user', 'SuggestUsername', params);
            return $q.when(data);
        }

        function user_suggestPassword(nome) {
            if (typeof (nome) == 'undefined') { nome = ""; }
            var params = [];
            params.push({ name: 'nome', value: nome });

            var data = getAllByParams('user', 'SuggestPassword', params);
            return $q.when(data);
        }        

        function user_setPassword(username, password) {
            if (typeof (username) == 'undefined') { username = ""; }
            if (typeof (password) == 'undefined') { password = ""; }

            var objName = 'user';
            var actionName = 'SetPassword';
            return $http.put(urlAPI + '/' + objName + '/' + actionName + '?username=' + username + '&password=' + password)
                .then(function (response) {
                    return response.status;
                })
                .catch(function (message) {
                    console.info('XHR Failed user_setPassword: %s', message);
                    return message.status;
                });
        }

        // ******************************
        //  ROLE  
        function role_getAllList() {
            var objName = 'user';
            var actionName = 'GetAllListRoles';
            return $http.get(urlAPI + '/' + objName + '/' + actionName)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.info('XHR Failed getAllList for %s: %s', objName, message);
                    return message.status;
                });
        }

        function role_getAll() {
            var objName = 'user';
            var actionName = 'GetAllRoles';
            var url = urlAPI + '/' + objName + '/' + actionName;

            return $http.get(url)
                        .then(function (response) {
                            return response.data;
                        })
                        .catch(function (message) {
                            console.log('XHR Failed getAll for %s: %s', objName, message);
                            return message.status;
                        });
        }

        function role_get(id) {
            var objName = 'user';
            var actionName = 'GetRole';
            var url = urlAPI + '/' + objName + '/' + actionName + '/' + id;

            return $http.get(url)
                        .then(function (response) {
                            return response.data;
                        })
                        .catch(function (message) {
                            console.log('XHR Failed getAll for %s: %s', objName, message);
                            return message.status;
                        });
        }

        // ******************************
        //  USER ROLE  
        function userRole_getAll(id) {
            var objName = 'user';
            var actionName = 'GetUserRoles';
            var url = urlAPI + '/' + objName + '/' + actionName + '/' + id;

            return $http.get(url)
                        .then(function (response) {
                            return response.data;
                        })
                        .catch(function (message) {
                            console.log('XHR Failed getAll for %s: %s', objName, message);
                            return message.status;
                        });
        }

        function userRole_add(risorsaId, roleId) {
            if (typeof (risorsaId) == 'undefined') { risorsaId = 0; }
            if (typeof (roleId) == 'undefined') { roleId = 0; }

            var params = [];
            params.push({ name: 'risorsaId', value: risorsaId });
            params.push({ name: 'roleId', value: roleId });

            var objName = 'user';
            var actionName = 'AddUserRole';
            var url = urlAPI + '/' + objName + '/' + actionName;
            var numParams = params.length;
            if (numParams > 0) {
                url += '?'
            }

            for (var i = 0; i < numParams; i++) {
                if (i > 0) url += '&';
                url += params[i].name + '=' + params[i].value;

            }
            return $http.post(url)
                        .then(function (response) {
                            return response.data;
                        })
                        .catch(function (message) {
                            console.log('XHR Failed addObj for %s: %s', objName, message);
                            return message.status;
                        });

        }

        function userRole_delete(risorsaId, roleId) {
            if (typeof (risorsaId) == 'undefined') { risorsaId = 0; }
            if (typeof (roleId) == 'undefined') { roleId = 0; }

            var params = [];
            params.push({ name: 'risorsaId', value: risorsaId });
            params.push({ name: 'roleId', value: roleId });

            var objName = 'user';
            var actionName = 'DeleteUserRole';
            var url = urlAPI + '/' + objName + '/' + actionName;
            var numParams = params.length;
            if (numParams > 0) {
                url += '?'
            }

            for (var i = 0; i < numParams; i++) {
                if (i > 0) url += '&';
                url += params[i].name + '=' + params[i].value;
            }

            return $http.delete(url)
            .then(function (response) {
                return response.status;
            })
            .catch(function (message) {
                console.log('XHR Failed deleteObj for %s: %s', objName, message);
                return message.status;
            });
        }

        // AUTHORIZATION
      /*
        function authorization_get(area) {
            if (typeof (area) == 'undefined') { area = ''; }

            var params = [];
            params.push({ name: 'area', value: area });

            var data = getAllByParams('user', 'GetAuthorization', params);
            return $q.when(data);

            //
			//var objName = 'user';
			//var actionName = 'GetAuthorization';
			//var url = urlAPI + '/' + objName + '/' + actionName;
			//var numParams = params.length;
			//if (numParams > 0) {
			//	url += '?'
			//}

			//for (var i = 0; i < numParams; i++) {
			//	if (i > 0) url += '&';
			//	url += params[i].name + '=' + params[i].value;
			//}

			//return $http.get(url)
			//							.then(function (response) {
			//								return response.data;
			//							})
			//							.catch(function (message) {
			//								console.info('XHR Failed authorization_get for %s: %s', objName, message);
			//								return message.status;
			//							});
            // 
        }

        function authorization_getAllByFilter(pageSize, page, userId, roleId, areaId, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = 0; }
            if (typeof (page) == 'undefined') { page = 0; }
            if (typeof (userId) == 'undefined') { userId = 0; }
            if (typeof (roleId) == 'undefined') { roleId = 0; }
            if (typeof (areaId) == 'undefined') { areaId = -1; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'userId', value: userId });
            params.push({ name: 'roleId', value: roleId });
            params.push({ name: 'areaId', value: areaId });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('user', 'Auth_GetAllByFilter', params);
            return $q.when(data);

            //
		    //var url = urlAPI + '/' + objName + '/' + actionName;
		    //var numParams = params.length;
		    //if (numParams > 0) {
		    //    url += '?'
		    //}

		    //for (var i = 0; i < numParams; i++) {
		    //    if (i > 0) url += '&';
		    //    url += params[i].name + '=' + params[i].value;
		    //}

		    //return $http.get(url)
			//							.then(function (response) {
			//							    return response.data;
			//							})
			//							.catch(function (message) {
			//							    console.info('XHR Failed authorization_getAllByFilter for %s: %s', objName, message);
			//							    return message.status;
			//							});
            //                          
        }

        function authorization_countAllByFilter(userId, roleId, areaId) {
            if (typeof (userId) == 'undefined') { userId = 0; }
            if (typeof (roleId) == 'undefined') { roleId = 0; }
            if (typeof (areaId) == 'undefined') { areaId = -1; }

            var params = [];
            params.push({ name: 'userId', value: userId });
            params.push({ name: 'roleId', value: roleId });
            params.push({ name: 'areaId', value: areaId });

            var data = getAllByParams('user', 'Auth_CountAllByFilter', params);
            return $q.when(data);

        //    
		//    var objName = 'user';
		//    var actionName = 'Auth_CountAllByFilter';
		//    var url = urlAPI + '/' + objName + '/' + actionName;
		//    var numParams = params.length;
		//    if (numParams > 0) {
		//        url += '?'
		//    }

		//    for (var i = 0; i < numParams; i++) {
		//        if (i > 0) url += '&';
		//        url += params[i].name + '=' + params[i].value;
		//    }

		//    return $http.get(url)
		//								.then(function (response) {
		//								    return response.data;
		//								})
		//								.catch(function (message) {
		//								    console.info('XHR Failed authorization_countAllByFilter for %s: %s', objName, message);
		//								    return message.status;
		//								});
        //                              
        }

        function authorization_getById(id) {
            if (typeof (id) == 'undefined') { id = 0; }

            var params = [];
            params.push({ name: 'id', value: id });

            var data = getAllByParams('user', 'Auth_Get', params);
            return $q.when(data);

            //
		    //var objName = 'user';
		    //var actionName = 'Auth_Get';
		    //var url = urlAPI + '/' + objName + '/' + actionName;
		    //var numParams = params.length;
		    //if (numParams > 0) {
		    //    url += '?'
		    //}

		    //for (var i = 0; i < numParams; i++) {
		    //    if (i > 0) url += '&';
		    //    url += params[i].name + '=' + params[i].value;
		    //}

		    //return $http.get(url)
			//							.then(function (response) {
			//							    return response.data;
			//							})
			//							.catch(function (message) {
			//							    console.info('XHR Failed authorization_getById for %s: %s', objName, message);
			//							    return message.status;
			//							});
            //
        }

        //
		//function authorization_getAllByUser(userId) {
		//    if (typeof (userId) == 'undefined') { userId = 0; }

		//    var params = [];
		//    params.push({ name: 'userId', value: userId });

		//    var data = getAllByParams('user', 'Auth_GetAllByUser', params);
		//    return $q.when(data);

            
		//    var objName = 'user';
		//    var actionName = 'Auth_GetAllByUser';
		//    var url = urlAPI + '/' + objName + '/' + actionName;
		//    var numParams = params.length;
		//    if (numParams > 0) {
		//        url += '?'
		//    }

		//    for (var i = 0; i < numParams; i++) {
		//        if (i > 0) url += '&';
		//        url += params[i].name + '=' + params[i].value;
		//    }

		//    return $http.get(url)
		//				.then(function (response) {
		//					return response.data;
		//				})
		//				.catch(function (message) {
		//					console.info('XHR Failed authorization_getAllByUser for %s: %s', objName, message);
		//					return message.status;
		//				});
                    
		//}
        //

        function authorization_getAllByUser(userId) {
            if (typeof (userId) == 'undefined') { userId = 0; }

            var params = [];
            params.push({ name: 'userId', value: userId });

            var data = getAllByParams('user', 'Auth_GetAllByUser', params);
            return $q.when(data);
        }

        function authorization_add(item) {
            var objName = 'user';
            var actionName = 'Auth_Post';

            return $http.post(urlAPI + '/' + objName + '/' + actionName, item)
										.then(function (response) {
										    return response.data;
										})
										.catch(function (message) {
										    console.info('XHR Failed authorization_add for %s: %s', objName, message);
										    return message.status;
										});
        }

        function authorization_update(item) {
            var objName = 'user';
            var actionName = 'Auth_Put';

            return $http.put(urlAPI + '/' + objName + '/' + actionName, item)
										.then(function (response) {
										    return response.data;
										})
										.catch(function (message) {
										    console.info('XHR Failed authorization_update for %s: %s', objName, message);
										    return message.status;
										});
        }

        function authorization_delete(id) {
            var objName = 'user';
            var actionName = 'Auth_Delete';
            return $http.delete(urlAPI + '/' + objName + '/' + actionName + '/' + id)
										.then(function (response) {
										    return response.status;
										})
										.catch(function (message) {
										    console.info('XHR Failed authorization_delete for %s: %s', objName, message);
										    return message.status;
										});
        }
        */

        //------------------------------------------------------------------
        //-- EDUP
        //------------------------------------------------------------------

        //-- TEST
        function test_getAllList() {
            var data = getAllList('test');
            return $q.when(data);
        }

        function test_getAllListExclude(testId) {
            var objName = 'test';
            if (typeof (testId) == 'undefined') { testId = 0; }

            return $http.get(urlAPI + '/' + objName + '/GetAllListExclude?testId=' + testId)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed GetAllListExclude for %s: %s', objName, message);
                    return message.status;
                });
        }

        function test_count() {
            var data = getAllByParams('test', 'Count');
            return $q.when(data);
        }

        function test_countByFilter(stato, testo, classeId, testStudenti) {
            if (typeof (stato) == 'undefined') { stato = 0; }
            if (typeof (testo) == 'undefined') { testo = ''; }
            if (typeof (classeId) == 'undefined') { classeId = 0; }            
            if (typeof (testStudenti) == 'undefined') { testStudenti = -1; }
            var params = [];
            params.push({ name: 'stato', value: stato });
            params.push({ name: 'testo', value: testo });
            params.push({ name: 'classeId', value: classeId });            
            params.push({ name: 'testStudenti', value: testStudenti });

            var data = getAllByParams('test', 'CountByFilter', params);
            return $q.when(data);
        }

        function test_getAllByFilter(pageSize, page, stato, testo, classeId, testStudenti, order) {            
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (stato) == 'undefined') { stato = 0; }
            if (typeof (testo) == 'undefined') { testo = ''; }
            if (typeof (classeId) == 'undefined') { classeId = 0; }            
            if (typeof (testStudenti) == 'undefined') { testStudenti = -1; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'stato', value: stato });
            params.push({ name: 'testo', value: testo });
            params.push({ name: 'classeId', value: classeId });            
            params.push({ name: 'testStudenti', value: testStudenti });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('test', 'GetAllByFilter', params);
            return $q.when(data);
        }

        function testDocentiAllievi_countByFilter(stato, testo, classeId, testStudenti, tipologia) {
            if (typeof (stato) == 'undefined') { stato = 0; }
            if (typeof (testo) == 'undefined') { testo = ''; }
            if (typeof (classeId) == 'undefined') { classeId = 0; }
            if (typeof (testStudenti) == 'undefined') { testStudenti = -1; }
            if (typeof (tipologia) == 'undefined') { tipologia = 0; }

            var params = [];
            params.push({ name: 'stato', value: stato });
            params.push({ name: 'testo', value: testo });
            params.push({ name: 'classeId', value: classeId });
            params.push({ name: 'testStudenti', value: testStudenti });
            params.push({ name: 'tipologia', value: tipologia });

            var data = getAllByParams('test', 'TestDocentiAllievi_CountByFilter', params);
            return $q.when(data);
        }

        function testDocentiAllievi_getAllByFilter(pageSize, page, stato, testo, classeId, testStudenti, tipologia, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (stato) == 'undefined') { stato = 0; }
            if (typeof (testo) == 'undefined') { testo = ''; }
            if (typeof (classeId) == 'undefined') { classeId = 0; }
            if (typeof (testStudenti) == 'undefined') { testStudenti = -1; }
            if (typeof (tipologia) == 'undefined') { tipologia = 0; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'stato', value: stato });
            params.push({ name: 'testo', value: testo });
            params.push({ name: 'classeId', value: classeId });
            params.push({ name: 'testStudenti', value: testStudenti });
            params.push({ name: 'tipologia', value: tipologia });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('test', 'TestDocentiAllievi_GetAllByFilter', params);
            return $q.when(data);
        }

        function asl_test_getAll(pageSize, page, ricerca, statusCode, testStudenti, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }
            if (typeof (statusCode) == 'undefined') { statusCode = -1; }
            if (typeof (testStudenti) == 'undefined') { testStudenti = -1; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'ricerca', value: ricerca });
            params.push({ name: 'statusCode', value: statusCode });
            params.push({ name: 'testStudenti', value: testStudenti });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('test', 'ASL_GetAllByFilter', params);
            return $q.when(data);
        }

        function asl_test_countAll(ricerca, statusCode, testStudenti) {
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }
            if (typeof (statusCode) == 'undefined') { statusCode = -1; }
            if (typeof (testStudenti) == 'undefined') { testStudenti = -1; }
            var params = [];
            params.push({ name: 'ricerca', value: ricerca });
            params.push({ name: 'statusCode', value: statusCode });
            params.push({ name: 'testStudenti', value: testStudenti });

            var data = getAllByParams('test', 'ASL_CountByFilter', params);
            return $q.when(data);
        }

        function testColleghi_countByFilter(testo) {            
            if (typeof (testo) == 'undefined') { testo = ''; }
            var params = [];            
            params.push({ name: 'testo', value: testo });
            
            var data = getAllByParams('test', 'CountColleghi', params);
            return $q.when(data);
        }

        function testColleghi_getAllByFilter(pageSize, page, testo, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (testo) == 'undefined') { testo = ''; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'testo', value: testo });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('test', 'GetAllColleghi', params);
            return $q.when(data);
        }

        function testIstituto_countByFilter(testo, tipologia) {
            if (typeof (testo) == 'undefined') { testo = ''; }
            if (typeof (tipologia) == 'undefined') { tipologia = 0; }

            var params = [];
            params.push({ name: 'testo', value: testo });
            params.push({ name: 'tipologia', value: tipologia });

            var data = getAllByParams('test', 'CountIstituto', params);
            return $q.when(data);
        }

        function testIstituto_getAllByFilter(pageSize, page, testo, tipologia, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (testo) == 'undefined') { testo = ''; }
            if (typeof (tipologia) == 'undefined') { tipologia = 0; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'testo', value: testo });
            params.push({ name: 'tipologia', value: tipologia });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('test', 'GetAllIstituto', params);
            return $q.when(data);
        }

        function testCommunity_countByFilter(testo, tipologia) {
            if (typeof (testo) == 'undefined') { testo = ''; }
            if (typeof (tipologia) == 'undefined') { tipologia = 0; }

            var params = [];
            params.push({ name: 'testo', value: testo });
            params.push({ name: 'tipologia', value: tipologia });

            var data = getAllByParams('test', 'CountCommunity', params);
            return $q.when(data);
        }

        function testCommunity_getAllByFilter(pageSize, page, testo, tipologia, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (testo) == 'undefined') { testo = ''; }
            if (typeof (tipologia) == 'undefined') { tipologia = 0; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'testo', value: testo });
            params.push({ name: 'tipologia', value: tipologia });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('test', 'GetAllCommunity', params);
            return $q.when(data);
        }

        function testAllieviCondivisi_countByFilter(testo, tipologia) {
            if (typeof (testo) == 'undefined') { testo = ''; }
            if (typeof (tipologia) == 'undefined') { tipologia = 0; }

            var params = [];
            params.push({ name: 'testo', value: testo });
            params.push({ name: 'tipologia', value: tipologia });

            var data = getAllByParams('test', 'CountAllieviCondivisi', params);
            return $q.when(data);
        }

        function testAllieviCondivisi_getAllByFilter(pageSize, page, testo, tipologia, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (testo) == 'undefined') { testo = ''; }
            if (typeof (tipologia) == 'undefined') { tipologia = 0; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'testo', value: testo });
            params.push({ name: 'tipologia', value: tipologia });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('test', 'GetAllAllieviCondivisi', params);
            return $q.when(data);
        }

        function testCondivisi_countByFilter(testo, tipologia, community) {
            if (typeof (testo) == 'undefined') { testo = ''; }
            if (typeof (tipologia) == 'undefined') { tipologia = 0; }
            if (typeof (community) == 'undefined') { community = false; }

            var params = [];
            params.push({ name: 'testo', value: testo });
            params.push({ name: 'tipologia', value: tipologia });
            params.push({ name: 'community', value: community });

            var data = getAllByParams('test', 'CountTestCondivisi', params);
            return $q.when(data);
        }

        function testCondivisi_getAllByFilter(pageSize, page, testo, tipologia, community, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (testo) == 'undefined') { testo = ''; }
            if (typeof (tipologia) == 'undefined') { tipologia = 0; }
            if (typeof (community) == 'undefined') { community = false; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'testo', value: testo });
            params.push({ name: 'tipologia', value: tipologia });
            params.push({ name: 'community', value: community });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('test', 'GetAllTestCondivisi', params);
            return $q.when(data);
        }

        function testAcquistati_countByFilter(testo) {
            if (typeof (testo) == 'undefined') { testo = ''; }
            var params = [];
            params.push({ name: 'testo', value: testo });

            var data = getAllByParams('test', 'CountTestAcquistati', params);
            return $q.when(data);
        }

        function testAcquistati_getAllByFilter(pageSize, page, testo, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (testo) == 'undefined') { testo = ''; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'testo', value: testo });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('test', 'GetAllTestAcquistati', params);
            return $q.when(data);
        }

        function testAcquistati_get(id) {
            return $http.get(urlAPI + '/Test/GetTestAcquistato/' + id)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed testAcquistati_get: %s', message);
                    if (message.status == 401) {
                        $location.path('/logout');
                    }
                    return message.status;
                });
        }

        function test_get(id) {
            var data = getById('test', id);
            return $q.when(data);
        }

        function test_update(item) {
            var data = updateObj('Test', item);
            return $q.when(data);
        }

        function test_delete(id) {
            var data = deleteObj('test', id);
            return $q.when(data);
        }


        function test_add(item) {
            var data = addObj('test', item);
            return $q.when(data);
        }

        function test_sendForVerify(item) {
            return $http.put(urlAPI + '/test/sendForVerify', item)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed test_sendForVerify: %s', message);
                    return message.status;
                });
        }

        function test_accept(item) {
            return $http.put(urlAPI + '/test/accept', item)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed test_accept: %s', message);
                    return message.status;
                });
        }
        function test_reject(item) {
            return $http.put(urlAPI + '/test/reject', item)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed test_reject: %s', message);
                    return message.status;
                });
        }
        function test_modify(item) {
            return $http.put(urlAPI + '/test/modify', item)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed test_modify: %s', message);
                    return message.status;
                });
        }
        function test_setCommunity(id, value) {
            return $http.put(urlAPI + '/test/SetCommunity?testId=' + id + '&value=' + value)
                .then(function (response) {
                    return response.status;
                })
                .catch(function (message) {
                    console.log('XHR Failed test_setCommunity: %s', message);
                    return message.status;
                });
        }

        function test_setIstitutoShare(id, value) {
            return $http.put(urlAPI + '/test/SetIstitutoShare?testId=' + id + '&value=' + value)
                .then(function (response) {
                    return response.status;
                })
                .catch(function (message) {
                    console.log('XHR Failed test_setIstitutoShare: %s', message);
                    return message.status;
                });
        }

        //-- question
        /*function question_getAllList() {
            var data = getAllList('question');
            return $q.when(data);
        }*/

        function question_getAllListInTest(testId) {
            var objName = 'question';
            if (typeof (testId) == 'undefined') { testId = 0; }

            return $http.get(urlAPI + '/' + objName + '/GetAllListInTest?testId=' + testId)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed getAllList for %s: %s', objName, message);
                    return message.status;
                });
        }

        function question_getAllListNotInTest(testId) {
            var objName = 'question';
            if (typeof (testId) == 'undefined') { testId = 0; }

            return $http.get(urlAPI + '/' + objName + '/GetAllListNotInTest?testId=' + testId)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed getAllList for %s: %s', objName, message);
                    return message.status;
                });
        }

        function question_count() {
            var data = getAllByParams('question', 'Count');
            return $q.when(data);
        }

        function question_countByFilter(testo) {
            if (typeof (testo) == 'undefined') { testo = ''; }
            var params = [];
            params.push({ name: 'testo', value: testo });

            var data = getAllByParams('question', 'CountByFilter', params);
            return $q.when(data);
        }

        function question_getAll() {
            var data = getAllNoParam('question', 'getAll');
            return $q.when(data);
        }

        function question_getAllByFilter(pageSize, page, testo, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (testo) == 'undefined') { testo = ''; }
            if (typeof (order) == 'undefined') { order = 'id'; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'testo', value: testo });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('question', 'GetAllByFilter', params);
            return $q.when(data);
        }

        function question_getAllByTest(testId, order) {
            if (typeof (testId) == 'undefined') { testId = 0; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'testId', value: testId });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('question', 'getAllByTest', params);
            return $q.when(data);
        }

        function question_get(id) {
            var data = getById('question', id);
            return $q.when(data);
        }

        function question_getWithRandomChoices(id) {            
            return $http.get(urlAPI + '/question/GetWithRandomChoices/' + id)
                .then(function (response) {                    
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed question_getWithRandomChoices: %s', message);
                    if (message.status == 401) {
                        $location.path('/logout');
                    }
                    return message.status;
                });
        }	

        function question_update(item) {
            var data = updateObj('question', item);
            return $q.when(data);
        }

        function question_delete(id) {
            var data = deleteObj('question', id);
            return $q.when(data);
        }

        function question_add(item) {
            var data = addObj('question', item);
            return $q.when(data);
        }

        function question_addToTest(item, testId) {
            var objName = 'questionTest';
            var method = 'AddQuestionToTest';

            if (typeof (testId) == 'undefined') { testId = 0; }
            if (typeof (item) == 'undefined') { item = {}; }

            var url = urlAPI + '/' + objName + '/' + method;

            item.testId = testId;


            return $http.post(url, item)
              .then(function (response) {
                  return response.data;
              })
              .catch(function (message) {
                  console.log('XHR Failed question_addToTest for %s: %s', objName, message);
                  return message.status;
              });

            /*
            return addObj('question', item).then(function (data) {
                return questionTest_addByParams(testId, data.Id).then(function (data2) {
                });
                /*
                var data2 = questionTest_addByParams(testId, data.Id);
                var dataUnion = {};
                dataUnion.question = data;
                dataUnion.questionTest = data2;
                return $q.when(dataUnion);
                //
            });
            */
        }



        function question_upload(filename, file) {
            var objName = 'question';
            var method = 'Upload';

            if (typeof (filename) == 'undefined') { filename = ''; }
            if (typeof (file) == 'undefined') { file = {}; }

            var url = urlAPI + '/' + objName + '/' + method;

            var item = {};
            item.filename = filename;
            item.file = file;


            return $http.post(url, item)
              .then(function (response) {
                  return response.data;
              })
              .catch(function (message) {
                  console.log('XHR Failed question_upload for %s: %s', objName, message);
                  return message.status;
              });

        }


        function question_deleteFiles(filesList) {
            var objName = 'question';
            if (typeof (filesList) == 'undefined') { filesList = []; }

            var obj = {
                filesList: filesList
            }

            var url = urlAPI + '/' + objName + '/DeleteFiles';
            return $http.put(url, obj)
              .then(function (response) {
                  return response.data;
              })
              .catch(function (message) {
                  console.log('XHR Failed DeleteFiles for %s: %s', objName, message);
                  return message.status;
              });

        }

        //-- choice
        function choice_getAllList() {
            var data = getAllList('choice');
            return $q.when(data);
        }

        function choice_count() {
            var data = getAllByParams('choice', 'Count');
            return $q.when(data);
        }

        function choice_countByFilter(testo) {
            if (typeof (testo) == 'undefined') { testo = ''; }
            var params = [];
            params.push({ name: 'testo', value: testo });

            var data = getAllByParams('choice', 'CountByFilter', params);
            return $q.when(data);
        }

        function choice_getAll() {
            var data = getAllNoParam('choice', 'getAll');
            return $q.when(data);
        }

        function choice_getAllByQuestion(questionId, order) {
            if (typeof (questionId) == 'undefined') { questionId = 0; }
            if (typeof (order) == 'undefined') { order = 'id'; }

            var params = [];
            params.push({ name: 'questionId', value: questionId });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('choice', 'getAllByQuestion', params);
            return $q.when(data);
        }

        function choice_get(id) {
            var data = getById('choice', id);
            return $q.when(data);
        }

        function choice_add(item) {
            var data = addObj('choice', item);
            return $q.when(data);
        }

        function choice_upload(filename, file) {
            var objName = 'choice';
            var method = 'Upload';

            if (typeof (filename) == 'undefined') { filename = ''; }
            if (typeof (file) == 'undefined') { file = {}; }

            var url = urlAPI + '/' + objName + '/' + method;

            var item = {};
            item.filename = filename;
            item.file = file;


            return $http.post(url, item)
                                    .then(function (response) {
                                        return response.data;
                                    })
                                    .catch(function (message) {
                                        console.log('XHR Failed choice_upload for %s: %s', objName, message);
                                        return message.status;
                                    });

        }

        function choice_update(item) {
            var data = updateObj('choice', item);
            return $q.when(data);
        }

        function choice_delete(id) {
            var data = deleteObj('choice', id);
            return $q.when(data);
        }

        //-- questionTest
        function questionTest_getAllList(testId) {
            var objName = 'questionTest';
            var action = 'GetAllList';
            if (typeof (testId) == 'undefined') { testId = 0; }

            return $http.get(urlAPI + '/' + objName + '/' + action + '/' + testId)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed getAllList for %s: %s', objName, message);
                    return message.status;
                });
        }

        function questionTest_countByTest(testId) {
            if (typeof (testId) == 'undefined') { testId = ''; }
            
            var params = [];
            params.push({ name: 'testId', value: testId });            

            var data = getAllByParams('QuestionTest', 'CountByTest', params);
            return $q.when(data);
        }

        function questionTest_getAllByTest(testId, order) {
            if (typeof (testId) == 'undefined') { testId = 0; }            
            if (typeof (order) == 'undefined') { order = 'id'; }

            var params = [];
            params.push({ name: 'testId', value: testId });            
            params.push({ name: 'order', value: order });

            var data = getAllByParams('questionTest', 'getAllByTest', params);
            return $q.when(data);
        }

        function questionTest_getAllByQuestion(testId, questionId, order) {
            if (typeof (testId) == 'undefined') { testId = 0; }
            if (typeof (questionId) == 'undefined') { questionId = 0; }
            if (typeof (order) == 'undefined') { order = 'id'; }

            var params = [];
            params.push({ name: 'testId', value: testId });
            params.push({ name: 'questionId', value: questionId });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('questionTest', 'getAllByQuestion', params);
            return $q.when(data);
        }

        function questionTest_get(id) {
            var data = getById('questionTest', id);
            return $q.when(data);
        }

        function questionTest_update(item) {
            var data = updateObj('questionTest', item);
            return $q.when(data);
        }


        function questionTest_changeSequence(orderList) {
            var objName = 'questionTest';
            if (typeof (orderList) == 'undefined') { orderList = []; }

            var obj = {
                orderList: orderList
            }

            var url = urlAPI + '/' + objName + '/ChangeSequence';
            return $http.put(url, obj)
              .then(function (response) {
                  return response.data;
              })
              .catch(function (message) {
                  console.log('XHR Failed ChangeSequence for %s: %s', objName, message);
                  return message.status;
              });

        }

        function questionTest_delete(id) {
            var data = deleteObj('questionTest', id);
            return $q.when(data);
        }

        function questionTest_add(item) {
            var data = addObj('questionTest', item);
            return $q.when(data);
        }

        function questionTest_importList(testId, questionsList) {
            var objName = 'questionTest';
            var method = 'ImportList';

            if (typeof (testId) == 'undefined') { testId = 0; }
            if (typeof (questionsList) == 'undefined') { questionsList = []; }

            var url = urlAPI + '/' + objName + '/' + method;

            var obj = {
                testId: testId,
                questionsList: questionsList
            }

            return $http.put(url, obj)
              .then(function (response) {
                  return response.data;
              })
              .catch(function (message) {
                  console.log('XHR Failed ImportList for %s: %s', objName, message);
                  return message.status;
              });
        }

        function questionTest_addByParams(testId, questionId) {
            var item = {};
            item.testId = testId;
            item.questionId = questionId;
            var data = addObj('questionTest', item);
            return $q.when(data);
        }

        function question_load(item, ext) {
            var objName = 'importaTest';
            var method = 'LoadFromExcelQuestion';
            if (ext == ".txt") {
                method = 'LoadFromTxtQuestion';
            }

            var url = urlAPI + '/' + objName + '/' + method;

            console.info('url', url);

            return $http.post(url, item)
              .then(function (response) {
                  return response.data;
              })
              .catch(function (message) {
                  console.log('XHR Failed question_upload for %s: %s', objName, message);
                  return message.status;
              });
        }

        function question_deleteFromTest(questionId, testId) {
            var objName = 'question';
            var method = 'DeleteFromTest';

            if (typeof (questionId) == 'undefined') { questionId = 0; }
            if (typeof (testId) == 'undefined') { testId = 0; }

            var url = urlAPI + '/' + objName + '/' + method + '?questionId=' + questionId + '&testId=' + testId;

            return $http.delete(url)
                .then(function (response) {
                    return response.status;
                })
                .catch(function (message) {
                    console.log('XHR Failed question_deleteFromTest for %s: %s', objName, message);
                    return message.status;
                });
        }        

        function questionTestCompBase_update(item) {//questionTestCompBase_update
            var data = updateObj('questionTestCompetenzeBase', item);
            return $q.when(data);
        }

        function questionTestCompBase_updateAll(compBaseId, testId, value) {
            var objName = 'questionTestCompetenzeBase';
            var method = 'UpdateAll';
            if (typeof (compBaseId) == 'undefined') { compBaseId = 0; }
            if (typeof (testId) == 'undefined') { testId = 0; }
            if (typeof (value) == 'undefined') { value = 0; }
            var url = urlAPI + '/' + objName + '/' + method;

            var obj = {
                compBaseId: compBaseId,
                testId: testId,
                value: value
            }

            return $http.put(url, obj)
              .then(function (response) {
                  return response.data;
              })
              .catch(function (message) {
                  console.log('XHR Failed UpdateAll for %s: %s', objName, message);
                  return message.status;
              });
        }

        //-- PERFORMANCE MATERIA
        function performanceMateria_getAll(anno, classeId, studenteId) {
            if (typeof (anno) == 'undefined') { anno = 0; }
            if (typeof (classeId) == 'undefined') { classeId = 0; }
            if (typeof (studenteId) == 'undefined') { studenteId = 0; }

            var params = [];
            params.push({ name: 'anno', value: anno });
            params.push({ name: 'classeId', value: classeId });
            params.push({ name: 'studenteId', value: studenteId });

            var data = getAllByParams('session', 'GetPerformanceMateria', params);
            return $q.when(data);
        }

        //-- SESSION
        function asl_session_getAll(pageSize, page, ricerca, stato, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }
            if (typeof (stato) == 'undefined') { stato = 0; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'ricerca', value: ricerca });
            params.push({ name: 'stato', value: stato });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('session', 'ASL_GetAllByFilter', params);
            return $q.when(data);
        }

        function asl_session_countAll(ricerca, stato) {
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }
            if (typeof (stato) == 'undefined') { stato = 0; }

            var params = [];
            params.push({ name: 'ricerca', value: ricerca });
            params.push({ name: 'stato', value: stato });            

            var data = getAllByParams('session', 'ASL_CountByFilter', params);
            return $q.when(data);
        }

        function session_getAllList() {
            var data = getAllList('session');
            return $q.when(data);
        }

        function session_count() {
            var data = getAllByParams('session', 'Count');
            return $q.when(data);
        }

        function session_countByFilter(anno, bStato, testId, classeId) {
            if (typeof (anno) == 'undefined') { anno = -1; }
            if (typeof (bStato) == 'undefined') { bStato = 0; }
            if (typeof (testId) == 'undefined') { testId = 0; }
            if (typeof (classeId) == 'undefined') { classeId = 0; }

            var params = [];
            params.push({ name: 'anno', value: anno });
            params.push({ name: 'bStato', value: bStato });
            params.push({ name: 'testId', value: testId });
            params.push({ name: 'classeId', value: classeId });

            var data = getAllByParams('session', 'CountByFilter', params);
            return $q.when(data);
        }

        function session_getAll() {
            var data = getAllNoParam('session', 'getAll');
            return $q.when(data);
        }

        function session_getAllByFilter(pageSize, page, anno, bStato, testId, classeId, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (anno) == 'undefined') { anno = -1; }
            if (typeof (bStato) == 'undefined') { bStato = 0; }
            if (typeof (testId) == 'undefined') { testId = 0; }
            if (typeof (classeId) == 'undefined') { classeId = ''; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'anno', value: anno });
            params.push({ name: 'bStato', value: bStato });
            params.push({ name: 'testId', value: testId });
            params.push({ name: 'classeId', value: classeId });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('session', 'GetAllByFilter', params);
            return $q.when(data);
        }

        function session_countByProc(anno, bStato, testId, classeId) {
            if (typeof (anno) == 'undefined') { anno = -1; }
            if (typeof (bStato) == 'undefined') { bStato = 0; }
            if (typeof (testId) == 'undefined') { testId = 0; }
            if (typeof (classeId) == 'undefined') { classeId = 0; }

            var params = [];
            params.push({ name: 'anno', value: anno });
            params.push({ name: 'bStato', value: bStato });
            params.push({ name: 'testId', value: testId });
            params.push({ name: 'classeId', value: classeId });

            var data = getAllByParams('session', 'CountByProc', params);
            return $q.when(data);
        }

        function session_getAllByProc(pageSize, page, anno, bStato, testId, classeId, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (anno) == 'undefined') { anno = -1; }
            if (typeof (bStato) == 'undefined') { bStato = 0; }
            if (typeof (testId) == 'undefined') { testId = 0; }
            if (typeof (classeId) == 'undefined') { classeId = ''; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'anno', value: anno });
            params.push({ name: 'bStato', value: bStato });
            params.push({ name: 'testId', value: testId });
            params.push({ name: 'classeId', value: classeId });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('session', 'GetAllByProc', params);
            return $q.when(data);
        }

        function session_get(id) {
            var data = getById('session', id);
            return $q.when(data);
        }

        function session_add(item) {
            var data = addObj('session', item);
            return $q.when(data);
        }

        function session_update(item) {
            var data = updateObj('session', item);
            return $q.when(data);
        }

        function session_delete(id) {
            console.log("delete session(%s)", id);

            var data = deleteObj('session', id);
            return $q.when(data);
        }

        function session_activate(sessionId) {
            var objName = 'Session';
            var actionName = 'Activate';
            if (typeof (sessionId) == 'undefined') { sessionId = 0; }

            var url = urlAPI + '/' + objName + '/' + actionName + '?sessionId=' + sessionId;
            return $http.put(url)
                .then(function (response) {
                    return response.data;
                })
              .catch(function (message) {
                  console.log('XHR Failed session_activate for %s: %s', objName, message);
                  return message.status;
              });
        }
        //attivazione come app
        function session_enable(item) {
            var objName = 'Session';
            var actionName = 'Enable';
            if (typeof (item) == 'undefined') { item = {}; }

            var url = urlAPI + '/' + objName + '/' + actionName;
            return $http.put(url, item)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed session_Enable for %s: %s', objName, message);
                    return message.status;
                });
        }

        function session_createCode(id) {
            if (typeof (id) == 'undefined') { id = 0; }

            return $http.put(urlAPI + '/Session/CreateCode/' + id)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed session_CreateCode: %s', message);
                    return message.status;
              });
        }

        function session_aggiornaVotiDidattica(sessionId) {
            return $http.put(urlAPI + '/Session/AggiornaVotiDidattica?sessionId=' + sessionId)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed session_aggiornaVotiDidattica: %s', message);
                    return message.status;
                });
        }

        function session_calcolaStatistiche(sessionId) {
            return $http.put(urlAPI + '/Session/CalcolaStatistiche?sessionId=' + sessionId)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed session_calcolaStatistiche: %s', message);
                    return message.status;
                });
        }

        function studenteSession_unlock(studenteSessionId) {
            var objName = 'StudenteSession';
            var actionName = 'Unlock';
            if (typeof (studenteSessionId) == 'undefined') { studenteSessionId = 0; }
            //SharedState.turnOn('pageLoading');
            var url = urlAPI + '/' + objName + '/' + actionName + '?studenteSessionId=' + studenteSessionId;
            return $http.post(url).then(function (response) {
                //SharedState.turnOff('pageLoading');
                return response.data;
            })
                .catch(function (message) {
                    console.log('XHR Failed studenteSession_unlock for %s: %s', objName, message);
                    return message.status;
                });
        }

        function studenteSession_disableStudent(studenteSessionId) {
            var objName = 'StudenteSession';
            var actionName = 'DisableStudent';
            if (typeof (studenteSessionId) == 'undefined') { studenteSessionId = 0; }
            //SharedState.turnOn('pageLoading');
            var url = urlAPI + '/' + objName + '/' + actionName + '?studenteSessionId=' + studenteSessionId;
            return $http.post(url).then(function (response) {
                //SharedState.turnOff('pageLoading');
                return response.data;
            })
                .catch(function (message) {
                    console.log('XHR Failed studenteSession_disableStudent for %s: %s', objName, message);
                    return message.status;
                });
        }

        function studenteSession_getBySessionId(sessionId) {
            return $http.get(urlAPI + '/studenteSession/GetBySessionId/' + sessionId)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (response) {
                    console.log('XHR Failed studenteSession_getBySessionId for %s: %s', 'studenteSession', response);
                    return response.status;
                });
        }

        function session_disable(id) {
            var objName = 'Session';
            return $http.put(urlAPI + '/session/disable/' + id)
                .then(function (response) {
                    return response.data;
                })
              .catch(function (message) {
                  console.log('XHR Failed session_disable for %s: %s', objName, message);
                  return message.status;
              });
        }

        function session_complete(id) {
            return $http.put(urlAPI + '/session/complete/' + id)
                .then(function (response) {
                    return response.data;
                })
              .catch(function (message) {
                  console.log('XHR Failed session_complete for %s: %s', objName, message);
                  return message.status;
              });
        }

        function session_getSecondsRemaining(id) {
            return $http.get(urlAPI + '/session/GetSecondsRemaining/' + id)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed session_getSecondsRemaining for %s: %s', objName, message);
                    return message.status;
                });
        }

        //Questo metodo � identico a studenteSession_getAll
        //l'unica differenza � che non visualizza il loader
        function session_monitor(sessionId) {
            return $http.get(urlAPI + '/studenteSession/getAll/' + sessionId)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    console.log('XHR Failed session_monitor for %s: %s', objName, message);
                    return message.status;
                });
        }       

        //fine attivazione

        // esecuzione come da app
        function studenteSession_disable(studenteSessionId) {
            var objName = 'StudenteSession';
            var actionName = 'Disable';
            if (typeof (studenteSessionId) == 'undefined') { studenteSessionId = 0; }
            //SharedState.turnOn('pageLoading');
            var url = urlAPI + '/' + objName + '/' + actionName + '?studenteSessionId=' + studenteSessionId;
            return $http.post(url).then(function (response) {
                //SharedState.turnOff('pageLoading');
                return response.data;
            })
                .catch(function (response) {
                    console.log('XHR Failed studenteSession_disable for %s: %s', objName, response);
                    return response.status;
                });
        }

        function studenteSession_start(sessionId, code) {
            return $http.get(urlAPI + '/studenteSession/Start?sessionId=' + sessionId + '&code=' + code)
                    .then(function (response) {
                        return response.data;
                    })
                    .catch(function (response) {
                        console.log('XHR Failed studenteSession_start for %s: %s', 'studenteSession', response);
                        return response.data.Code;
                    });
        }

        function questionStudenteSession_update(item) {
            var data = updateObj('questionStudenteSession', item);
            return $q.when(data);
        }


        function session_inactivate(sessionId) {
            var objName = 'Session';
            var actionName = 'Inactive';
            if (typeof (sessionId) == 'undefined') { sessionId = 0; }

            var url = urlAPI + '/' + objName + '/' + actionName + '?sessionId=' + sessionId;
            return $http.put(url)
                .then(function (response) {
                    return response.data;
                })
              .catch(function (message) {
                  console.log('XHR Failed session_inactivate for %s: %s', objName, message);
                  return message.status;
              });
        }

        function session_getAllHistory() {
            var data = getAllNoParam('session', 'GetAllHistory');
            return $q.when(data);
        }

        function session_getAllActive() {
            var data = getAllNoParam('session', 'GetAllActive');
            return $q.when(data);
        }

        function session_countAllHistoryByProc(anno, ricerca) {
            if (typeof (anno) == 'undefined') { anno = -1; }
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }

            var params = [];
            params.push({ name: 'anno', value: anno });
            params.push({ name: 'ricerca', value: ricerca });

            var data = getAllByParams('session', 'CountAllHistoryByProc', params);
            return $q.when(data);
        }

        function session_getAllHistoryByProc(pageSize, page, anno, ricerca, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (anno) == 'undefined') { anno = -1; }
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'anno', value: anno });
            params.push({ name: 'ricerca', value: ricerca });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('session', 'GetAllHistoryByProc', params);
            return $q.when(data);
        }

        function session_countAllActiveByProc(anno, ricerca) {
            if (typeof (anno) == 'undefined') { anno = -1; }
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }

            var params = [];
            params.push({ name: 'anno', value: anno });
            params.push({ name: 'ricerca', value: ricerca });

            var data = getAllByParams('session', 'CountAllActiveByProc', params);
            return $q.when(data);
        }

        function session_getAllActiveByProc(pageSize, page, anno, ricerca, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (anno) == 'undefined') { anno = -1; }
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'anno', value: anno });
            params.push({ name: 'ricerca', value: ricerca });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('session', 'GetAllActiveByProc', params);
            return $q.when(data);
        }

        //REPORTSTUDENTESESSION
        function reportStudenteSession_getAllByStudenteId(pageSize, page, studenteId, ricerca, anno, presenti, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (studenteId) == 'undefined') { studenteId = 0; }
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }
            if (typeof (anno) == 'undefined') { anno = -1; }
            if (typeof (presenti) == 'undefined') { presenti = 0; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'studenteId', value: studenteId });
            params.push({ name: 'ricerca', value: ricerca });
            params.push({ name: 'anno', value: anno });
            params.push({ name: 'presenti', value: presenti });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('reportStudenteSession', 'GetAllByStudenteId', params);
            return $q.when(data);
        }

        function reportStudenteSession_countAllByStudenteId(studenteId, ricerca, anno, presenti) {
            if (typeof (studenteId) == 'undefined') { studenteId = 0; }
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }
            if (typeof (anno) == 'undefined') { anno = -1; }
            if (typeof (presenti) == 'undefined') { presenti = 0; }

            var params = [];
            params.push({ name: 'studenteId', value: studenteId });
            params.push({ name: 'ricerca', value: ricerca });
            params.push({ name: 'anno', value: anno });
            params.push({ name: 'presenti', value: presenti });

            var data = getAllByParams('reportStudenteSession', 'CountAllByStudenteId', params);
            return $q.when(data);
        }

        //REPORTSTUDENTESCHEDACOMPETENZE
        function reportStudenteSchedaCompetenze_getAllByStudenteId(pageSize, page, studenteId, ricerca, /*anno, presenti,*/ order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (studenteId) == 'undefined') { studenteId = 0; }
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }
            //if (typeof (anno) == 'undefined') { anno = -1; }
            //if (typeof (presenti) == 'undefined') { presenti = 0; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'studenteId', value: studenteId });
            params.push({ name: 'ricerca', value: ricerca });
            //params.push({ name: 'anno', value: anno });
            //params.push({ name: 'presenti', value: presenti });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('reportStudenteSchedaCompetenze', 'GetAllByStudenteId', params);
            return $q.when(data);
        }

        function reportStudenteSchedaCompetenze_countAllByStudenteId(studenteId, ricerca/*, anno, presenti*/) {
            if (typeof (studenteId) == 'undefined') { studenteId = 0; }
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }
            //if (typeof (anno) == 'undefined') { anno = -1; }
            //if (typeof (presenti) == 'undefined') { presenti = 0; }

            var params = [];
            params.push({ name: 'studenteId', value: studenteId });
            params.push({ name: 'ricerca', value: ricerca });
            //params.push({ name: 'anno', value: anno });
            //params.push({ name: 'presenti', value: presenti });

            var data = getAllByParams('reportStudenteSchedaCompetenze', 'CountAllByStudenteId', params);
            return $q.when(data);
        }

        //REPORTCLASSESESSION
        function reportClasseSession_getAllByClasseId(pageSize, page, classeId, ricerca, docenteId, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (classeId) == 'undefined') { classeId = 0; }
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }
            if (typeof (docenteId) == 'undefined') { docenteId = 0; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'classeId', value: classeId });
            params.push({ name: 'ricerca', value: ricerca });
            params.push({ name: 'docenteId', value: docenteId });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('reportClasseSession', 'GetAllByClasseId', params);
            return $q.when(data);
        }

        function reportClasseSession_countAllByClasseId(classeId, ricerca, docenteId) {
            if (typeof (classeId) == 'undefined') { classeId = 0; }
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }
            if (typeof (docenteId) == 'undefined') { docenteId = 0; }

            var params = [];
            params.push({ name: 'classeId', value: classeId });
            params.push({ name: 'ricerca', value: ricerca });
            params.push({ name: 'docenteId', value: docenteId });

            var data = getAllByParams('reportClasseSession', 'CountAllByClasseId', params);
            return $q.when(data);
        }

        //-- SESSIONSTUDENTE
        function studenteSession_getAllList(sessionId) {
            var data = getAllByParam('studenteSession', 'GetAllList', 'sessionId', sessionId);
            return $q.when(data);
        }       

        function studenteSession_addList(sessionId, studentiList) {
            var objName = 'studenteSession';
            var method = 'AddList';

            if (typeof (sessionId) == 'undefined') { sessionId = 0; }
            if (typeof (studentiList) == 'undefined') { studentiList = []; }

            var url = urlAPI + '/' + objName + '/' + method;

            var obj = {
                sessionId: sessionId,
                studentiList: studentiList
            }

            return $http.put(url, obj)
              .then(function (response) {
                  return response.data;
              })
              .catch(function (message) {
                  console.log('XHR Failed AddList for %s: %s', objName, message);
                  return message.status;
              });
        }

        function studenteSession_count() {
            var data = getAllByParams('studenteSession', 'Count');
            return $q.when(data);
        }

        function studenteSession_countByFilter(sessionId) {
            if (typeof (sessionId) == 'undefined') { sessionId = 0; }

            var params = [];
            params.push({ name: 'sessionId', value: sessionId });

            var data = getAllByParams('studenteSession', 'CountByFilter', params);
            return $q.when(data);
        }

        function studenteSession_getAll() {
            var data = getAllNoParam('studenteSession', 'getAll');
            return $q.when(data);
        }

        function studenteSession_getAllByFilter(pageSize, page, sessionId, nominativo, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (sessionId) == 'undefined') { sessionId = 0; }
            if (typeof (nominativo) == 'undefined') { nominativo = ''; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'sessionId', value: sessionId });
            params.push({ name: 'nominativo', value: nominativo });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('studenteSession', 'GetAllByFilter', params);
            return $q.when(data);
        }

        function studenteSession_getAllByProc(pageSize, page, sessionId, ricerca, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (sessionId) == 'undefined') { sessionId = 0; }
            if (typeof (ricerca) == 'undefined') { ricerca = ''; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'sessionId', value: sessionId });
            params.push({ name: 'ricerca', value: ricerca });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('studenteSession', 'GetAllByProc', params);
            return $q.when(data);
        }

        function studenteSession_get(id) {
            var data = getById('studenteSession', id);
            return $q.when(data);
        }

        function studenteSession_update(item) {
            var data = updateObj('studenteSession', item);
            return $q.when(data);
        }

        function studenteSession_delete(id) {
            var data = deleteObj('studenteSession', id);
            return $q.when(data);
        }

        function studenteSession_updatePdp(studenteSessionId) {
            var objName = 'studenteSession';
            var actionName = 'UpdatePdp';
            if (typeof (studenteSessionId) == 'undefined') { studenteSessionId = 0; }

            var url = urlAPI + '/' + objName + '/' + actionName + '?studenteSessionId=' + studenteSessionId;
            return $http.put(url)
                .then(function (response) {
                    return response.data;
                })
              .catch(function (message) {
                  console.log('XHR Failed session_activate for %s: %s', objName, message);
                  return message.status;
              });
        }

        
        

        //COMMUNITY
        function community_getAllRichieste(stato) {
            if (typeof (stato) == 'undefined') { stato = -1; }

            var params = [];
            params.push({ name: 'stato', value: stato });

            var data = getAllByParams('RisorsaAmicizia', 'GetAll', params);
            return $q.when(data);
        }

        function community_getAllRichiesteRifiutate() {
            var data = getAllNoParam('RisorsaAmicizia', 'GetAllRifiutate');
            return $q.when(data);
        }

        function community_ricercaDocenti(filter) {
            if (typeof (filter) == 'undefined') { filter = ''; }            

            var params = [];
            params.push({ name: 'filter', value: filter });            

            var data = getAllByParams('RisorsaAmicizia', 'RicercaDocenti', params);
            return $q.when(data);
        }

        function community_getAllAmici() {            
            var data = getAllNoParam('RisorsaAmicizia', 'GetAllAmici');
            return $q.when(data);
        }

        function community_getAmicizia(altroDocenteId) {
            return $http.get(urlAPI + '/RisorsaAmicizia/Get?altroDocenteId=' + altroDocenteId)
                       .then(function (response) {
                           return response.data;
                       })
                       .catch(function (message) {
                           console.log('XHR Failed community_getAmicizia for community_getAmicizia: %s', message);
                           return message.status;
                       });
        }            

        function community_addAmicizia(docenteId) {
            return $http.post(urlAPI + '/RisorsaAmicizia/Post?destId=' + docenteId)
                        .then(function (response) {
                            return response.data;
                        })
                        .catch(function (message) {
                            console.log('XHR Failed addObj for community_addAmicizia: %s', message);
                            return message.status;
                        });
        }

        function community_deleteAmicizia(id) {
            var data = deleteObj('RisorsaAmicizia', id);
            return $q.when(data);
        }

        function community_accettaAmicizia(id) {
            return $http.put(urlAPI + '/RisorsaAmicizia/Accept?id=' + id)
                        .then(function (response) {
                            return response.data;
                        })
                        .catch(function (message) {
                            console.log('XHR Failed addObj for community_accettaAmicizia: %s', message);
                            return message.status;
                        });
        }

        function community_rifiutaAmicizia(id) {
            return $http.put(urlAPI + '/RisorsaAmicizia/Reject?id=' + id)
                        .then(function (response) {
                            return response.data;
                        })
                        .catch(function (message) {
                            console.log('XHR Failed addObj for community_rifiutaAmicizia: %s', message);
                            return message.status;
                        });
        }

        function community_attiva() {
            return $http.put(urlAPI + '/RisorsaAmicizia/AttivaCommunity')
                       .then(function (response) {
                           return response.data;
                       })
                       .catch(function (message) {
                           console.log('XHR Failed addObj for community_attiva: %s', message);
                           return message.status;
                       });
        }

        function community_annulla() {
            return $http.put(urlAPI + '/RisorsaAmicizia/AnnullaCommunity')
                       .then(function (response) {
                           return response.data;
                       })
                       .catch(function (message) {
                           console.log('XHR Failed addObj for community_annulla: %s', message);
                           return message.status;
                       });
        }

        function community_getProfilo() {
            var data = getAllNoParam('RisorsaAmicizia', 'GetProfilo');
            return $q.when(data);
        }

        //DASHBOARD
        function dashboard_get(anno) {
            if (typeof (anno) == 'undefined' || anno == '') { anno = -1; }

            var params = [];
            params.push({ name: 'anno', value: anno });

            var data = getAllByParams('dashboard', 'Get', params);
            return $q.when(data);
        }

        function dashboard_getDocente(anno) {
            if (typeof (anno) == 'undefined' || anno == '') { anno = -1; }

            var params = [];
            params.push({ name: 'anno', value: anno });
            var data = getAllByParams('dashboard', 'getDocente', params);
            return $q.when(data);
        }

        function dashboard_getStudente(anno) {
            if (typeof (anno) == 'undefined' || anno == '') { anno = -1; }

            var params = [];
            params.push({ name: 'anno', value: anno });
            var data = getAllByParams('dashboard', 'getStudente', params);
            return $q.when(data);
        }

        function dashboard_getAllStudenteSession(anno, classeId, studenteId, materiaId) {
            if (!anno || typeof (anno) == 'undefined') { anno = -1; }
            if (!classeId || typeof (classeId) == 'undefined') { classeId = 0; }
            if (!studenteId || typeof (studenteId) == 'undefined') { studenteId = 0; }
            if (!materiaId || typeof (materiaId) == 'undefined') { materiaId = 0; }

            var params = [];
            params.push({ name: 'anno', value: anno });
            params.push({ name: 'classeId', value: classeId });
            params.push({ name: 'studenteId', value: studenteId });
            params.push({ name: 'materiaId', value: materiaId });

            var data = getAllByParams('dashboard', 'getAllStudenteSession', params);
            return $q.when(data);
        }

        function dashboard_getStudenteAllSessions(anno, classeId, studenteId, materiaId) {
            if (!anno || typeof (anno) == 'undefined') { anno = -1; }
            if (!classeId || typeof (classeId) == 'undefined') { classeId = 0; }
            if (!studenteId || typeof (studenteId) == 'undefined') { studenteId = 0; }
            if (!materiaId || typeof (materiaId) == 'undefined') { materiaId = 0; }

            var params = [];
            params.push({ name: 'anno', value: anno });
            params.push({ name: 'classeId', value: classeId });
            params.push({ name: 'studenteId', value: studenteId });
            params.push({ name: 'materiaId', value: materiaId });

            var data = getAllByParams('dashboard', 'getStudenteAllSessions', params);
            return $q.when(data);
        }

        function dashboard_getStudenteAllDocenteSessions(anno, classeId, studenteId, materiaId) {
            if (!anno || typeof (anno) == 'undefined') { anno = -1; }
            if (!classeId || typeof (classeId) == 'undefined') { classeId = 0; }
            if (!studenteId || typeof (studenteId) == 'undefined') { studenteId = 0; }
            if (!materiaId || typeof (materiaId) == 'undefined') { materiaId = 0; }

            var params = [];
            params.push({ name: 'anno', value: anno });
            params.push({ name: 'classeId', value: classeId });
            params.push({ name: 'studenteId', value: studenteId });
            params.push({ name: 'materiaId', value: materiaId });

            var data = getAllByParams('dashboard', 'getStudenteAllDocenteSessions', params);
            return $q.when(data);
        }        

        function dashboard_getStakeholder(anno) {
            if (typeof (anno) == 'undefined' || anno == '') { anno = -1; }

            var params = [];
            params.push({ name: 'anno', value: anno });
            var data = getAllByParams('dashboard', 'getStakeholder', params);
            return $q.when(data);
        }

        function dashboard_getCommerciale(anno) {
            if (typeof (anno) == 'undefined' || anno == '') { anno = -1; }

            var params = [];
            params.push({ name: 'anno', value: anno });

            var data = getAllByParams('dashboard', 'getCommerciale', params);
            return $q.when(data);
        }

        function dashboard_getAdmin() {
            var data = getAllNoParam('dashboard', 'getAdmin');
            return $q.when(data);
        }        

        function dashboard_getAllStakeholderVendite(pageSize, page, titolo, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }
            if (typeof (titolo) == 'undefined') { titolo = ''; }
            if (typeof (order) == 'undefined') { order = ''; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'titolo', value: titolo });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('dashboard', 'getAllStakeholderVendite', params);
            return $q.when(data);
        }

        //VALUTAZIONE DOC
        function valutazioneDoc_getAll() {
            var data = getAllNoParam('valutazioneDoc', 'getAll');
            return $q.when(data);
        }

        function valutazioneDoc_update(item) {
            var data = updateObj('valutazioneDoc', item);
            return $q.when(data);
        }

        function valutazioneDoc_getByVoto(voto) {
            return $http.get(urlAPI + '/ValutazioneDoc/GetByVoto?voto=' + voto)
                       .then(function (response) {
                           return response.data;
                       })
                       .catch(function (message) {
                           console.log('XHR Failed getObj for valutazioneDoc_getByVoto: %s', message);
                           return message.status;
                       });
        }

        function valutazioneDoc_getByLettera(lettera) {
            return $http.get(urlAPI + '/ValutazioneDoc/GetByLettera?lettera=' + lettera)
                       .then(function (response) {
                           return response.data;
                       })
                       .catch(function (message) {
                           console.log('XHR Failed getObj for valutazioneDoc_getByLettera: %s', message);
                           return message.status;
                       });
        }

        //SYSTEM
        function getWhoAmI() {
            return $http.get(urlAPI + '/system/whoami')
                          .then(getWhoAmIComplete)
                          .catch(function (message) {
                              console.log('XHR Failed for whoami: %s', message);
                          });

            function getWhoAmIComplete(response) {
                return response.data;
            }
        }

        function getYearsList() {
            var listAnno = [];
            for (var i = 0; i <= 19; i++) {
                var item = {};
                item.value = 2017 - i;
                item.text = (2017 - i).toString();
                listAnno.push(item);
            }

            return _.sortBy(listAnno, function (o) { return o.value; });
        }

        function logGetAll() {
            var data = getAllNoParam('System', 'Log_GetAll');
            return $q.when(data);
        }

        function logDelete(id) {
            var objName = 'System';
            return $http.delete(urlAPI + '/' + objName + '/Log_Delete/' + id)
                        .then(function (response) {
                            return response.status;
                        })
                        .catch(function (message) {
                            console.log('XHR Failed logDelete for %s: %s', objName, message);
                            return message.status;
                        });            
        }

        function pushGetAll() {
            var data = getAllNoParam('System', 'Push_GetAll');
            return $q.when(data);
        }

        function pushDelete(id) {
            var objName = 'System';
            return $http.delete(urlAPI + '/' + objName + '/Push_Delete/' + id)
                        .then(function (response) {
                            return response.status;
                        })
                        .catch(function (message) {
                            console.log('XHR Failed pushDelete for %s: %s', objName, message);
                            return message.status;
                        });
        }

        function updateSettings(iWelcome, iTest, iUpdate) {
            var objName = 'system';
            var method = 'updateSettings';

            if (typeof (iWelcome) == 'undefined') { iWelcome = -1; }
            if (typeof (iTest) == 'undefined') { iTest = -1; }
            if (typeof (iUpdate) == 'undefined') { iUpdate = -1; }

            return $http.put(urlAPI + '/' + objName + '/' + method + '?Welcome=' + iWelcome + '&Test=' + iTest + '&Update=' + iUpdate)
                        .then(function (response) {
                            return response.data;
                        })
                        .catch(function (message) {
                            console.log('XHR Failed user_updateSettings');
                            return message.status;
                        });
        }

        //Verifica voucher Carta Docente
        function cartaDocente_check(codiceVoucher) {
            if (typeof (codiceVoucher) == 'undefined') { codiceVoucher = ''; }

            return $http.get(urlAPI + '/CartaDocente/check?codiceVoucher=' + codiceVoucher)
                        .then(function (response) {                            
                            return JSON.parse(response.data)[0];
                        })
                        .catch(function (response) {                            
                            console.log('XHR for cartaDocente_check: %s', response);
                            return response.data;
                        });
        }

        function cartaDocente_confirmLicenza(codiceVoucher, cfBeneficiario) {
            if (typeof (codiceVoucher) == 'undefined') { codiceVoucher = ''; }            
            if (typeof (cfBeneficiario) == 'undefined') { cfBeneficiario = ''; }

            return $http.get(urlAPI + '/CartaDocente/confirmLicenza?codiceVoucher=' + codiceVoucher + '&cfBeneficiario=' + cfBeneficiario)
                        .then(function (response) {                            
                            return JSON.parse(response.data)[0];
                            //return response.data[0];
                        })
                        .catch(function (response) {
                            console.log('XHR for cartaDocente_confirmLicenza: %s', response);
                            return response.data;
                        });
        }

        //FATTURA PA
        function fatturaPa_getAllByFilter(pageSize, page, numero, order) {
            if (typeof (pageSize) == 'undefined') { pageSize = _pageSize; }
            if (typeof (page) == 'undefined') { page = 1; }            
            if (typeof (numero) == 'undefined') { numero = ""; }
            if (typeof (order) == 'undefined') { order = ""; }

            var params = [];
            params.push({ name: 'pageSize', value: pageSize });
            params.push({ name: 'page', value: page });
            params.push({ name: 'numero', value: numero });
            params.push({ name: 'order', value: order });

            var data = getAllByParams('fatturaPa', 'GetAllByFilter', params);
            return $q.when(data);
        }

        function fatturaPa_countByFilter(numero) {
            if (typeof (numero) == 'undefined') { numero = ""; }

            var params = [];
            params.push({ name: 'numero', value: numero });

            var data = getAllByParams('fatturaPa', 'CountByFilter', params);
            return $q.when(data);
        }

        function fatturaPa_get(id) {
            var data = getById('fatturaPa', id);
            return $q.when(data);
        }

        function fatturaPa_add(item) {
            var data = addObj('fatturaPa', item);
            return $q.when(data);
        }

        function fatturaPa_update(item) {
            var data = updateObj('fatturaPa', item);
            return $q.when(data);
        }

        function fatturaPa_delete(id) {
            var data = deleteObj('fatturaPa', id);
            return $q.when(data);
        }

        function fatturaPa_getBuoni(id) {
            if (typeof (id) == 'undefined') { id = 0; }

            var params = [];
            params.push({ name: 'id', value: id });

            var data = getAllByParams('fatturaPa', 'GetBuoni', params);
            return $q.when(data);
        }

        function fatturaPa_getBuoniDaFatturare() {
            var data = getAllNoParam('fatturaPa', 'GetBuoniDaFatturare');
            return $q.when(data);
        }
    }
})();